/* eslint-disable object-curly-newline */
import { defineAsyncComponent } from 'vue';
import { store } from '@common/store/store';
import { sDs } from '@common/sDs/sDs';
import { uStore } from "@common/userStore";
import { configStore } from "@common/configStore";
import { recordStore } from "@common/recordStore";
import { ngAdapterStore } from "@common/ngAdapterStore";
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import { ddStore } from "@common/ddStore";
import moment from "moment";

const controlComponent = defineAsyncComponent(() => import('@common/control/control.vue'));
// const windowPortal = defineAsyncComponent(() => import('@common/windowPortal.vue'));

const recordSourceControl = {
    text: 'Record Source',
    type: 'dropdown',
    value: 'recordSource',
    items: [
        { text: 'Source', value: 'source' },
        { text: 'Sub Source', value: 'subSource' },
        { text: 'Matching Record', value: 'matchingRecord' },
        { text: 'Context Volunteer', value: 'contextVolId' },
        { text: 'Context Organization', value: 'contextOrgId' },
        { text: 'Context Opportunity', value: 'contextOppId' },
        { text: 'Context Schedule Shift', value: 'contextSchId' },
        { text: 'Context Logbook Entry', value: 'contextLbeId' },
        { text: 'Context Activity', value: 'contextAeId' },
        { text: 'Context Affiliation', value: 'contextAffId' },
        { text: 'Context Dialog', value: 'contextDialogId' },
        { text: 'Selectable', value: 'selectable' },
        { text: 'Fixed', value: 'fixed' },
        { text: 'Store Property', value: 'storeProp' },
        { text: 'None', value: 'none' },
    ],
    fields: {
        text: 'text',
        value: 'value'
    },
    helpText: 'Choose "source" to use the record from the source component where the action is used.  Choose "fixed" to provide an ID for a specific record.  Choose "selectable" to ',
    logic: [
        {
            criteriaRecord: 'self',
            record: 'component',
            prop: 'component.controlConfigs.param___index___recordId.display',
            valueType: 'criteria',
            criteria: 'this.value === "fixed"'
        }
    ],
    default: 'selectable'
};
const createRecordSourceControl = (paramField, sourceOptions, matchingFields, title, matchingRecordFields, defaultValue) => {
    let sourceControl = library.cloneObj(recordSourceControl);
    if (title) sourceControl.text = title;
    sourceControl.value += '_' + paramField; //  recordSource_volId or recordSource_recordId
    let updatedProp = sourceControl.logic[0].prop.replace('recordId', paramField);
    sourceControl.logic[0].prop = updatedProp;
    if (sourceOptions) {
        sourceControl.items = sourceControl.items.filter((item) => sourceOptions.indexOf(item.value) !== -1);
        if (sourceOptions.indexOf('subSource') !== -1) {
            sourceControl.logic.push({
                criteriaRecord: 'self',
                record: 'component',
                prop: 'component.controlConfigs.param___index___subSourcePath.display',
                valueType: 'criteria',
                criteria: 'this.value === "subSource"'
            });
        }
        if (sourceOptions.indexOf('sourceWithField') !== -1) {
            sourceControl.logic.push({
                criteriaRecord: 'self',
                record: 'component',
                prop: 'component.controlConfigs.param___index___matchingSourceField.display',
                valueType: 'criteria',
                criteria: 'this.value === "sourceWithField"'
            });
        }
        if (sourceOptions.indexOf('storeProp') !== -1) {
            sourceControl.logic.push({
                criteriaRecord: 'self',
                record: 'component',
                prop: `component.controlConfigs.param___index___${paramField}_storeProp.display`,
                valueType: 'criteria',
                criteria: 'this.value === "storeProp"'
            });
        }
    }
    if (defaultValue) sourceControl.default = defaultValue;
    if (Array.isArray(matchingRecordFields)) {
        matchingRecordFields.forEach((field) => {
            field = 'param_' + field;
            sourceControl.logic.push({
                criteriaRecord: 'self',
                record: 'component',
                prop: 'component.controlConfigs.param___index___' + field + '.display',
                valueType: 'criteria',
                criteria: 'this.value === "matchingRecord"'
            });
        });
    }
    if (matchingFields) sourceControl.matchingFields = matchingFields;
    return sourceControl;
};
const recordTypeControl = {
    text: 'Record Type',
    value: 'psp',
    type: 'dropdown',
    items: [
        { text: 'Volunteer', value: 'vol' },
        { text: 'Opportunity', value: 'opp' },
        { text: 'Organization', value: 'org' },
        { text: 'Shift', value: 'sch' } // TODO watch this
    ],
    fields: { text: 'text', value: 'value' },
    default: 'vol'
};

const recordIdControl = {
    text: 'Record ID',
    value: 'recordId',
    type: 'string',
    default: '',
    display: false
};

const actionStore = {
    namespaced: true,
    state: {
        actionOptions: [
            {
                text: 'Set Layout Property',
                value: 'layoutProperty',
                onlyRunsParallel: true,
                params: [
                    {
                        text: 'Property',
                        value: 'prop',
                        type: 'string',
                        default: ''
                    }, {
                        text: 'Value Type',
                        value: 'type',
                        type: 'dropdown',
                        items: [
                            { text: 'Value From Control', value: 'controlValue' },
                            { text: 'String', value: 'string' },
                            { text: 'Boolean', value: 'boolean' },
                            { text: 'Toggle Boolean', value: 'toggleBoolean' },
                            { text: 'Number', value: 'number' },
                            { text: 'Offset Number', value: 'numberOffset' },
                        ],
                        fields: { text: 'text', value: 'value' },
                        default: 'string',
                        logic: [
                            {
                                criteriaRecord: 'self',
                                record: 'component',
                                prop: 'component.controlConfigs.param___index___val.type',
                                valueType: 'criteria',
                                criteria: 'this.value'
                            }, {
                                criteriaRecord: 'self',
                                record: 'component',
                                prop: 'component.controlConfigs.param___index___val.display',
                                valueType: 'criteria',
                                criteria: 'this.value !== "controlValue"'
                            }, {
                                criteriaRecord: 'self',
                                record: 'component',
                                prop: 'component.controlConfigs.param___index___toggleBooleanText.display',
                                valueType: 'criteria',
                                criteria: 'this.value === "toggleBoolean"'
                            }, {
                                criteriaRecord: 'self',
                                record: 'component',
                                prop: 'component.controlConfigs.param___index___offset.display',
                                valueType: 'criteria',
                                criteria: 'this.value === "numberOffset"'
                            }
                        ]
                    }, {
                        text: 'Value',
                        value: 'val',
                        type: 'string',
                        default: ''
                    }, {
                        text: 'Offset Value By',
                        value: 'offset',
                        type: 'number',
                        display: false,
                        default: 1,
                        helpText: 'This will offset the current value by the amount entered.'
                    }, {
                        text: 'Toggle Value',
                        value: 'toggleBooleanText',
                        type: 'info',
                        display: false,
                        default: 'This will toggle the value for this property.'
                    }
                ]
            },
            {
                text: 'Open Component Dialog',
                value: 'openComponentDialog',
                availableForPsp: ['vol', 'ae'],
                params: [
                    {
                        text: 'Component ID',
                        value: 'componentId',
                        type: 'dropdown',
                        itemsSource: 'componentStore.getList(true)',
                        fields: { text: 'cId', value: 'cId' },
                        allowFiltering: true,
                        filterType: 'Contains',
                        default: [],
                        required: true
                    },
                    createRecordSourceControl(
                        'srcAffId',
                        ['source', 'contextAffId', 'fixed'],
                        ['AFFILIATION_ID', 'uiRecordId', 'ID'],
                        'Affiliation Record',
                    ),
                    {
                        text: 'Affiliation Id',
                        value: 'srcAffId',
                        type: 'string',
                        default: ''
                    },
                    {
                        text: 'Dialog Settings',
                        value: 'dialogSettings',
                        type: 'object',
                        properties: {
                            title: {
                                type: 'string',
                                label: 'Dialog Title',
                                helpText: 'Title of dialog.',
                                id: 'title',
                                default: 'Task'
                            },
                            size: {
                                type: 'string',
                                label: 'Size',
                                id: 'size'
                            },
                            cssClass: {
                                type: 'string',
                                label: 'CSS Class',
                                id: 'cssClass'
                            },
                            okButtonLabel: {
                                type: 'string',
                                label: 'Ok Button Label',
                                id: 'closeOnEscape',
                                default: 'Ok'
                            },
                            okButtonCssClass: {
                                type: 'string',
                                label: 'Ok Button CSS Class',
                                id: 'okButtonCssClass',
                            },
                            cancelButtonLabel: {
                                type: 'string',
                                label: 'Cancel Button Label',
                                id: 'cancelButtonLabel',
                                default: 'Cancel'
                            },
                            cancelButtonCssClass: {
                                type: 'string',
                                label: 'Cancel Button CSS Class',
                                id: 'cancelButtonCssClass',
                            },
                            closeOnEscape: {
                                type: 'boolean',
                                label: 'Allow Closing on Escape',
                                id: 'closeOnEscape',
                                default: true
                            }
                        },
                        default: {}
                    }
                ]
            },
            {
                text: 'View Profile',
                value: 'getProfileFields',
                availableForPsp: ['vol', 'ae'],
                params: [
                    library.cloneObj(recordSourceControl),
                    library.cloneObj(recordTypeControl),
                    library.cloneObj(recordIdControl),
                    {
                        text: 'Fields',
                        value: 'fields',
                        type: 'dropdowntree',
                        allowFiltering: true,
                        filterType: 'Contains',
                        fields: {
                            text: 'text',
                            value: 'value',
                            hasChildren: 'hasChild',
                            parentValue: 'pId',
                        },
                        showCheckBox: true,
                        itemsSource: 'configStore.allFieldOptions()',
                        default: []
                    },
                    {
                        text: 'Hidden Fields',
                        value: 'hiddenFields',
                        type: 'dropdowntree',
                        fields: {
                            text: 'text',
                            value: 'value',
                            hasChildren: 'hasChild',
                            parentValue: 'pId',
                        },
                        showCheckBox: true,
                        itemsSource: 'configStore.allFieldOptions()',
                        default: []
                    },
                ]
            },
            {
                text: 'Open Recruiter Form',
                value: 'openRecruiterForm',
                availableForPsp: ['vol', 'ae'],
                params: [
                    {
                        text: 'Form Name',
                        value: 'formName',
                        type: 'string',
                    }
                ]
            },
            {
                text: 'Save Control Panel',
                value: 'saveControlPanel',
                availableForPsp: ['vol', 'ae'],
                params: []
            },
            {
                text: 'Close Dialog',
                value: 'closeDialog',
                availableForPsp: ['vol', 'ae'],
                params: [
                    {
                        text: 'Dialog to Close',
                        value: 'dialogId',
                        type: 'dropdown',
                        items: [
                            {
                                text: 'Parent',
                                value: 'parent'
                            },
                            {
                                text: 'All',
                                value: 'all'
                            }
                        ],
                        fields: {
                            text: 'text',
                            value: 'value'
                        },
                        default: 'parent'
                    },
                    {
                        text: 'Close As',
                        value: 'closeAs',
                        type: 'dropdown',
                        items: [
                            {
                                text: 'Ok',
                                value: 'ok'
                            },
                            {
                                text: 'Cancel',
                                value: 'cancel'
                            }
                        ],
                        fields: {
                            text: 'text',
                            value: 'value'
                        },
                        default: 'ok'
                    }
                ]
            },
            {
                text: 'Update Profile Field',
                value: 'updateProfileField',
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                params: [
                    library.cloneObj(recordTypeControl),
                    library.cloneObj(recordSourceControl),
                    library.cloneObj(recordIdControl),
                    {
                        text: 'Field',
                        value: 'field',
                        type: 'dropdown',
                        allowFiltering: true,
                        filterType: 'Contains',
                        itemsSource: 'configStore.allFieldOptions(this.component.paramValues.psp)',
                        doNotMergeOptions: true,
                        fields: {
                            text: 'text',
                            value: 'value',
                            hasChildren: 'hasChild',
                            parentValue: 'pId',
                        },
                        logic: [
                            {
                                criteriaRecord: 'self',
                                record: 'component',
                                prop: 'component.controlConfigs.param___index___value.display',
                                valueType: 'criteria',
                                criteria: '!this.loadingOptions'
                            }
                        ],
                        default: []
                    },
                    {
                        text: 'Value',
                        value: 'value',
                        type: 'string',
                        configSource: 'this.component.paramValues.field',
                        showClearButton: false,
                        display: false,
                        additionalOptions: [
                            { text: '_empty_', value: '_empty_', absoluteOptionPosition: 0 },
                        ],
                    },
                    {
                        text: 'Disable Toast Confirmation',
                        value: 'disableToastConfirmation',
                        type: 'boolean',
                        default: false
                    }
                ]
            },
            {
                text: 'Update Profile Fields',
                value: 'updateProfileFields',
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                params: [
                    library.cloneObj(recordTypeControl),
                    library.cloneObj(recordSourceControl),
                    library.cloneObj(recordIdControl),
                    {
                        text: 'Fields',
                        value: 'fields',
                        label: 'Fields',
                        type: 'ARRAY',
                        default: [],
                        allowDragAndDrop: true,
                        itemConfig: {
                            itemType: 'object',
                            primaryKey: 'field',
                            keys: {
                                field: {
                                    label: 'Field',
                                    id: 'field',
                                    type: 'dropdown',
                                    allowFiltering: true,
                                    filterType: 'Contains',
                                    itemsSource: 'configStore.allFieldOptions(this.component.paramValues.psp)',
                                    helpText: '',
                                    itemsFilter: 'this.item.pId' // Removes Headers from field list
                                },
                                value: {
                                    text: 'Value',
                                    value: undefined,
                                    label: 'Value',
                                    type: 'string',
                                    configSource: 'this.component.paramValues.fields[__index__].field',
                                    additionalOptions: [
                                        { text: '_empty_', value: '_empty_', absoluteOptionPosition: 0 },
                                    ],
                                }
                            },
                            newItem: {
                                field: '',
                                value: ''
                            },
                            permissions: {
                                canMove: false,
                                canDelete: true,
                                allowAddItem: true
                            }
                        }
                    },
                    {
                        text: 'Disable Toast Confirmation',
                        value: 'disableToastConfirmation',
                        type: 'boolean',
                        default: false
                    }
                ]
            },
            {
                text: 'Run Background Check',
                value: 'runBackgroundCheck',
                availableForPsp: ['vol', 'ae'],
                params: [
                    {
                        text: 'package ID',
                        value: 'packageID',
                        type: 'dropdown',
                        itemsSource: 'configStore.bcPackageOptions()',
                        default: ''
                    },
                    createRecordSourceControl(
                        'recordId',
                        ['source', 'contextVolId', 'fixed'],
                        ['VOLUNTEER_ID', 'uiRecordId', 'ID'],
                        'Volunteer Record'
                    ),
                    {
                        text: 'vol ID',
                        value: 'recordId',
                        type: 'string',
                        default: ''
                    },
                    createRecordSourceControl(
                        'affiliationId',
                        ['source', 'fixed'],
                        ['AFFILIATION_ID', 'uiRecordId', 'ID'],
                        'Affiliation ID'
                    ),
                    {
                        text: 'Affiliation ID',
                        value: 'affiliationId',
                        type: 'string',
                        default: ''
                    }
                ]
            },
            {
                text: 'Edit Automation',
                value: 'editAutomation',
                params: [
                    createRecordSourceControl(
                        'automationID',
                        ['source', 'fixed'],
                        ['AUTOMATION_ID', 'value', 'ID'],
                        'Automation ID'
                    ),
                    {
                        text: 'Automation ID',
                        value: 'automationID',
                        type: 'dropdown',
                        itemsSource: 'configStore.allAutomationOptions()',
                        fields: {
                            text: 'text',
                            value: 'value',
                            hasChildren: 'hasChild',
                            parentValue: 'pId',
                        },
                        default: ''
                    }
                ]
            },
            {
                text: 'Delete Automation',
                value: 'deleteAutomation',
                params: [
                    createRecordSourceControl(
                        'automationID',
                        ['source', 'fixed'],
                        ['AUTOMATION_ID', 'value', 'ID'],
                        'Automation ID'
                    ),
                    {
                        text: 'Automation ID',
                        value: 'automationID',
                        type: 'dropdown',
                        itemsSource: 'configStore.allAutomationOptions()',
                        fields: {
                            text: 'text',
                            value: 'value',
                            hasChildren: 'hasChild',
                            parentValue: 'pId',
                        },
                        default: ''
                    }
                ]
            },
            {
                text: 'Run Automation',
                value: 'runAutomation',
                params: [
                    {
                        text: 'Automation Perspective',
                        value: 'psp',
                        type: 'dropdown',
                        items: ['vol', 'org', 'opp'],
                        default: 'vol'
                    },
                    {
                        text: 'automation ID',
                        value: 'automationID',
                        type: 'dropdown',
                        itemsSource: 'configStore.allAutomationOptions(this.component.output.psp)',
                        fields: {
                            text: 'text',
                            value: 'value',
                            hasChildren: 'hasChild',
                            parentValue: 'pId',
                        },
                        default: ''
                    },
                    library.cloneObj(recordSourceControl),
                    library.cloneObj(recordIdControl)
                ]
            },
            {
                text: 'Delete Assignment',
                value: 'deleteAssignment',
                showAllSteps: true,
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                addHideInDialogSwitches: true,
                params: [
                    createRecordSourceControl(
                        'assignmentID',
                        ['source', 'subSource', 'fixed'],
                        ['ASSIGNMENT_ID', 'ID'],
                        'Assignment ID'
                    ),
                    {
                        text: 'Assignment ID',
                        value: 'assignmentID',
                        type: 'number',
                        min: 1,
                        logic: [
                            {
                                criteriaRecord: 'component',
                                record: 'self',
                                prop: 'component.controlConfigs.param___index___assignmentID.display',
                                valueType: 'criteria',
                                criteria: 'this.value === "fixed"'
                            }
                        ],
                    },
                ]
            },
            {
                text: 'Update Affiliation',
                value: 'updateAffiliation',
                showAllSteps: true,
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                addHideInDialogSwitches: true,
                params: [
                    createRecordSourceControl(
                        'affID',
                        ['source', 'subSource', 'fixed', 'matchingRecord'],
                        ['AFFILIATION_ID', 'uiRecordId', 'ID'],
                        'Affiliation Record',
                        ['matchingAffType']
                    ),
                    {
                        text: 'Affiliation ID',
                        value: 'affID',
                        type: 'number',
                        min: 1,
                        logic: [
                            {
                                criteriaRecord: 'component',
                                record: 'self',
                                prop: 'component.controlConfigs.param___index___affId.display',
                                valueType: 'criteria',
                                criteria: 'this.value === "fixed"'
                            }
                        ],
                    },
                    createRecordSourceControl('AFF_OPPORTUNITY_ID', ['source', 'contextOppId', 'selectable', 'fixed', 'none'], ['OPPORTUNITY_ID', 'rowID'], 'Opportunity Record Source'),
                    {
                        text: 'Opportunity ID',
                        value: 'AFF_OPPORTUNITY_ID',
                        type: 'dropdown',
                        default: '',
                        itemsSource: 'configStore.allOppOptions()',
                        logic: [
                            {
                                criteriaRecord: 'self',
                                record: 'component',
                                prop: 'component.controlConfigs.param___index___oppId.display',
                                valueType: 'criteria',
                                criteria: 'this.value === "fixed"'
                            }
                        ],
                    },
                    {
                        text: 'Sub Source Path',
                        value: 'subSourcePath',
                        type: 'string',
                        logic: [
                            {
                                criteriaRecord: 'component',
                                record: 'self',
                                prop: 'display',
                                valueType: 'criteria',
                                criteria: 'this.component.paramValues.recordSource_affID === "subSource"'
                            }
                        ],
                        message: 'eg: Use nextItem.record or prevItem.record to access the next or prev step in a workflow.',
                    },
                    {
                        text: 'Matching Affiliation Type',
                        value: 'matchingAffType',
                        type: 'dropdown',
                        items: [
                            {
                                text: 'Volunteer/Activity',
                                value: 'vol_ae'
                            },
                            {
                                text: 'Volunteer/Organization',
                                value: 'vol_org'
                            }
                        ],
                        fields: {
                            text: 'text',
                            value: 'value'
                        },
                        logic: [
                            {
                                criteriaRecord: 'component',
                                record: 'self',
                                prop: 'display',
                                valueType: 'criteria',
                                criteria: 'this.component.paramValues.recordSource_affID === "matchingRecord"'
                            }
                        ],
                    },
                    {
                        text: 'Matching Activity',
                        value: 'matchingActivityId',
                        type: 'dropdown',
                        itemsSource: 'configStore.activityOptions()',
                        fields: {
                            text: 'AE_TITLE',
                            value: 'ACTIVITY_ENTITY_ID'
                        },
                        logic: [
                            {
                                criteriaRecord: 'component',
                                record: 'self',
                                prop: 'display',
                                valueType: 'criteria',
                                criteria: 'this.component.paramValues.matchingAffType === "vol_ae"'
                            }
                        ],
                    },
                    {
                        text: 'Matching Organization',
                        value: 'matchingOrgId',
                        type: 'dropdown',
                        itemsSource: 'configStore.allOrgOptions()',
                        logic: [
                            {
                                criteriaRecord: 'component',
                                record: 'self',
                                prop: 'display',
                                valueType: 'criteria',
                                criteria: 'this.component.paramValues.matchingAffType === "vol_ae"'
                            }
                        ],
                    },
                    {
                        text: 'Affiliation Type for Status/Reason',
                        label: 'Affiliation Type for Status/Reason',
                        value: 'affType',
                        type: 'dropdown',
                        items: [
                            { text: 'Volunteer/Activity', value: 'vol_ae' },
                            { text: 'Volunteer/Organization', value: 'vol_org' },
                            { text: 'Organization/Organization', value: 'org_org' },
                            { text: 'Assignment', value: 'assignment' },
                        ],
                        fields: {
                            text: 'text',
                            value: 'value'
                        }
                    },
                    {
                        text: 'Status',
                        label: 'Status',
                        value: 'AFF_STATUS',
                        type: 'dropdown',
                        itemsSource: 'configStore.attrListOptions("aff_status_2")',
                        additionalOptions: [
                            { text: 'Empty', value: -1, absoluteOptionPosition: 0 },
                        ],
                        logic: [
                            {
                                criteriaRecord: 'component',
                                record: 'self',
                                prop: 'itemsSource',
                                valueType: 'value',
                                value: 'configStore.attrListOptions("aff_status_0")',
                                criteria: 'this.component.paramValues.affType === "vol_org"'
                            },
                            {
                                criteriaRecord: 'component',
                                record: 'self',
                                prop: 'itemsSource',
                                valueType: 'value',
                                value: 'configStore.attrListOptions("aff_status_1")',
                                criteria: 'this.component.paramValues.affType === "assignment"'
                            },
                            {
                                criteriaRecord: 'component',
                                record: 'self',
                                prop: 'itemsSource',
                                valueType: 'value',
                                value: 'configStore.attrListOptions("aff_status_2")',
                                criteria: 'this.component.paramValues.affType === "vol_ae"'
                            },
                            {
                                criteriaRecord: 'component',
                                record: 'self',
                                prop: 'itemsSource',
                                valueType: 'value',
                                value: 'configStore.attrListOptions("aff_status_3")',
                                criteria: 'this.component.paramValues.affType === "org_org"'
                            },
                        ],
                        fields: { text: 'text', value: 'value' },
                        enableShowInDialog: true,
                    },
                    {
                        text: 'Reason',
                        label: 'Reason',
                        value: 'AFF_REASON',
                        type: 'dropdown',
                        itemsSource: 'configStore.attrListOptions("aff_reason_2")',
                        additionalOptions: [
                            { text: 'Empty', value: -1, absoluteOptionPosition: 0 },
                        ],
                        logic: [
                            {
                                criteriaRecord: 'component',
                                record: 'self',
                                prop: 'itemsSource',
                                valueType: 'value',
                                value: 'configStore.attrListOptions("aff_reason_0")',
                                criteria: 'this.component.paramValues.affType === "vol_org"'
                            },
                            {
                                criteriaRecord: 'component',
                                record: 'self',
                                prop: 'itemsSource',
                                valueType: 'value',
                                value: 'configStore.attrListOptions("aff_reason_1")',
                                criteria: 'this.component.paramValues.affType === "assignment"'
                            },
                            {
                                criteriaRecord: 'component',
                                record: 'self',
                                prop: 'itemsSource',
                                valueType: 'value',
                                value: 'configStore.attrListOptions("aff_reason_2")',
                                criteria: 'this.component.paramValues.affType === "vol_ae"'
                            },
                            {
                                criteriaRecord: 'component',
                                record: 'self',
                                prop: 'itemsSource',
                                valueType: 'value',
                                value: 'configStore.attrListOptions("aff_reason_3")',
                                criteria: 'this.component.paramValues.affType === "org_org"'
                            },
                        ],
                        fields: { text: 'text', value: 'value' },
                        enableShowInDialog: true,
                    },
                    {
                        text: 'Start Date Type',
                        label: 'Start Date Type',
                        value: 'AFF_START_DATE_TYPE',
                        type: 'dropdown',
                        fields: { text: 'text', value: 'value' },
                        items: [{ text: 'Today', value: 'today' }, { text: 'Choose a Date', value: 'selected' }],
                        enableShowInDialog: true
                    },
                    {
                        text: 'Start Date',
                        label: 'Start Date',
                        value: 'AFF_START_DATE',
                        type: 'date',
                        min: new Date(2000, 0, 1),
                        enableShowInDialog: true,
                        allowRelativeDate: true,
                        logic: [
                            {
                                criteriaRecord: 'component',
                                record: 'self',
                                prop: 'display',
                                valueType: 'criteria',
                                criteria: '!this.component.paramValues.AFF_START_DATE_TYPE || this.component.paramValues.AFF_START_DATE_TYPE === "selected"'
                            }
                        ],
                    },
                    {
                        text: 'Expiration Date Type',
                        label: 'Expiration Date Type',
                        value: 'AFF_EXPIRATION_DATE_TYPE',
                        type: 'dropdown',
                        fields: { text: 'text', value: 'value' },
                        items: [
                            { text: 'Today', value: 'today' },
                            { text: '90 days from today', value: '90_days' },
                            { text: '1 year from today', value: '1_year' },
                            { text: 'Choose a Date', value: 'selected' }
                        ],
                        enableShowInDialog: true
                    },
                    {
                        text: 'Expiration Date',
                        label: 'Expiration Date',
                        value: 'AFF_EXPIRATION_DATE',
                        type: 'date',
                        display: 'asField',
                        min: new Date(2000, 0, 1),
                        enableShowInDialog: true,
                        logic: [
                            {
                                criteriaRecord: 'component',
                                record: 'self',
                                prop: 'display',
                                valueType: 'criteria',
                                criteria: '!this.component.paramValues.AFF_EXPIRATION_DATE_TYPE || this.component.paramValues.AFF_EXPIRATION_DATE_TYPE === "selected"'
                            }
                        ],
                    },
                    {
                        text: 'Compliance Status',
                        label: 'Compliance Status',
                        value: 'AFF_COMPLIANCE_STATUS',
                        type: 'dropdown',
                        itemsSource: 'configStore.attrListOptions("aff_compliance_status")',
                        additionalOptions: [
                            { text: 'Empty', value: -1, absoluteOptionPosition: 0 },
                        ],
                        fields: { text: 'text', value: 'value' },
                        enableShowInDialog: true,
                    },
                    {
                        text: 'End Date Type',
                        label: 'End Date Type',
                        value: 'AFF_END_DATE_TYPE',
                        type: 'dropdown',
                        fields: { text: 'text', value: 'value' },
                        items: [
                            { text: 'Today', value: 'today' },
                            { text: '90 days from today', value: '90_days' },
                            { text: '1 year from today', value: '1_year' },
                            { text: 'Choose a Date', value: 'selected' }
                        ],
                        enableShowInDialog: true
                    },
                    {
                        text: 'End Date',
                        label: 'End Date',
                        value: 'AFF_END_DATE',
                        type: 'date',
                        display: 'asField',
                        min: new Date(2000, 0, 1),
                        enableShowInDialog: true,
                        logic: [
                            {
                                criteriaRecord: 'component',
                                record: 'self',
                                prop: 'display',
                                valueType: 'criteria',
                                criteria: '!this.component.paramValues.AFF_END_DATE_TYPE || this.component.paramValues.AFF_END_DATE_TYPE === "selected"'
                            }
                        ],
                    },
                    {
                        text: 'Note',
                        label: 'Note',
                        value: 'AFF_NOTE',
                        type: 'string',
                        enableShowInDialog: true,
                    },
                    {
                        text: 'Don\'t show response message',
                        value: 'disableResponseMessage',
                        type: 'boolean',
                        default: false
                    },
                    {
                        text: 'Run Affiliation Renew On Expiration',
                        value: 'runAffiliationRenewOnExpiration',
                        type: 'boolean',
                        default: false,
                        enableShowInDialog: true,
                    },
                ]
            },
            {
                text: 'Reset Workflow',
                value: 'resetWorkflow',
                params: [
                    createRecordSourceControl(
                        'assignmentId',
                        ['source', 'subSource', 'fixed'],
                        ['ASSIGNMENT_ID', 'ID'],
                        'Assignment ID'
                    ),
                    {
                        text: 'Assignment ID',
                        value: 'assignmentId',
                        type: 'number'
                    },
                    {
                        text: 'Workflow ID',
                        value: 'workflowId',
                        type: 'dropdown',
                        itemsSource: 'configStore.getWorkflowList()',
                        fields: {
                            text: 'WORKFLOW_TITLE',
                            value: 'WORKFLOW_ID'
                        }
                    },
                    {
                        text: 'New Assignment Status',
                        value: 'newAssignmentStatus',
                        type: 'dropdown',
                        itemsSource: 'configStore.attrListOptions("aff_status_1")',
                        additionalOptions: [
                            { text: 'Empty', value: -1, absoluteOptionPosition: 0 },
                        ],
                        fields: {
                            text: 'text',
                            value: 'value'
                        }
                    },
                    {
                        text: 'New Workflow Status',
                        value: 'newWorkflowStatus',
                        type: 'dropdown',
                        items: [
                            { text: 'Completed', value: 'Completed' },
                            { text: 'In Progress', value: 'In Progress' },
                            { text: 'Not Started', value: 'Not Started' },
                            { text: 'Waiting', value: 'Waiting' },
                        ],
                        fields: {
                            text: 'text',
                            value: 'value'
                        }
                    }
                ]
            },
            {
                text: 'Update Workflow Status',
                value: 'updateWorkflowStatus',
                params: [
                    createRecordSourceControl(
                        'assignmentId',
                        ['source', 'subSource', 'fixed'],
                        ['ASSIGNMENT_ID', 'ID', 'uiRecordId'],
                        'Assignment ID'
                    ),
                    {
                        text: 'Assignment ID',
                        value: 'assignmentId',
                        type: 'number'
                    },
                    createRecordSourceControl(
                        'workflowId',
                        ['source', 'subSource', 'fixed'],
                        ['WORKFLOW_ID', 'ID', 'uiRecordId'],
                        'Workflow ID'
                    ),
                    {
                        text: 'Workflow ID',
                        value: 'workflowId',
                        type: 'dropdown',
                        itemsSource: 'configStore.getWorkflowList()',
                        fields: {
                            text: 'WORKFLOW_TITLE',
                            value: 'WORKFLOW_ID'
                        }
                    },
                    {
                        text: 'Workflow Status',
                        value: 'workflowStatus',
                        type: 'dropdown',
                        items: [
                            { text: 'Completed', value: 'Completed' },
                            { text: 'In Progress', value: 'In Progress' },
                            { text: 'Not Started', value: 'Not Started' },
                            { text: 'Waiting', value: 'Waiting' },
                        ],
                        fields: {
                            text: 'text',
                            value: 'value'
                        }
                    }
                ]
            },
            {
                text: 'Renew Existing Activity',
                value: 'renewActivity',
                availableForPsp: ['vol', 'ae'],
                params: [
                    createRecordSourceControl(
                        'currentAffId',
                        ['source', 'subSource', 'contextAffId', 'fixed'],
                        ['AFFILIATION_ID', 'uiRecordId', 'ID'],
                        'Current Affiliation'
                    ),
                    {
                        text: 'Current Sub-source Path',
                        value: 'currentAffId_subSourcePath',
                        type: 'string',
                    },
                    {
                        text: 'Current Affiliation ID',
                        value: 'currentAffId',
                        type: 'number',
                        min: 1
                    },
                    createRecordSourceControl(
                        'volId',
                        ['source', 'subSource', 'contextVolId', 'fixed'],
                        ['VOLUNTEER_ID', 'uiRecordId', 'ID'],
                        'Volunteer Record'
                    ),
                    {
                        text: 'Volunteer Sub-source Path',
                        value: 'volId_subSourcePath',
                        type: 'string',
                    },
                    {
                        text: 'Volunteer ID',
                        value: 'volId',
                        type: 'number',
                        min: 1
                    },
                    createRecordSourceControl(
                        'activityId',
                        ['source', 'subSource', 'contextAeId', 'fixed'],
                        ['ACTIVITY_ENTITY_ID', 'uiRecordId', 'ID'],
                        'Activity Record'
                    ),
                    {
                        text: 'Activity Sub-source Path',
                        value: 'activityId_subSourcePath',
                        type: 'string',
                    },
                    {
                        text: 'Activity ID',
                        value: 'activityId',
                        type: 'number',
                        min: 1
                    },
                    createRecordSourceControl(
                        'repeatOrgId',
                        ['source', 'subSource', 'fixed'],
                        ['ORGANIZATION_ID', 'uiRecordId', 'ID'],
                        'Repeat Organization Record'
                    ),
                    {
                        text: 'Repeat Organization Sub-source Path',
                        value: 'repeatOrgId_subSourcePath',
                        type: 'string',
                    },
                    {
                        text: 'Repeat Organization ID',
                        value: 'repeatOrgId',
                        type: 'number',
                        min: 1
                    },
                    {
                        text: 'Fields',
                        value: 'fields',
                        label: 'Fields',
                        type: 'ARRAY',
                        default: [],
                        allowDragAndDrop: true,
                        itemConfig: {
                            itemType: 'object',
                            primaryKey: 'field',
                            keys: {
                                field: {
                                    label: 'Field',
                                    id: 'field',
                                    type: 'dropdown',
                                    allowFiltering: true,
                                    filterType: 'Contains',
                                    itemsSource: 'configStore.allFieldOptions("aff")',
                                    helpText: '',
                                    fields: {
                                        text: 'text',
                                        value: 'value'
                                    },
                                    itemsFilter: 'this.item.pId' // Removes Headers from field list
                                },
                                value: {
                                    label: 'Value',
                                    id: 'value',
                                    type: 'string',
                                    configSource: 'this.component.paramValues.fields[__index__].field'
                                }
                            },
                            newItem: {
                                field: '',
                                value: ''
                            },
                            permissions: {
                                canMove: false,
                                canDelete: true,
                                allowAddItem: true
                            }
                        }
                    },
                ]
            },
            {
                text: 'Logout',
                value: 'logout',
                params: [
                    {
                        text: 'Perspective',
                        value: 'psp',
                        type: 'dropdown',
                        items: ['vol', 'org', 'app', 'user'],
                        default: 'vol'
                    }
                ]
            },
            {
                text: 'Delete shift',
                value: 'deleteShift',
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                params: [
                    createRecordSourceControl(
                        'slotId',
                        ['source', 'contextSchId', 'selectable', 'fixed'],
                        ['SCHEDULE_SLOT_ID', 'rowID', 'schId', 'ID'],
                        'Shift Record Source'
                    ),
                    {
                        text: 'Shift ID',
                        value: 'slotId',
                        type: 'string',
                        default: ''
                    },
                    {
                        text: 'Disable Confirmation Dialog',
                        value: 'disableConfirmationDialog',
                        type: 'boolean',
                        default: false
                    }
                ]
            },
            {
                text: 'Place/Refer into opp or shift',
                value: 'refPlace',
                params: [
                    {
                        text: 'Is Referral',
                        value: 'isReferral',
                        type: 'dropdown',
                        default: false,
                        items: [
                            { text: 'refer', value: true },
                            { text: 'place', value: false },
                            { text: 'default', value: 'default' }
                        ]
                    },
                    createRecordSourceControl(
                        'oppIds',
                        ['source', 'contextOppId', 'selectable', 'fixed'],
                        ['rowID', 'volId'],
                        'Opportunity Record Source'
                    ),
                    {
                        text: 'Opp IDs',
                        value: 'oppIds',
                        type: 'string',
                        default: ''
                    },
                    createRecordSourceControl(
                        'volIds',
                        ['source', 'contextVolId', 'selectable', 'fixed'],
                        ['rowID', 'volId'],
                        'Volunteer Record Source'
                    ),
                    {
                        text: 'Volunteer IDs',
                        value: 'volIds',
                        type: 'string',
                        default: ''
                    },
                    createRecordSourceControl(
                        'slotIds',
                        ['source', 'contextSchId', 'selectable', 'fixed'],
                        ['rowID', 'schId'],
                        'Shift Record Source'
                    ),
                    {
                        text: 'Shift IDs',
                        value: 'slotIds',
                        type: 'string',
                        default: ''
                    },
                    createRecordSourceControl(
                        'assignmentID',
                        ['source', 'subSource', 'fixed'],
                        ['rowID', 'ASSIGNMENT_ID'],
                        'Assignment Reference for Shift'
                    ),
                    {
                        text: 'Assignment Reference for Shift',
                        value: 'assignmentID',
                        type: 'string',
                        default: ''
                    },
                    createRecordSourceControl(
                        'aeAffID',
                        ['source', 'subSource', 'fixed'],
                        ['rowID', 'AFFILIATION_ID'],
                        'Affiliation Reference for Shift'
                    ),
                    {
                        text: 'Affiliation Reference for Shift',
                        value: 'aeAffID',
                        type: 'string',
                        default: ''
                    },
                    {
                        text: 'Remove Existing Assignment',
                        value: 'removeExistingAssignment',
                        type: 'boolean',
                        default: true,
                        helpText: 'This will remove the opposite referral/placement before submitting the new assignment.'
                    },
                    {
                        text: 'Do Prerequisite Check',
                        value: 'doAddCheck',
                        type: 'boolean',
                        default: false
                    },
                    {
                        text: 'Return Available Positions',
                        value: 'returnAvailPositionsSlotIdsArray',
                        type: 'boolean',
                        default: false
                    }
                ]
            },
            {
                text: 'Send Email Template',
                value: 'sendEST',
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                params: [
                    {
                        text: 'Record Type',
                        value: 'psp',
                        type: 'dropdown',
                        items: [
                            { text: 'Volunteer', value: 'vol' },
                            { text: 'Opportunity', value: 'opp' },
                            { text: 'Organization', value: 'org' },
                            { text: 'Clients', value: 'mem' },
                            { text: 'Activity', value: 'ae' },
                            { text: 'Shift', value: 'slot' },
                            { text: 'Log Book', value: 'lbe' },
                        ],
                        fields: { text: 'text', value: 'value' },
                        default: 'vol'
                    },
                    {
                        text: 'Email Template',
                        value: 'estId',
                        type: 'dropdowntree',
                        allowFiltering: true,
                        filterType: 'Contains',
                        doNotMergeOptions: true,
                        fields: {
                            text: 'text',
                            value: 'value',
                            hasChildren: 'hasChild',
                            parentValue: 'pId',
                        },
                        itemsSource: 'configStore.filteredESTOption(this.component.paramValues.psp)',
                        default: null
                    },
                    library.cloneObj(recordSourceControl),
                    {
                        text: 'Record Ids',
                        value: 'recordId',
                        type: 'string',
                        default: '',
                        display: false
                    },
                    createRecordSourceControl(
                        'affID',
                        ['source', 'subSource', 'fixed', 'matchingRecord'],
                        ['AFFILIATION_ID', 'uiRecordId', 'ID'],
                        'Affiliation Record',
                        ['matchingAffType']
                    ),
                    {
                        text: 'Affiliation ID',
                        value: 'affID',
                        type: 'number',
                        min: 1
                    }
                ]
            },
            {
                text: 'Upload attachments',
                value: 'uploadAttachments',
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                params: [
                    library.cloneObj(recordSourceControl),
                    {
                        text: 'Record Type',
                        value: 'psp',
                        type: 'dropdown',
                        items: [
                            { text: 'Volunteer', value: 'vol' },
                            { text: 'Opportunity', value: 'opp' },
                            { text: 'Organization', value: 'org' },
                            { text: 'Clients', value: 'mem' },
                            { text: 'Activity', value: 'ae' }
                        ],
                        fields: { text: 'text', value: 'value' },
                        default: 'vol'
                    },
                    library.cloneObj(recordIdControl),
                    {
                        text: 'Upload Files',
                        value: 'attachIds',
                        type: 'dropdowntree',
                        allowFiltering: true,
                        allowMultiSelection: true,
                        message: '"Ctrl + click" to select/deselect multiple',
                        filterType: 'Contains',
                        doNotMergeOptions: true,
                        fields: {
                            text: 'text',
                            value: 'value'
                        },
                        itemsSource: 'configStore.getAttachTypeListOptions(1, this.component.paramValues.psp, true)',
                        default: []
                    },
                    {
                        text: 'Disable Toast Confirmation',
                        value: 'disableToastConfirmation',
                        type: 'boolean',
                        default: false
                    }
                ]
            },
            {
                text: 'Review Background Checks',
                value: 'openBackgroundCheckReview',
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                params: [
                    library.cloneObj(recordSourceControl),
                    createRecordSourceControl(
                        'recordId',
                        ['source', 'contextVolId', 'selectable', 'fixed'],
                        ['VOLUNTEER_ID', 'rowID', 'volId', 'uiRecordId'],
                        'Volunteer Record Source'
                    ),
                    {
                        text: 'Record Ids',
                        value: 'recordId',
                        type: 'string',
                        default: '',
                        display: false
                    }
                ]
            },
            {
                text: 'Create Update Shift',
                value: 'createUpdateShift',
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                params: [
                    createRecordSourceControl('schID', ['source', 'contextSchId', 'selectable', 'fixed', 'none'], ['SCHEDULE_SLOT_ID', 'rowID', 'ID'], 'Shift Record Source'),
                    {
                        text: 'Shift ID',
                        value: 'schID',
                        type: 'string',
                        default: '',
                    },
                    createRecordSourceControl('oppID', ['source', 'contextOppId', 'selectable', 'fixed', 'none'], ['OPPORTUNITY_ID', 'rowID'], 'Opportunity Record Source'),
                    {
                        text: 'Opportunity ID',
                        value: 'oppID',
                        type: 'string',
                        default: '',
                    },
                    createRecordSourceControl('aeID', ['source', 'contextAeId', 'selectable', 'fixed', 'none'], ['ACTIVITY_ENTITY_ID', 'rowID'], 'Activity Record Source'),
                    {
                        text: 'Activity ID',
                        value: 'aeID',
                        type: 'string',
                        default: '',
                    },
                    createRecordSourceControl('aeOrgID', ['source', 'contextOrgId', 'selectable', 'fixed', 'none'], ['ORGANIZATION_ID', 'rowID'], 'Activity Organization Record Source'),
                    {
                        text: 'Activity Organization ID',
                        value: 'aeOrgID',
                        type: 'string',
                        default: '',
                    },
                    {
                        text: 'Date',
                        value: 'selectedDate',
                        type: 'date',
                        display: 'asField'
                    },
                ]
            },
            {
                text: 'Unplace/unrefer from opp or shift',
                value: 'unRefPlace',
                params: [
                    {
                        text: 'Assignment Type',
                        value: 'isReferral',
                        type: 'dropdown',
                        default: false,
                        items: [
                            { text: 'refer', value: true },
                            { text: 'place', value: false },
                            { text: 'default', value: 'default' },
                            { text: 'both', value: 'both' }
                        ]
                    },
                    createRecordSourceControl(
                        'oppIds',
                        ['source', 'contextOppId', 'selectable', 'fixed'],
                        ['rowID', 'volId'],
                        'Opportunity Record Source'
                    ),
                    {
                        text: 'Opp IDs',
                        value: 'oppIds',
                        type: 'string',
                        default: ''
                    },
                    createRecordSourceControl(
                        'volIds',
                        ['source', 'contextVolId', 'selectable', 'fixed'],
                        ['rowID', 'volId'],
                        'Volunteer Record Source'
                    ),
                    {
                        text: 'Volunteer IDs',
                        value: 'volIds',
                        type: 'string',
                        default: ''
                    },
                    createRecordSourceControl(
                        'slotIds',
                        ['source', 'contextSchId', 'selectable', 'fixed'],
                        ['rowID', 'schId'],
                        'Shift Record Source'
                    ),
                    {
                        text: 'Shift IDs',
                        value: 'slotIds',
                        type: 'string',
                        default: ''
                    }
                ]
            },
            {
                text: 'Open Email',
                value: 'openEmail',
                params: [
                    {
                        text: 'Record Type',
                        value: 'psp',
                        type: 'dropdown',
                        items: [
                            { text: 'Volunteer', value: '1' },
                            { text: 'Opportunity', value: '2' },
                            { text: 'Organization', value: '3' },
                            { text: 'Source Record', value: 'source' }
                        ],
                        fields: { text: 'text', value: 'value' },
                        default: 'vol'
                    },
                    library.cloneObj(recordSourceControl),
                    {
                        text: 'Record Ids',
                        value: 'recordId',
                        type: 'string',
                        default: '',
                        display: false
                    }
                ]
            },
            {
                text: 'Open Logbook Entry',
                value: 'openLogBookEntry',
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                params: [
                    createRecordSourceControl('lbeID', ['source', 'subSource', 'contextLbeId', 'selectable', 'fixed'], ['LOG_BOOK_ENTRY_ID', 'rowID']),
                    {
                        text: 'Logbook entry ID',
                        value: 'lbeID',
                        type: 'number',
                        default: false
                    },
                    {
                        text: 'Sub Source Path',
                        value: 'subSourcePath',
                        type: 'string',
                    },
                ]
            },
            {
                text: 'Open Survey',
                value: 'openSurvey',
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                params: [
                    createRecordSourceControl(
                        'recordId',
                        ['source', 'subSource', 'contextVolId', 'selectable', 'fixed'],
                        ['VOLUNTEER_ID', 'AFF_VOLUNTEER_ID'],
                        'Volunteer ID',
                    ),
                    {
                        text: 'Volunteer ID',
                        value: 'recordId',
                        type: 'string',
                        default: '',
                        display: false
                    },
                    {
                        text: 'Opportunity ID',
                        value: 'oppID',
                        type: 'dropdown',
                        itemsSource: 'configStore.allOppOptions()',
                        fields: {
                            text: 'text',
                            value: 'value'
                        },
                        helpText: 'Leave this empty if you want to record a non-opportunity survey',
                        default: ''
                    },
                    {
                        text: 'Select Survey',
                        value: 'packageID',
                        type: 'dropdowntree',
                        itemsSource: 'configStore.allSurveyOptions()',
                        doNotMergeOptions: true,
                        fields: {
                            text: 'text',
                            value: 'value',
                            hasChildren: 'hasChild',
                            parentValue: 'pId',
                        },
                        default: '',
                        itemsFilter: '(this.component.paramValues.oppID && this.item.pId === "regular") || (!this.component.paramValues.oppID && this.item.pId === "nonopp")'
                    },
                    createRecordSourceControl('aeID', ['source', 'contextAeId', 'selectable', 'fixed'], ['ACTIVITY_ENTITY_ID', 'rowID'], 'Activity Record Source'),
                    {
                        text: 'Activity ID',
                        value: 'aeID',
                        type: 'string',
                        default: '',
                    },
                    createRecordSourceControl(
                        'affID',
                        ['source', 'fixed', 'matchingRecord'],
                        ['AFFILIATION_ID', 'uiRecordId', 'ID'],
                        'Affiliation Record',
                        ['matchingAffType']
                    ),
                    {
                        text: 'Affiliation ID',
                        value: 'affID',
                        type: 'number',
                        min: 1,
                    },
                    createRecordSourceControl('assignmentID', ['source', 'subSource', 'fixed'], ['ASSIGNMENT_ID', 'rowID'], 'Assignment Record Source'),
                    {
                        text: 'Assignment ID',
                        value: 'assignmentID',
                        type: 'number',
                    },
                    {
                        text: 'Dialog Settings',
                        value: 'dialogSettings',
                        type: 'object',
                        properties: {
                            title: {
                                type: 'string',
                                label: 'Dialog Title',
                                helpText: 'Title of dialog.',
                                id: 'title',
                            },
                            size: {
                                type: 'string',
                                label: 'Size',
                                id: 'size'
                            },
                            width: {
                                type: 'string',
                                label: 'Width',
                                id: 'width'
                            },
                            height: {
                                type: 'string',
                                label: 'Height',
                                id: 'height'
                            },
                            cssClass: {
                                type: 'string',
                                label: 'CSS Class',
                                id: 'cssClass'
                            },
                            okButtonLabel: {
                                type: 'string',
                                label: 'Ok Button Label',
                                id: 'okButtonLabel',
                                default: 'Ok'
                            },
                            okButtonCssClass: {
                                type: 'string',
                                label: 'Ok Button CSS Class',
                                id: 'okButtonCssClass',
                            },
                            cancelButtonLabel: {
                                type: 'string',
                                label: 'Cancel Button Label',
                                id: 'cancelButtonLabel',
                                default: 'Cancel'
                            },
                            cancelButtonCssClass: {
                                type: 'string',
                                label: 'Cancel Button CSS Class',
                                id: 'cancelButtonCssClass',
                            },
                            closeOnEscape: {
                                type: 'boolean',
                                label: 'Allow Closing on Escape',
                                id: 'closeOnEscape',
                                default: false
                            }
                        },
                        default: {}
                    }
                ]
            },
            {
                text: 'Open Waiver',
                value: 'openWaiver',
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                params: [
                    library.cloneObj(recordSourceControl),
                    {
                        text: 'Volunteer ID',
                        value: 'recordId',
                        type: 'string',
                        default: '',
                        display: false
                    },
                    createRecordSourceControl('oppID',
                        ['source', 'contextOppId', 'selectable', 'fixed', 'none'],
                        ['OPPORTUNITY_ID', 'rowID', 'ID'],
                        'Opportunity Record Source'),
                    {
                        text: 'Opportunity ID',
                        value: 'oppID',
                        type: 'dropdown',
                        itemsSource: 'configStore.allOppOptions()',
                        fields: {
                            text: 'text',
                            value: 'value'
                        },
                        helpText: 'Leave this empty if you want to record a non-opportunity waiver',
                        default: ''
                    },
                    {
                        text: 'Select Waiver',
                        value: 'packageID',
                        type: 'dropdown',
                        itemsSource: 'configStore.allWaiverOptions()',
                        fields: {
                            text: 'text',
                            value: 'value'
                        },
                        itemTemplate: `<div><span style="font-weight: 500; color: #333333">{{this.data.text}}</span> <span style="color: #999999;"> ({{this.data.value}})</span></div>`,
                        default: ''
                    },
                    createRecordSourceControl('aeID', ['source', 'contextAeId', 'selectable', 'fixed'], ['ACTIVITY_ENTITY_ID', 'rowID'], 'Activity Record Source'),
                    {
                        text: 'Activity ID',
                        value: 'aeID',
                        type: 'string',
                        default: '',
                    },
                    createRecordSourceControl(
                        'affID',
                        ['source', 'fixed', 'matchingRecord'],
                        ['AFFILIATION_ID', 'uiRecordId', 'ID'],
                        'Affiliation Record',
                        ['matchingAffType']
                    ),
                    {
                        text: 'Affiliation ID',
                        value: 'affID',
                        type: 'number',
                        min: 1,
                    },
                    createRecordSourceControl('assignmentID', ['source', 'subSource', 'fixed'], ['ASSIGNMENT_ID', 'rowID'], 'Assignment Record Source'),
                    {
                        text: 'Assignment ID',
                        value: 'assignmentID',
                        type: 'number',
                    },
                    {
                        text: 'Dialog Settings',
                        value: 'dialogSettings',
                        type: 'object',
                        properties: {
                            title: {
                                type: 'string',
                                label: 'Dialog Title',
                                helpText: 'Title of dialog.',
                                id: 'title',
                            },
                            size: {
                                type: 'string',
                                label: 'Size',
                                id: 'size'
                            },
                            width: {
                                type: 'string',
                                label: 'Width',
                                id: 'width'
                            },
                            height: {
                                type: 'string',
                                label: 'Height',
                                id: 'height'
                            },
                            cssClass: {
                                type: 'string',
                                label: 'CSS Class',
                                id: 'cssClass'
                            },
                            okButtonLabel: {
                                type: 'string',
                                label: 'Ok Button Label',
                                id: 'okButtonLabel',
                                default: 'Ok'
                            },
                            okButtonCssClass: {
                                type: 'string',
                                label: 'Ok Button CSS Class',
                                id: 'okButtonCssClass',
                            },
                            cancelButtonLabel: {
                                type: 'string',
                                label: 'Cancel Button Label',
                                id: 'cancelButtonLabel',
                                default: 'Cancel'
                            },
                            cancelButtonCssClass: {
                                type: 'string',
                                label: 'Cancel Button CSS Class',
                                id: 'cancelButtonCssClass',
                            },
                            closeOnEscape: {
                                type: 'boolean',
                                label: 'Allow Closing on Escape',
                                id: 'closeOnEscape',
                                default: false
                            }
                        },
                        default: {}
                    }
                ]
            },
            {
                text: 'Open Training',
                value: 'openTraining',
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                params: [
                    library.cloneObj(recordSourceControl),
                    {
                        text: 'Volunteer ID',
                        value: 'recordId',
                        type: 'string',
                        default: '',
                        display: false
                    },
                    {
                        text: 'Opportunity ID',
                        value: 'oppID',
                        type: 'dropdown',
                        itemsSource: 'configStore.allOppOptions()',
                        fields: {
                            text: 'text',
                            value: 'value'
                        },
                        helpText: 'Leave this empty if you want to record a non-opportunity training',
                        default: ''
                    },
                    {
                        text: 'Select Training',
                        value: 'packageID',
                        type: 'dropdown',
                        itemsSource: 'configStore.allTrainingOptions()',
                        fields: {
                            text: 'text',
                            value: 'value'
                        },
                        default: ''
                    },
                    createRecordSourceControl('aeID', ['source', 'contextAeId', 'selectable', 'fixed'], ['ACTIVITY_ENTITY_ID', 'rowID'], 'Activity Record Source'),
                    {
                        text: 'Activity ID',
                        value: 'aeID',
                        type: 'string',
                        default: '',
                    },
                    createRecordSourceControl('assignmentID', ['source', 'subSource', 'fixed'], ['ASSIGNMENT_ID', 'rowID'], 'Assignment Record Source'),
                    {
                        text: 'Assignment ID',
                        value: 'assignmentID',
                        type: 'number',
                    },
                    createRecordSourceControl(
                        'affID',
                        ['source', 'fixed', 'matchingRecord'],
                        ['AFFILIATION_ID', 'uiRecordId', 'ID'],
                        'Affiliation Record',
                        ['matchingAffType']
                    ),
                    {
                        text: 'Affiliation ID',
                        value: 'affID',
                        type: 'number',
                        min: 1,
                    },
                    {
                        text: 'Dialog Settings',
                        value: 'dialogSettings',
                        type: 'object',
                        properties: {
                            title: {
                                type: 'string',
                                label: 'Dialog Title',
                                helpText: 'Title of dialog.',
                                id: 'title',
                            },
                            size: {
                                type: 'string',
                                label: 'Size',
                                id: 'size'
                            },
                            width: {
                                type: 'string',
                                label: 'Width',
                                id: 'width'
                            },
                            height: {
                                type: 'string',
                                label: 'Height',
                                id: 'height'
                            },
                            cssClass: {
                                type: 'string',
                                label: 'CSS Class',
                                id: 'cssClass'
                            },
                            okButtonLabel: {
                                type: 'string',
                                label: 'Ok Button Label',
                                id: 'okButtonLabel',
                                default: 'Ok'
                            },
                            okButtonCssClass: {
                                type: 'string',
                                label: 'Ok Button CSS Class',
                                id: 'okButtonCssClass',
                            },
                            cancelButtonLabel: {
                                type: 'string',
                                label: 'Cancel Button Label',
                                id: 'cancelButtonLabel',
                                default: 'Cancel'
                            },
                            cancelButtonCssClass: {
                                type: 'string',
                                label: 'Cancel Button CSS Class',
                                id: 'cancelButtonCssClass',
                            },
                            closeOnEscape: {
                                type: 'boolean',
                                label: 'Allow Closing on Escape',
                                id: 'closeOnEscape',
                                default: false
                            }
                        },
                        default: {}
                    }
                ]
            },
            {
                text: 'Create Logbook Entry',
                value: 'createLbe',
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                params: [
                    createRecordSourceControl(
                        'volId',
                        ['source', 'contextVolId', 'selectable', 'fixed'],
                        ['VOLUNTEER_ID', 'uiRecordId', 'volId'],
                        'Volunteer Record Source'
                    ),
                    {
                        text: 'Volunteer ID',
                        value: 'volId',
                        type: 'string',
                        default: '',
                        display: false
                    },
                    {
                        text: 'Select Survey',
                        value: 'surveyId',
                        type: 'dropdowntree',
                        itemsSource: 'configStore.allSurveyOptions()',
                        doNotMergeOptions: true,
                        allowFiltering: true,
                        fields: {
                            text: 'text',
                            value: 'value',
                            hasChildren: 'hasChild',
                            parentValue: 'pId'
                        },
                        default: ''
                    },
                    {
                        text: 'Select Opportunity',
                        value: 'oppId',
                        type: 'dropdown',
                        itemsSource: 'configStore.allOppOptions()',
                        allowFiltering: true,
                        optional: true,
                        fields: {
                            text: 'text',
                            value: 'value'
                        },
                        helpText: 'Leave this empty if you want to record a non-opportunity survey',
                        default: ''
                    },
                    {
                        text: 'Logged Data Field(s)',
                        value: 'loggedDataFields',
                        label: 'Options',
                        type: 'ARRAY',
                        default: [],
                        itemConfig: {
                            itemType: 'object',
                            primaryKey: 'field',
                            permissions: {
                                allowAddItem: true,
                                canMove: true,
                                canDelete: true
                            },
                            keys: {
                                field: {
                                    label: 'Field',
                                    id: 'field',
                                    type: 'dropdowntree',
                                    allowFiltering: true,
                                    filterType: 'Contains',
                                    itemsSource: 'configStore.allFieldOptions("lbe")',
                                    helpText: 'Select a Logged Data Field for your survey'
                                },
                                value: {
                                    label: 'Value',
                                    id: 'value',
                                    type: 'string',
                                    helpText: 'Type in the value for the Logged Data Field'
                                }
                            },
                            newItem: {
                                field: '',
                                value: ''
                            }
                        },
                    },
                    createRecordSourceControl(
                        'ACTIVITY_ENTITY_ID',
                        ['source', 'contextAeId', 'selectable', 'fixed'],
                        ['ACTIVITY_ENTITY_ID', 'rowID'],
                        'Activity Record Source'
                    ),
                    {
                        text: 'Activity ID',
                        value: 'ACTIVITY_ENTITY_ID',
                        type: 'string',
                        default: '',
                    },
                    createRecordSourceControl(
                        'AFFILIATION_ID',
                        ['source', 'fixed', 'matchingRecord'],
                        ['AFFILIATION_ID', 'uiRecordId', 'ID'],
                        'Affiliation Record',
                    ),
                    {
                        text: 'Affiliation ID',
                        value: 'AFFILIATION_ID',
                        type: 'number',
                        min: 1,
                    },
                    {
                        text: 'Success Message text',
                        value: 'successMessageText',
                        type: 'text',
                    },
                    {
                        text: 'Disable Success Message',
                        value: 'disableSuccessMessage',
                        type: 'checkbox',
                        default: false,
                    },
                ]
            },
            {
                text: 'Open Url',
                value: 'openUrl',
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                onlyRunsParallel: true,
                params: [
                    {
                        text: 'URL',
                        value: 'url',
                        type: 'string',
                        default: '',
                        helpText: 'Specify the url to open.'
                    },
                    library.cloneObj(recordSourceControl),
                    library.cloneObj(recordIdControl),
                    {
                        text: 'URL Parameters',
                        value: 'urlParams',
                        type: 'string',
                        default: '',
                        message: 'eg: param=1&userparam={{record.VOL_FIRST_NAME}}',
                        helpText: 'Generate static parameters or provide dynamic parameters based on the provided record.  When using dynamic params, the parent will always be "record".'
                    },
                    {
                        text: 'Target',
                        value: 'target',
                        type: 'dropdown',
                        items: [
                            '_blank',
                            '_self',
                            '_parent',
                        ],
                        default: 'blank',
                        helpText: 'Open in the current window, a new window, or parent window (if in an iframe).'
                    }
                ]
            },
            {
                text: 'Play YouTube video',
                value: 'playYouTubeVideo',
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                params: [
                    {
                        text: 'Modal Header',
                        value: 'modalHeader',
                        type: 'string',
                        default: '',
                    },
                    {
                        text: 'Video URL',
                        value: 'videoUrl',
                        type: 'string',
                        default: '',
                    },
                    {
                        text: 'Custom message',
                        value: 'customMessage',
                        type: 'text',
                        default: '',
                    },
                    {
                        text: 'Allow resume',
                        value: 'allowResume',
                        type: 'checkbox',
                        default: false,
                    },
                    {
                        text: 'Disable fast forward',
                        value: 'disableFastForward',
                        type: 'checkbox',
                        default: false,
                    }
                ]
            },
            {
                text: 'Affiliate Record',
                value: 'affiliateRecord',
                submitButtonLabel: 'Affiliate',
                params: [
                    {
                        text: 'Affiliation Type',
                        value: 'affType',
                        type: 'dropdown',
                        items: [
                            { text: 'Volunteer/Organization', value: 'vol_org' },
                            { text: 'Organization/Organization', value: 'org_org' },
                            { text: 'Assignment', value: 'assignment' },
                        ]
                    },
                    createRecordSourceControl(
                        'volId',
                        ['source', 'contextVolId', 'selectable', 'fixed'],
                        ['rowID', 'volId'],
                        'Volunteer Record Source'
                    ),
                    {
                        text: 'Volunteer',
                        value: 'volId',
                        type: 'dropdown',
                        allowFiltering: true,
                        itemsSource: 'configStore.allVolOptions()',
                        helpText: 'The volunteer you want to affiliate.'
                    },
                    createRecordSourceControl(
                        'orgId',
                        ['source', 'contextOrgId', 'selectable', 'fixed'],
                        ['rowID', 'orgId'],
                        'Organization Record Source'
                    ),
                    {
                        text: 'Organization',
                        value: 'orgId',
                        type: 'dropdown',
                        allowFiltering: true,
                        itemsSource: 'configStore.allOrgOptions()',
                        helpText: 'The Organization you want to affiliate.'
                    },
                    createRecordSourceControl(
                        'orgId2',
                        ['source', 'contextOrgId', 'selectable', 'fixed'],
                        ['rowID', 'orgId'],
                        'Organization 2 Record Source'
                    ),
                    {
                        text: 'Organization 2',
                        value: 'orgId2',
                        type: 'dropdown',
                        allowFiltering: true,
                        itemsSource: 'configStore.allOrgOptions()',
                        helpText: 'The Organization you want to affiliate.'
                    },
                    createRecordSourceControl(
                        'endpointID',
                        ['source', 'selectable', 'fixed', 'subSource'],
                        ['rowID', 'AFFILIATION_ID'],
                        'Endpoint Record Source'
                    ),
                    {
                        text: 'Endpoint',
                        value: 'endpointID',
                        type: 'string',
                        helpText: 'Endpoint ID.'
                    },
                    {
                        text: 'Endpoint Sub-source Path',
                        value: 'endpointID_subSourcePath',
                        type: 'string',
                    },
                    // library.cloneObj(recordSourceControl),
                    // library.cloneObj(recordIdControl),
                ]
            },
            {
                text: 'Create Assignment',
                value: 'createAssignment',
                submitButtonLabel: 'Create',
                params: [
                    createRecordSourceControl(
                        'volId',
                        ['source', 'contextVolId', 'selectable', 'fixed'],
                        ['rowID', 'volId'],
                        'Volunteer Record Source'
                    ),
                    {
                        text: 'Volunteer',
                        value: 'volId',
                        type: 'dropdown',
                        allowFiltering: true,
                        itemsSource: 'configStore.allVolOptions()',
                        helpText: 'The volunteer you want to affiliate.'
                    },
                    createRecordSourceControl(
                        'endpointID',
                        ['source', 'selectable', 'fixed', 'subSource'],
                        ['rowID', 'AFFILIATION_ID'],
                        'Endpoint Record Source'
                    ),
                    {
                        text: 'Endpoint',
                        value: 'endpointID',
                        type: 'string',
                        helpText: 'Endpoint ID.'
                    },
                    {
                        text: 'Endpoint Sub-source Path',
                        value: 'endpointID_subSourcePath',
                        type: 'string',
                    },
                    // library.cloneObj(recordSourceControl),
                    // library.cloneObj(recordIdControl),
                ]
            },
            {
                text: 'Create Dataset',
                value: 'createDataset',
                params: [
                    {
                        text: 'Dataset Type',
                        value: 'psp',
                        type: 'dropdown',
                        items: [
                            { value: 1, text: 'Volunteer dataset' },
                            { value: 51, text: 'Volunteer logbook dataset' },
                            { value: 2, text: 'Opportunity dataset' },
                            { value: 52, text: 'Opportunity logbook dataset' },
                            { value: 3, text: 'Organization dataset' },
                            { value: 53, text: 'Organization logbook dataset' },
                            { value: 5, text: 'Client dataset' },
                            { value: 55, text: 'Client logbook dataset' },
                            { value: 11, text: 'Calendar dataset' },
                            { value: 32, text: 'Affiliations dataset' },
                            { value: 14, text: 'Professions dataset' },
                        ],
                        fields: { text: 'text', value: 'value' },
                        default: 1
                    },
                ]
            },
            {
                text: 'Switch to Tab',
                value: 'openTab',
                params: [
                    {
                        text: 'Perspective',
                        value: 'psp',
                        type: 'dropdown',
                        items: [
                            { text: 'Volunteers', value: 'vol' },
                            { text: 'Opportunities', value: 'opp' },
                            { text: 'Organizations', value: 'org' },
                            { text: 'Clients', value: 'mem' },
                            { text: 'Professions', value: 'prof' },
                            { text: 'Affiliations', value: 'aff' },
                        ],
                        fields: { text: 'text', value: 'value' },
                        default: 1
                    },
                    {
                        text: 'Grid ID',
                        value: 'gridId',
                        type: 'dropdowntree',
                        fields: {
                            text: 'text',
                            value: 'value',
                            hasChildren: 'hasChild',
                            parentValue: 'pId',
                        },
                        showCheckBox: false,
                        itemsSource: 'configStore.allSavedGridOptions()',
                        // itemsFilter: 'this.component.controls.psp.value === this.item.pId',
                        default: []
                    },
                    {
                        text: 'Filter ID',
                        value: 'filterId',
                        type: 'dropdowntree',
                        fields: {
                            text: 'text',
                            value: 'value',
                            hasChildren: 'hasChild',
                            parentValue: 'pId',
                        },
                        showCheckBox: false,
                        itemsSource: 'configStore.allFiltersOptions()',
                        // itemsFilter: 'this.component.controls.psp.value === this.item.pId',
                        default: []
                    },
                ]
            },
            {
                text: 'New component',
                value: 'createComponent',
                showAllSteps: true,
                submitButtonLabel: 'Create Component',
                params: [
                    {
                        text: 'Component Title',
                        type: 'string',
                        value: 'cTitle',
                        default: 'New Component',
                    },
                    {
                        type: 'string',
                        value: 'cId',
                        text: 'Component ID',
                        default: 'componentId1',
                    },
                    {
                        type: 'boolean',
                        value: 'isPublic',
                        text: 'Component Is Public',
                        default: false,
                    },
                    {
                        type: 'boolean',
                        value: 'createFromCopy',
                        text: 'Copy Existing Component?',
                        default: false,
                        helpText: 'Select the component you want to copy.',
                    },
                    {
                        type: 'dropdown',
                        value: 'cType',
                        itemsSource: 'componentStore.getTypes()',
                        text: 'Component Type',
                        required: true,
                        helpText: 'Type of component that you want to create.',
                        default: false,
                    },
                    {
                        type: 'dropdown',
                        value: 'componentToCopy',
                        itemsSource: 'componentStore.getList(true)',
                        itemsFilter: '!this.component.output.cType || this.component.output.cType === this.item.cType',
                        allowFiltering: true,
                        filterType: 'contains',
                        fields: { text: 'cId', value: 'cId' },
                        logic: [
                            {
                                record: 'self',
                                prop: 'display',
                                valueType: 'criteria',
                                criteria: 'this.controls.createFromCopy.value === true'
                            }
                        ],
                        text: 'Component To Copy',
                        required: true,
                        helpText: 'Select the component you want to copy.',
                    }
                ]
            },
            {
                text: 'Add hours',
                value: 'openAddhours',
                params: [
                    {
                        text: 'Volunteer ID',
                        value: 'recordId',
                        type: 'string',
                        default: '',
                        display: false
                    },
                    {
                        text: 'Record ID Source Field',
                        value: 'matchingSourceField',
                        type: 'string',
                        default: '',
                        display: false,
                        message: 'Select the record field you want your ID to come from.'
                    }
                ]
            },
            {
                text: 'Open PDF',
                value: 'openPdf',
                params: [
                    {
                        text: 'Template',
                        value: 'fileHash',
                        type: 'dropdown',
                        itemsSource: 'configStore.pdfTemplateOptions()',
                        fields: { text: 'text', value: 'value' },
                        default: ''
                    },
                    {
                        text: 'Volunteer ID',
                        value: 'volId',
                        type: 'string',
                        default: '',
                        display: false
                    },
                    {
                        text: 'Opportunity ID',
                        value: 'oppId',
                        type: 'dropdown',
                        itemsSource: 'configStore.allOppOptions()',
                        fields: {
                            text: 'text',
                            value: 'value'
                        },
                        default: ''
                    }
                ]
            },
            {
                text: 'Open LMS Module',
                value: 'openLMSModule',
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                params: [
                    {
                        text: 'LMS Module URL',
                        value: 'lmsModuleURL',
                        type: 'string',
                        default: ''
                    }
                ]
            },
            {
                text: 'Open Scheduling Modal',
                value: 'openSchedulingModal',
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae'],
                params: [
                    {
                        text: 'Type of Shifts',
                        value: 'shiftRecordType',
                        type: 'dropdown',
                        items: [{ text: 'Activity Shifts', value: 'ae' }, { text: 'Opportunity Shifts', value: 'opp' }],
                        fields: {
                            text: 'text',
                            value: 'value',
                        }
                    },
                    createRecordSourceControl('recordId',
                        ['source', 'selectable', 'fixed'],
                        ['ACTIVITY_ENTITY_ID', 'OPPORTUNITY_ID', 'rowID', 'ID']),
                    {
                        text: 'Record ID',
                        value: 'recordId',
                        type: 'string',
                        default: ''
                    },
                    createRecordSourceControl(
                        'assignmentID',
                        ['source', 'subSource', 'fixed'],
                        ['rowID', 'ASSIGNMENT_ID'],
                        'Assignment Reference for Shift'
                    ),
                    {
                        text: 'Assignment Reference for Shift',
                        value: 'assignmentID',
                        type: 'string',
                        default: ''
                    },
                    createRecordSourceControl(
                        'aeAffID',
                        ['source', 'subSource', 'fixed'],
                        ['rowID', 'AFFILIATION_ID'],
                        'Affiliation Reference for Shift'
                    ),
                    {
                        text: 'Affiliation Reference for Shift',
                        value: 'aeAffID',
                        type: 'string',
                        default: ''
                    },
                    {
                        text: 'Automatically Set "Scheduled" Reason',
                        value: 'autoSetScheduledAffReason',
                        type: 'dropdown',
                        fields: { text: 'text', value: 'value' },
                        itemsSource: 'configStore.attrListOptions("aff_reason_2")',
                    },
                    {
                        text: 'Automatically Set "Not Scheduled" Reason',
                        value: 'autoSetUnscheduledAffReason',
                        type: 'dropdown',
                        fields: { text: 'text', value: 'value' },
                        itemsSource: 'configStore.attrListOptions("aff_reason_2")',
                    },
                    createRecordSourceControl(
                        'volId',
                        ['source', 'selectable', 'contextVolId'],
                        ['VOLUNTEER_ID', 'uiRecordId', 'ID'],
                        'Volunteer Id'
                    ),
                    {
                        text: 'Volunteer Id',
                        value: 'volId',
                        type: 'string',
                        default: ''
                    },
                    createRecordSourceControl(
                        'aeSsOrgId',
                        ['source', 'subSource', 'selectable', 'contextOrgId'],
                        ['ORGANIZATION_ID', 'AE_SS_ORGANIZATION_ID'],
                        'Shifts For Matching Organization'
                    ),
                    {
                        text: 'Activity Organization Sub-source Path',
                        value: 'aeSsOrgId_subSourcePath',
                        type: 'string',
                    },
                    {
                        text: 'Activity Organization ID',
                        value: 'aeSsOrgId',
                        type: 'string',
                        default: ''
                    },
                    {
                        text: 'Start Date',
                        value: 'startDate',
                        type: 'date',
                        allowRelativeDate: true
                    },
                    {
                        text: 'End Date',
                        value: 'endDate',
                        type: 'date',
                        allowRelativeDate: true
                    },
                    {
                        text: 'Dialog Settings',
                        value: 'scheduleDialogSettings',
                        type: 'object',
                        properties: {
                            title: {
                                type: 'string',
                                label: 'Dialog Title',
                                helpText: 'Title of dialog.',
                                id: 'title',
                                default: 'Task'
                            },
                            size: {
                                type: 'string',
                                label: 'Size',
                                id: 'size'
                            },
                            cssClass: {
                                type: 'string',
                                label: 'CSS Class',
                                id: 'cssClass'
                            },
                            okButtonLabel: {
                                type: 'string',
                                label: 'Ok Button Label',
                                id: 'closeOnEscape',
                                default: 'Ok'
                            },
                            okButtonCssClass: {
                                type: 'string',
                                label: 'Ok Button CSS Class',
                                id: 'okButtonCssClass',
                            },
                            cancelButtonLabel: {
                                type: 'string',
                                label: 'Cancel Button Label',
                                id: 'cancelButtonLabel',
                                default: 'Cancel'
                            },
                            cancelButtonCssClass: {
                                type: 'string',
                                label: 'Cancel Button CSS Class',
                                id: 'cancelButtonCssClass',
                            },
                            closeOnEscape: {
                                type: 'boolean',
                                label: 'Allow Closing on Escape',
                                id: 'closeOnEscape',
                                default: true
                            }
                        },
                        default: {}
                    },
                    {
                        text: 'Maximum Shift Signup',
                        value: 'maxShiftSignup',
                        type: 'number',
                        default: 1
                    },
                    {
                        text: 'Is Rescheduling Modal',
                        value: 'rescheduleEnabled',
                        type: 'boolean',
                        default: false
                    },
                    {
                        text: 'Enable the "more" and "details" links',
                        value: 'enableMoreLinks',
                        type: 'boolean',
                        default: false
                    },
                    /* {
                        text: 'Recruiter ID',
                        value: 'recruiterID',
                        type: 'string',
                        default: ''
                    } */
                ]
            },
            {
                text: 'Switch Between Instance And Local',
                value: 'switchBetweenInstanceAndLocal',
                availableForInstance: ['DEVDASH', 'DEVDASHQA'],
                params: []
            },
            {
                text: 'Open Profile',
                value: 'openProfile',
                availableForPsp: ['vol', 'opp', 'org', 'mem', 'ae', 'ctr'],
                params: [
                    {
                        text: 'Perspective',
                        value: 'recordPsp',
                        type: 'dropdown',
                        items: [
                            { text: 'Volunteer', value: 'vol' },
                            { text: 'Opportunity', value: 'opp' },
                            { text: 'Organization', value: 'org' },
                            { text: 'Client', value: 'mem' },
                            { text: 'Activity', value: 'ae' },
                            { text: 'Contact Record', value: 'ctr' },
                            { text: 'Source Record', value: 'source' }
                        ],
                        fields: { text: 'text', value: 'value' },
                        default: 'vol'
                    },
                    createRecordSourceControl('recordId',
                        ['source', 'contextVolId', 'contextOppId', 'contextOrgId', 'selectable', 'fixed'],
                        ['VOLUNTEER_ID', 'rowID', 'OPPORTUNITY_ID', 'ORGANIZATION_ID']),
                    {
                        text: 'Record ID',
                        value: 'recordId',
                        type: 'string',
                        default: '',
                        display: false
                    }
                ]
            },
            {
                text: 'Generate Quicklink',
                value: 'generateQuicklink'
            },
            {
                text: 'Test Action',
                value: 'testAction',
                params: [
                    {
                        text: 'Dropdown Param',
                        value: 'param1',
                        type: 'dropdown',
                        items: ['val1', 'val2'],
                        default: 'val1'
                    }, {
                        text: 'Boolean Param',
                        value: 'param2',
                        type: 'boolean',
                        default: true
                    }, {
                        text: 'String Param',
                        value: 'param3',
                        type: 'string',
                        default: 'A String'
                    }, {
                        text: 'Number Param',
                        value: 'param4',
                        type: 'number',
                        default: 555
                    }, {
                        text: 'Offset Value By',
                        value: 'offset',
                        type: 'number',
                        display: true,
                        default: 1,
                        helpText: 'This will offset the current value by the amount entered.'
                    }, {
                        text: 'Toggle Value',
                        value: 'testToggleBoolean',
                        type: 'boolean',
                        display: true,
                        default: true,
                        helpText: 'This will toggle the value for this property.'
                    }
                ]
            },
        ],
        requiredParams: {
            openComponentDialog: [
                {
                    text: 'Component Id',
                    type: 'string',
                    key: 'componentId'
                }
            ],
            getProfileFields: [
                {
                    text: 'Perspective',
                    type: 'psp',
                    key: 'psp'
                }, {
                    text: 'Record ID',
                    type: 'records',
                    key: 'recordId'
                }, {
                    text: 'Fields',
                    type: 'fields',
                    key: 'fields',
                    allowMultiple: true
                }
            ],
            openRecruiterForm: [
                {
                    text: 'Form Name',
                    type: 'string',
                    key: 'formName'
                }
            ],
            closeDialog: [
                {
                    text: 'Dialog to Close',
                    type: 'dropdown',
                    key: 'dialogId'
                },
                {
                    text: 'Close As',
                    type: 'dropdown',
                    key: 'closeAs'
                }
            ],
            sendEST: [
                {
                    text: 'Email Template',
                    type: 'dropdowntree',
                    key: 'estId'
                },
                {
                    text: 'Record ID',
                    type: 'records',
                    key: 'recordId'
                }
            ],
            playYouTubeVideo: [
                {
                    text: 'Video URL',
                    type: 'string',
                    key: 'videoUrl'
                }
            ],
            uploadAttachments: [
                {
                    text: 'Perspective',
                    type: 'psp',
                    key: 'psp'
                },
                {
                    text: 'Upload Files',
                    type: 'dropdowntree',
                    key: 'attachIds'
                },
                {
                    text: 'Record ID',
                    type: 'records',
                    key: 'recordId'
                }
            ],
            updateProfileField: [
                {
                    text: 'Perspective',
                    type: 'psp',
                    key: 'psp'
                }, {
                    text: 'Record ID',
                    type: 'records',
                    key: 'recordId'
                }, {
                    text: 'Fields',
                    type: 'fields',
                    key: 'field'
                }, {
                    text: 'Values',
                    type: 'values',
                    key: 'value'
                }
            ],
            updateProfileFields: [
                {
                    text: 'Perspective',
                    type: 'psp',
                    key: 'psp'
                }, {
                    text: 'Record ID',
                    type: 'records',
                    key: 'recordId'
                }, {
                    label: 'Provide Field Information',
                    message: 'Please provide the necessary field information below.',
                    key: 'fields',
                    type: 'array',
                    itemConfig: {
                        permissions: {
                            canMove: false,
                            canDelete: false,
                            allowAddItem: false
                        },
                        hiddenKeys: ['field']
                    },
                    hideActions: true,
                    hideHeaders: true,
                    expandAll: true,
                    requiredSubKeys: ['value'],
                }
            ],
            // updateMultipleFields: [
            //     {
            //         text: 'Perspective',
            //         type: 'psp',
            //         key: 'psp'
            //     }, {
            //         text: 'Record ID',
            //         type: 'records',
            //         key: 'recordId'
            //     },
            //     // TODO: Verify type should be value
            //     {
            //         text: 'Fields',
            //         type: 'value',
            //         key: 'fields'
            //     }
            // ],
            runBackgroundCheck: [
                {
                    text: 'Background Check Record',
                    type: 'records',
                    key: 'recordId',
                    defaults: {
                        psp: 'vol'
                    }
                }, {
                    text: 'Background Check Package',
                    type: 'package',
                    key: 'packageID',
                    packageType: 'bcCheck'
                }
            ],
            editAutomation: [
                {
                    text: 'Automation ID',
                    type: 'package',
                    key: 'automationID',
                    packageType: 'automation'
                }
            ],
            deleteAutomation: [
                {
                    text: 'Automation ID',
                    type: 'package',
                    key: 'automationID',
                    packageType: 'automation'
                }
            ],
            runAutomation: [
                {
                    text: 'Automation ID',
                    type: 'package',
                    key: 'automationID',
                    packageType: 'automation'
                }, {
                    text: 'Record ID',
                    type: 'records',
                    key: 'recordId'
                }
            ],
            deleteAssignment: [
                {
                    text: 'Assignment ID',
                    type: 'number',
                    key: 'assignmentID',
                }
            ],
            updateAffiliation: [
                {
                    text: 'Affiliation ID',
                    type: 'number',
                    key: 'affID',
                }
            ],
            renewActivity: [
                {
                    text: 'Volunteer ID',
                    type: 'records',
                    key: 'volId',
                    defaults: {
                        psp: 'vol'
                    }
                },
                {
                    text: 'Activity Id',
                    type: 'dropdown',
                    key: 'activityId'
                }
            ],
            resetWorkflow: [
                {
                    text: 'Assignment ID',
                    type: 'number',
                    key: 'assignmentId',
                },
                {
                    text: 'Workflow',
                    type: 'dropdown',
                    itemsSource: 'configStore.getWorkflowList()',
                    fields: {
                        text: 'WORKFLOW_TITLE',
                        value: 'WORKFLOW_ID'
                    },
                    key: 'workflowId',
                },
                {
                    text: 'Status',
                    type: 'dropdown',
                    key: 'newAssignmentStatus',
                    itemsSource: 'configStore.attrListOptions("assignment")',
                    additionalOptions: [
                        { text: 'Empty', value: -1, absoluteOptionPosition: 0 },
                    ],
                    fields: {
                        text: 'text',
                        value: 'value'
                    }
                },
                {
                    text: 'Status',
                    type: 'dropdown',
                    key: 'newWorkflowStatus',
                    items: [
                        { text: 'Completed', value: 'Completed' },
                        { text: 'In Progress', value: 'In Progress' },
                        { text: 'Not Started', value: 'Not Started' },
                        { text: 'Waiting', value: 'Waiting' },
                    ],
                    fields: {
                        text: 'text',
                        value: 'value'
                    }
                }
            ],
            updateWorkflowStatus: [
                {
                    text: 'Assignment ID',
                    type: 'number',
                    key: 'assignmentId',
                },
                {
                    text: 'Workflow',
                    type: 'dropdown',
                    itemsSource: 'configStore.getWorkflowList()',
                    fields: {
                        text: 'WORKFLOW_TITLE',
                        value: 'WORKFLOW_ID'
                    },
                    key: 'workflowId',
                },
                {
                    text: 'Status',
                    type: 'dropdown',
                    key: 'workflowStatus',
                    items: [
                        { text: 'Completed', value: 'Completed' },
                        { text: 'In Progress', value: 'In Progress' },
                        { text: 'Not Started', value: 'Not Started' },
                        { text: 'Waiting', value: 'Waiting' },
                    ],
                    fields: {
                        text: 'text',
                        value: 'value'
                    }
                }
            ],
            openBackgroundCheckReview: [],
            createUpdateShift: [],
            openEmail: [
                {
                    text: 'Perspective',
                    type: 'psp',
                    key: 'psp'
                }, {
                    text: 'Record ID',
                    type: 'records',
                    key: 'recordId',
                }
            ],
            openLogBookEntry: [
                {
                    text: 'Logbook Entry ID',
                    type: 'lbeID',
                    key: 'lbeID'
                }
            ],
            openSurvey: [
                {
                    text: 'Record ID',
                    type: 'records',
                    key: 'recordId',
                    defaults: { psp: 'vol' }
                },
                {
                    text: 'Select Survey',
                    type: 'package',
                    key: 'packageID',
                    packageType: 'survey'
                }
            ],
            openWaiver: [
                {
                    text: 'Record ID',
                    type: 'records',
                    key: 'recordId',
                    defaults: { psp: 'vol' }
                },
                {
                    text: 'Select Waiver',
                    type: 'package',
                    key: 'packageID',
                    packageType: 'waiver'
                }
            ],
            openTraining: [
                {
                    text: 'Record ID',
                    type: 'records',
                    key: 'recordId',
                    defaults: { psp: 'vol' }
                },
                {
                    text: 'Select Survey',
                    type: 'package',
                    key: 'packageID',
                    packageType: 'training'
                }
            ],
            deleteShift: [
                {
                    text: 'Slot Record ID',
                    type: 'records',
                    key: 'slotId',
                    defaults: { psp: 'sch' }
                },
            ],
            refPlace: [
                {
                    text: 'Vol Record ID',
                    type: 'records',
                    key: 'volIds',
                    allowMultiple: true,
                    defaults: { psp: 'vol' }
                },
            ],
            unRefPlace: [
                {
                    text: 'Vol Record ID',
                    type: 'records',
                    key: 'volIds',
                    allowMultiple: true,
                    defaults: { psp: 'vol' }
                }
            ],
            createLbe: [
                {
                    text: 'Vol ID',
                    type: 'records',
                    key: 'volId',
                    reject0: true,
                    defaults: { psp: 'vol' }
                },
                {
                    text: 'Select Survey',
                    type: 'package',
                    key: 'surveyId',
                    packageType: 'survey'
                }
            ],
            openUrl: [
                // No parameters can be defined by wizard for this action
            ],
            affiliateRecord: [
                {
                    text: 'Vol ID',
                    type: 'records',
                    key: 'volId',
                    reject0: true,
                    defaults: { psp: 'vol' }
                }, {
                    text: 'Org ID',
                    type: 'records',
                    key: 'orgId',
                    reject0: true,
                    defaults: { psp: 'org' }
                }
            ],
            createAssignment: [
                {
                    text: 'Vol ID',
                    type: 'records',
                    key: 'volId',
                    reject0: true,
                    defaults: { psp: 'vol' }
                }, {
                    text: 'Endpoint ID',
                    key: 'endpointID',
                    reject0: true
                }
            ],
            openTab: [
                {
                    text: 'Perspective',
                    type: 'psp',
                    key: 'psp'
                },
                {
                    text: 'Grid ID',
                    type: 'record',
                    optional: true,
                    key: 'gridId'
                },
                {
                    text: 'Filter ID',
                    type: 'record',
                    optional: true,
                    key: 'filterId'
                }
            ],
            openAddhours: [
                {
                    text: 'Volunteer ID',
                    type: 'records',
                    key: 'recordId',
                    optional: true,
                    defaults: { psp: 'vol' }
                }
            ],
            openPdf: [
                {
                    text: 'Volunteer ID',
                    type: 'records',
                    key: 'volId',
                    optional: true,
                    defaults: { psp: 'vol' }
                },
                {
                    text: 'Opportunity ID',
                    type: 'records',
                    key: 'oppId',
                    optional: true,
                    defaults: { psp: 'opp' }
                }
            ],
            openLMSModule: [
                {
                    text: 'LMS Module URL',
                    type: 'string',
                    key: 'lmsModuleURL',
                    defaults: {}
                }
            ],
            openSchedulingModal: [
                {
                    text: 'Shift Record Type',
                    type: 'dropdown',
                    key: 'shiftRecordType',
                    defaults: {}
                }, {
                    text: 'Record ID',
                    type: 'string',
                    key: 'recordId',
                    defaults: {}
                }, {
                    text: 'Volunteer ID',
                    type: 'string',
                    key: 'volId',
                    defaults: {}
                }
            ],
            openProfile: [
                {
                    text: 'Perspective',
                    type: 'psp',
                    key: 'recordPsp'
                },
                {
                    text: 'Record ID',
                    type: 'records',
                    key: 'recordId',
                    optional: true,
                    defaults: {}
                }
            ],
            createComponent: [
                {
                    text: 'Component Title',
                    type: 'string',
                    key: 'cTitle',
                    default: 'New Component',
                    optional: true
                },
                {
                    type: 'string',
                    key: 'cId',
                    text: 'Component ID',
                    default: 'componentId1',
                    optional: true
                },
                {
                    type: 'boolean',
                    key: 'isPublic',
                    text: 'Component Is Public',
                    default: false,
                    optional: true
                },
                {
                    type: 'boolean',
                    key: 'createFromCopy',
                    text: 'Copy Existing Component?',
                    default: false,
                    helpText: 'Select the component you want to copy.',
                    optional: true
                },
                {
                    type: 'dropdown',
                    key: 'cType',
                    itemsSource: 'componentStore.getTypes()',
                    text: 'Component Type',
                    required: true,
                    helpText: 'Type of component that you want to create.',
                    default: false
                },
                {
                    type: 'dropdown',
                    key: 'componentToCopy',
                    itemsSource: 'componentStore.getList(true)',
                    itemsFilter: '!this.component.output.cType || this.component.output.cType === this.item.cType',
                    filterType: 'contains',
                    fields: { text: 'cId', value: 'cId' },
                    logic: [
                        {
                            record: 'self',
                            prop: 'display',
                            valueType: 'criteria',
                            criteria: 'this.controls.createFromCopy.value === true'
                        }
                    ],
                    text: 'Component To Copy',
                    required: true,
                    helpText: 'Select the component you want to copy.',
                    optional: true
                }
            ],
            createDataset: [
                {
                    text: 'Perspective',
                    type: 'psp',
                    key: 'psp'
                }
            ],
        },
        canBeUsedAsItemsSource: [
            'getActionOptions'
        ],
        globalMethods: []
    },
    getters: {
        getActionOptions(state) {
            return function (payload) {
                let [forPsp] = Object.values(payload);
                let tmpActionOptions = [];
                if (forPsp && !Array.isArray(forPsp)) forPsp = [forPsp];
                for (let i in state.actionOptions) {
                    let includeAction = true;
                    let iAvailPsp = state.actionOptions[i].availableForPsp;
                    let iAvailInstance = state.actionOptions[i].availableForInstance;
                    if (forPsp && Array.isArray(iAvailPsp)) {
                        includeAction = forPsp.some((iPsp) => iAvailPsp.includes(iPsp));
                    }
                    if (includeAction && Array.isArray(iAvailInstance)) {
                        includeAction = iAvailInstance.includes(configStore.getCurrentInstanceDetails(true).instanceName);
                    }
                    if (includeAction) tmpActionOptions.push(state.actionOptions[i]);
                }
                tmpActionOptions.sort((a, b) => a.text.localeCompare(b.text));
                return tmpActionOptions;
            };
        }
    },
    actions: {
        executeGlobalMethod({ state, commit, dispatch }, payload) {
            let [cType, method, args, storeId] = Object.values(payload);
            if (typeof args !== 'object') args = [];
            if (!state.globalMethods || !state.globalMethods[cType]) return null;
            if (storeId) {
                if (state.globalMethods[cType][storeId] && typeof state.globalMethods[cType][storeId][method] === 'function') {
                    return state.globalMethods[cType][storeId][method].apply(null, args);
                }
                return null;
            }
            // if !storeId try to find method using tmpStoreId
            for (let tmpStoreId in state.globalMethods[cType]) {
                if (tmpStoreId === 'length') continue;
                if (
                    !state.globalMethods[cType][tmpStoreId]
                    || typeof state.globalMethods[cType][tmpStoreId][method] !== 'function'
                ) continue;
                return state.globalMethods[cType][tmpStoreId][method].apply(null, args);
            }
            return null;
        },
        async iframeProcessSubmit(submitAction, params, windowWidth, windowHeight) {
            let instance = await configStore.getDevDashLocalInstanceDetails();
            let tmpProjectsUrl = instance && instance.url ? instance.url : PROJECTS_URL;
            let tmpUrl = tmpProjectsUrl + '/coordinator/index.php?actionStore&act=' + params.actVal + (instance.sId ? '&copyPHPSESSID=' + instance.sId : '');
            if (submitAction === 'customUrl' && params.url) {
                tmpUrl = params.url;
                if (params.needResponse) tmpUrl += '&needResponse=1&prevWinName=' + window.name;
                if (params.aeID) tmpUrl += '&ACTIVITY_ENTITY_ID=' + params.aeID;
                if (params.affID) tmpUrl += '&AFFILIATION_ID=' + params.affID;
            } else {
                if (params.psp) tmpUrl += '&pspID=' + params.psp;
                if (params.needResponse) tmpUrl += '&needResponse=1&prevWinName=' + window.name;
                if (submitAction !== 'openTab') tmpUrl += '&selectedID=' + params.recordId;
                if (params.actVal === 'new_logbook_training') tmpUrl += '&trainingID=' + params.trainingID;
                if (submitAction === 'newLBE') {
                    if (params.oppID) tmpUrl += '&oppID=' + params.oppID;
                    if (params.packageID) tmpUrl += '&packageID=' + params.packageID;
                    if (params.aeID) tmpUrl += '&ACTIVITY_ENTITY_ID=' + params.aeID;
                    if (params.affID) tmpUrl += '&AFFILIATION_ID=' + params.affID;
                    if (params.assignmentID) tmpUrl += '&assignmentID=' + params.assignmentID;
                }
                if (submitAction === 'editAutomation') {
                    if (params.aeID && parseInt(params.aeID, 10) > 0) tmpUrl += '&aeID=' + params.aeID;
                }
                if (submitAction === 'openTab') {
                    if (params.gridId) tmpUrl += '&gridID=' + params.gridId;
                    if (params.filterId) tmpUrl += '&filterID=' + params.filterId;
                }
                if (submitAction === 'createUpdateShift') {
                    let slotId = params.schID;
                    let recordId = slotId.length > 8
                        ? slotId.substring(0, slotId.length - 6)
                        : slotId;
                    if (params.schID) tmpUrl += '&recordID=' + recordId;
                    if (params.oppID) tmpUrl += '&opportunityID=' + params.oppID;
                    if (params.aeID) tmpUrl += '&activityEntityID=' + params.aeID;
                    if (params.aeOrgID) tmpUrl += '&activityEntityOrganizationID=' + params.aeOrgID;
                    let selectedDate;
                    if (params.actVal === 'editSlot') {
                        if (slotId && slotId.length > 8) {
                            let slotDate = slotId.substring(slotId.length - 6, slotId.length);
                            let year = slotDate.substring(0, 2);
                            let month = slotDate.substring(2, 4);
                            let day = slotDate.substring(4, 6);
                            year = '20' + year;
                            selectedDate = `${year}-${month}-${day}`;
                        } else {
                            if (params.selectedDate) {
                                selectedDate = params.selectedDate;
                            } else {
                                selectedDate = moment().format("YYYY-MM-DD");
                            }
                        }
                    }
                    tmpUrl += '&selectedDate=' + selectedDate;
                }
                if (!windowWidth) windowWidth = params.width || 1000; // NOSONAR
                if (!windowHeight) windowHeight = params.height || 1000; // NOSONAR
                if (params.isMainGrid) {
                    tmpUrl += '&isMainGrid=true';
                    if (typeof params.vueOnePageDesign === 'undefined' || params.vueOnePageDesign) {
                        tmpUrl += '&vueOnePageDesign=true';
                    }
                }
                if (params.vueOnePageDesign) tmpUrl += '&vueOnePageDesign=true';
                if (params.prevWindowName) tmpUrl += '&prevWindowName=' + params.prevWindowName;
                if (params.fromTopMenu) {
                    tmpUrl += '&fromTopMenu=true';
                }
                if (params.backendAct) {
                    tmpUrl += '&_backendAct=' + params.backendAct;
                }
            }
            let response = {};
            if (params.openInSameWindow) {
                let winOpener = window;
                let dialogComponentObj;
                let dialogComponent = {
                    name: 'iframe-' + params.actVal,
                    template: `
                        <div :id="'frameWrapper_' + params.actVal" style="height: 100%;"><div class='new-window-icon'>
                        <button v-if="!hideOpenInNewWindow" @click="click" class="e-dlg-closeicon-btn e-control e-btn e-lib e-flat e-icon-btn"
                                type="button" title="Open In New Window" aria-label="Open In New Window"
                                data-ripple="true"><span class="e-icons e-open-link"></span></button>
                        </div>
                        <iframe v-if="src" id="${params.actVal}" :name="windowName" :src="src" class="same-window-iframe"
                            vspace="0" hspace="0"
                            @load="stopload"></iframe></div>
                    `,
                    data() {
                        return {
                            src: null,
                            submitAction: submitAction,
                            params: params,
                            windowWidth: windowWidth,
                            windowHeight: windowHeight,
                            hideOpenInNewWindow: params.hideOpenInNewWindow,
                            windowName: (params.windowName || params.actVal)
                        };
                    },
                    created() {
                        dialogComponentObj = this;
                        library.showLoadingIndicator('frameWrapper_' + this.params.actVal);
                    },
                    methods: {
                        dialogOpened() {
                            this.src = tmpUrl;
                        },
                        stopload(tmpEvent) {
                            if (typeof tmpEvent?.currentTarget?.contentWindow !== 'undefined') {
                                tmpEvent.currentTarget.contentWindow.opener = winOpener;
                                if (typeof tmpEvent.currentTarget.contentWindow.pushWindow === 'function') tmpEvent.currentTarget.contentWindow.pushWindow(winOpener.name);
                            }
                            library.hideLoadingIndicator('frameWrapper_' + this.params.actVal);
                            library.hideLoadingIndicator('main');
                            let thisFrame = window.frames[this.windowName];
                            if (this.params.addECCss) {
                                let link = document.createElement('link');
                                link.setAttribute('rel', 'stylesheet');
                                link.setAttribute('href', PROJECTS_URL + '/coordinator/xsl/css/coordinator.css');
                                document.head.appendChild(link);
                            }
                            if (typeof VUE_PROJECT_NAME !== 'undefined' && VUE_PROJECT_NAME === 'recruiterBridge') {
                                // Close the dialog if it's the report again screen
                                // if (!reportFrameBody.classList.contains('profile')) {
                                // If <body class="profile log_book_entry"> iframe contents is not "report again"
                                // clearInterval(hideElemsInterval);
                                // library.hideDialog(this.params.actVal, true);
                                // }
                                // add recruiter CSS
                                let cstoolsUrl = typeof CSTOOLS_URL !== 'undefined'
                                    ? CSTOOLS_URL
                                    : 'https://cstools.samaritan.com/';
                                let reportServiceCss = document.createElement('link');
                                reportServiceCss.setAttribute('rel', 'stylesheet');
                                reportServiceCss.setAttribute('href', cstoolsUrl + '/css/report_service_styles.css');
                                if (thisFrame.document.head) thisFrame.document.head.appendChild(reportServiceCss);
                                let hideElemsInterval = setInterval(() => {
                                    if (thisFrame.document.body) {
                                        // eslint-disable-next-line max-len
                                        let elems = thisFrame.document.body.querySelectorAll('input[name="ok_button"], input[id="cancel"], input[name="cancel_button"], input[name="submit_button"], input[name="Save_Button"], input[name="Cancel_Button"], #make_another_entry_link, #make_another_entry_button');
                                        elems.forEach((elem) => {
                                            elem.style.display = 'none';
                                            setTimeout(() => {
                                                clearInterval(hideElemsInterval);
                                            }, 500);
                                        });
                                    }
                                }, 50, 200);
                            }
                            if (thisFrame) {
                                thisFrame.close = () => {
                                    library.hideDialog(this.params.actVal, false, false, false, thisFrame);
                                };
                            }
                            if (thisFrame.document
                                && thisFrame.document.body
                                && thisFrame.document.body.innerHTML === ''
                                && thisFrame.document.head.innerHTML.indexOf('window.close()')
                            ) {
                                library.hideDialog(this.params.actVal, false, false, false, thisFrame);
                            }
                            setTimeout(() => {
                                library.hideLoadingIndicator('frameWrapper_' + params.actVal);
                            }, 1000);
                        },
                        click() {
                            let params = this.params;
                            delete params.openInSameWindow;
                            params.vueOnePageDesign = false;
                            params.prevWindowName = window.name;
                            library.hideDialog(this.params.actVal);
                            setTimeout(() => {
                                actionStore.actions.iframeProcessSubmit(this.submitAction, params, this.windowWidth, this.windowHeight);
                            }, 1000);
                        }
                    }
                };
                let cssClass = "hide-footer iframe-popup";
                if (params.cssClass) cssClass += ' ' + params.cssClass;
                cssClass = cssClass.trim();
                let opt = {
                    name: params.actVal,
                    width: windowWidth,
                    height: windowHeight,
                    title: " ",
                    cssClass: cssClass,
                    showNewWindowIcon: true,
                    resizeDialogToIframeHeight: params.actVal,
                    resizeDialogToIframeWidth: params.actVal,
                    preventCloseOnBackdropClick: params.preventCloseOnBackdropClick,
                    funcOnOpen: () => {
                        library.showLoadingIndicator('frameWrapper_' + params.actVal);
                    }
                };
                if (params?.dialogSettings) {
                    if (typeof params?.dialogSettings?.title !== 'undefined') opt.title = params.dialogSettings.title;
                    if (typeof params?.dialogSettings?.size !== 'undefined') opt.size = params.dialogSettings.size;
                    if (typeof params?.dialogSettings?.width !== 'undefined') opt.width = params.dialogSettings.width;
                    if (typeof params?.dialogSettings?.height !== 'undefined') opt.height = params.dialogSettings.height;
                    if (typeof params?.dialogSettings?.cssClass !== 'undefined') opt.cssClass = params.dialogSettings.cssClass;
                    if (typeof params?.dialogSettings?.okButtonLabel !== 'undefined') opt.okButtonLabel = params.dialogSettings.okButtonLabel;
                    if (typeof params?.dialogSettings?.okButtonCssClass !== 'undefined') opt.okButtonCssClass = params.dialogSettings.okButtonCssClass;
                    if (typeof params?.dialogSettings?.cancelButtonLabel !== 'undefined') opt.cancelButtonLabel = params.dialogSettings.cancelButtonLabel;
                    if (typeof params?.dialogSettings?.cancelButtonCssClass !== 'undefined') opt.cancelButtonCssClass = params.dialogSettings.cancelButtonCssClass;
                    if (typeof params?.dialogSettings?.closeOnEscape !== 'undefined') opt.closeOnEscape = params.dialogSettings.closeOnEscape;
                }
                if (typeof VUE_PROJECT_NAME !== 'undefined' && VUE_PROJECT_NAME === 'recruiterBridge') {
                    opt.okButtonFunction = async function () {
                        let thisFrame = window.frames[params.actVal];
                        if (!thisFrame || typeof thisFrame.profile_doAction !== 'function') return { status: 'failure' };
                        if (typeof thisFrame?.document?.forms?.['profileForm'] !== 'undefined') {
                            thisFrame.onbeforeunload = () => {
                                library.showLoadingIndicator('frameWrapper_recruiter_survey_iframe', false, 'Please wait while your document is submitted, do not refresh the page.', 'spinner-with-background');
                            };
                        }
                        thisFrame.profile_doAction('ok');
                        let promise = new Promise((resolve) => {
                            let tmpInterval = setInterval(() => {
                                let reportFrameBody = thisFrame.document.body;
                                // Close the dialog if it's the report again screen
                                if (reportFrameBody && !reportFrameBody.classList.contains('profile')) {
                                    // If <body class="profile log_book_entry"> iframe contents is not "report again"
                                    clearInterval(tmpInterval);
                                    resolve({ status: 'success' });
                                }
                            }, 100, 200); // 20 seconds
                        });
                        return promise;
                    };
                }
                if (params.doLocalAction) {
                    opt['doLocalAction'] = params.doLocalAction;
                }
                if (opt['cssClass'].indexOf('show-only-content-popup') === -1) opt['cssClass'] = 'hide-cancel';
                response.dialogResponse = await library.showDialog(
                    dialogComponent,
                    () => {
                        response.status = 'success';
                    },
                    () => {
                        response.status = 'failure';
                    },
                    opt,
                    false,
                    false,
                    function () {
                        if (typeof dialogComponentObj?.dialogOpened === 'function') dialogComponentObj.dialogOpened();
                    }
                );
            } else {
                let openedWindow;
                tmpUrl += '&openedInNewWindow=1';
                // Wait for any existing windows from chained actions to close
                setTimeout(() => {
                    openedWindow = window.open(tmpUrl, submitAction, 'scrollbars=yes,resizable=yes,width=' + windowWidth + ',height=' + windowHeight + ',status=yes,top=100,left=100');
                }, 500);
                if (params.needResponse) {
                    response = await new Promise((resolve) => {
                        const timer = setInterval(() => {
                            if (openedWindow && openedWindow.closed) {
                                clearInterval(timer);
                                setTimeout(() => {
                                    // Make sure we don't run this before the message listener
                                    resolve({ status: 'failure' });
                                }, 400);
                            }
                        }, 500);
                        let responseListener = (response) => {
                            if (response && response.data && typeof response.data === 'object' && response.data.childWindowResponse) {
                                clearInterval(timer);
                                resolve(response.data.childWindowResponse);
                                removeEventListener('message', responseListener);
                            }
                        };
                        window.addEventListener('message', responseListener, false);
                    });
                    if (typeof params.doLocalAction === 'function') {
                        params.doLocalAction(params.actVal, response);
                    }
                } else {
                    response.status = 'success';
                }
            }
            return response;
        },
        async checkParams(params, action, paramMixins, dialogOptions) {
            // requiredParams takes key:value pair where key is match to type of function in getParam obj below,
            // and value is output param used by calling function
            let component;
            let mappedRecord;
            if (!params || (Array.isArray(params) && !params.length)) params = {};
            if (typeof params === 'object' && params.component) ({ component, mappedRecord, ...params } = params);
            params = library.cloneObj(params);
            if (!dialogOptions) dialogOptions = {};
            let output = params;
            let requiredParams = library.cloneObj(actionStore.state.requiredParams[action]);
            let requiredParamsKeys = [];
            for (let i in requiredParams) {
                requiredParamsKeys.push(requiredParams[i].key);
            }
            let actionOption = actionStore.state.actionOptions.find((iAction) => iAction.value === action);
            if (params && params.showInDialog && actionOption && actionOption.params) {
                for (let i in actionOption.params) {
                    if (requiredParamsKeys.indexOf(actionOption.params[i].value) !== -1 || !params.showInDialog[actionOption.params[i].value]) continue;
                    if (params.showInDialog[actionOption.params[i].value]) {
                        let tmpParam = library.cloneObj(actionOption.params[i]);
                        tmpParam.key = tmpParam.value;
                        tmpParam.optional = true;
                        delete tmpParam.value;
                        requiredParams.push(tmpParam);
                    }
                }
            }
            let paramControls = {};
            let isEmptyParam = (paramVal, param) => {
                if (param.type === 'array' && Array.isArray(paramVal) && Array.isArray(param.requiredSubKeys)) {
                    let hasEmptyParam = false;
                    // iterate array of value objects
                    paramVal.forEach((iParamVal) => {
                        // Check all requiredSubKeys for filled values
                        param.requiredSubKeys.forEach((pSubKey) => {
                            let iKeyVal = iParamVal[pSubKey];
                            if (!iKeyVal && iKeyVal !== false) hasEmptyParam = true;
                        });
                    });
                    return hasEmptyParam;
                }
                return typeof paramVal === 'undefined'
                || (!paramVal && paramVal !== false)
                || (param.reject0 && paramVal === 0);
            };
            let getSteps = (excludeOptional) => (requiredParams
                && Array.isArray(requiredParams)
                && requiredParams
                    .filter((param) => (!excludeOptional || !param.optional) && isEmptyParam(output[param.key], param))
                    .map((param) => {
                        let controlConfig = actionOption.params.find((pConfig) => param.key === pConfig.value);
                        controlConfig = library.cloneObj(controlConfig);
                        library.mergeObj(controlConfig, param);
                        // push the param into the UI
                        controlConfig.removeOnDestroy = true;
                        let controlName = controlConfig.value;
                        if (paramMixins && paramMixins[controlName]) {
                            for (let i in paramMixins[controlName]) {
                                if (i === 'length') continue;
                                controlConfig[i] = paramMixins[controlName][i];
                            }
                        }
                        if (typeof controlConfig.label === 'undefined') controlConfig.label = controlConfig.text;
                        if (typeof controlConfig.onchange === 'undefined') controlConfig.onchange = 'setOutputObj';
                        if (typeof controlConfig.id === 'undefined') controlConfig.id = controlName;
                        // Adjust param logic
                        if (Array.isArray(controlConfig.logic)) {
                            controlConfig.logic.forEach((iRule) => {
                                // Remove the param index because the dialog is not part of the chaining
                                if (typeof iRule.criteria === 'string') iRule.criteria = iRule.criteria.replace(/param___index___/g, '');
                            });
                        }
                        paramControls[controlName] = controlConfig;
                        param.controlName = controlName;
                        return param;
                    })) || [];
            let steps = getSteps();
            // eslint-disable-next-line consistent-return
            let getParamWizard = async () => new Promise((resolve) => {
                let dialogRequired = steps.length;
                // Open dialog
                if (!dialogRequired) return resolve('done');
                let showParamWizard = true;
                let processClose = () => {
                    showParamWizard = false;
                };
                let processSuccess = () => {
                    let finalSteps = getSteps(true);
                    if (!finalSteps.length) resolve('done');
                };
                let tmpDialogName = 'actionParamsDialog' + library.getUniqueID();
                let paramsDialogTemplate = {
                    name: tmpDialogName,
                    template: `<div v-if="showParamWizard && steps && steps.length">
                        <action-param-wizard c-id="actionParamWizard" 
                             :prop-param-controls="paramControls"
                             :prop-param-values="paramValues" 
                             :prop-show-all-steps="showAllSteps"
                             :prop-submit-button-label="submitButtonLabel"
                             @update:prop-param-values="paramValues = $event" 
                             :prop-required-params="requiredParams"
                             :prop-steps="steps"
                             :prop-action="action"
                             :wizard-complete="wizardComplete"
                             :context-dialog-id="ctxDialogId"
                        ></action-param-wizard>
                    </div>`,
                    data() {
                        return {
                            showParamWizard: true,
                            paramControls: paramControls,
                            paramValues: params,
                            requiredParams: requiredParams,
                            steps: steps,
                            showAllSteps: actionOption.showAllSteps || false,
                            submitButtonLabel: dialogOptions.submitButtonLabel || actionOption.submitButtonLabel || false,
                            wizardComplete: false,
                            ctxDialogId: tmpDialogName,
                            action: action
                        };
                    },
                    updated() {
                        output = library.cloneObj(this.paramValues);
                    },
                    mounted() {
                        let interval = setInterval(() => {
                            if (showParamWizard !== this.showParamWizard) {
                                this.showParamWizard = showParamWizard;
                                clearInterval(interval);
                            }
                        }, 500); // NOSONAR
                    },
                    components: {
                        'actionParamWizard': defineAsyncComponent(() => import('@common/actionParamWizard.vue'))
                    }
                };
                return library.showDialog(paramsDialogTemplate, processSuccess, false, {
                    title: dialogOptions.dialogTitle || actionOption.dialogTitle || 'Provide Additional Information',
                    name: tmpDialogName,
                    okButtonCssClass: 'hide',
                    cancelButtonCssClass: 'hide',
                    preventCloseOnBackdropClick: true,
                    closeAfterSeconds: 1
                }, false, processClose);
            });
            if (typeof IS_JEST === 'undefined') await getParamWizard();
            // Check Steps again
            if (requiredParams) {
                requiredParams.forEach((param) => {
                    if (isEmptyParam(output[param.key], param) && !param.optional) output[param.key] = 'isMissing';
                });
            }
            return output;
        },
        // TODO code this and connect into controlMixins
        layoutProperty(/* { state, commit, dispatch }, payload */) {
            // if (this.$parent.component && this.$parent.component.layoutStoreId && store.state[this.$parent.component.layoutStoreId]) {
            //     let setNewVal = (iActionArgs, storeVal) => {
            //         let type = iActionArgs.type;
            //         if (type === 'numberOffset') return storeVal + iActionArgs.offset;
            //         if (type === 'toggleBoolean') return !storeVal;
            //         return iActionArgs.val;
            //     };
            //     if (actionArgs && !library.objIsEmpty(actionArgs)) {
            //         store.state[this.$parent.component.layoutStoreId][actionArgs.prop] = setNewVal(actionArgs, store.state[this.$parent.component.layoutStoreId][actionArgs.prop]);
            //     }
            //     else {
            //         for (let i in this.realConfig[realActionType + 'Args']) {
            //             let val = this.realConfig[realActionType + 'Args'][i].value || this.value;
            //             store.state[this.$parent.component.layoutStoreId][this.realConfig[realActionType + 'Args'][i].arg] = val;
            //         }
            //     }
            // }
        },
        async openComponentDialog({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let { componentId, dialogSettings, srcAffId, contextRecordIds, component } = passedParams;
            let { volId, oppId, orgId, lbeId, schId, affId } = component;
            if (srcAffId) affId = srcAffId;
            else if (contextRecordIds && contextRecordIds.affId) affId = contextRecordIds.affId;
            let compConfig = await componentStore.getConfig(componentId);
            let dialogComponentId = componentId + "_in_dialog_" + library.getUniqueID();
            let componentRef = 'component_in_' + dialogComponentId;
            let vueRefs = {};
            let componentDialogTemplate = {
                name: dialogComponentId,
                template: `<div :id="dialogComponentId">
                    <component :is="cType" :c-id="componentId + '__' + dialogComponentId" :c-type="cType"
                       :context-vol-id="volId"
                       :context-opp-id="oppId"
                       :context-org-id="orgId"
                       :context-lbe-id="lbeId"
                       :context-sch-id="schId"
                       :context-aff-id="affId"
                       :context-dialog-id="dialogComponentId"
                       :ref="componentRef"
                       @update:childComponentRefs="setChildRefs"
                    ></component>
                </div>`,
                data() {
                    return {
                        volId,
                        oppId,
                        orgId,
                        lbeId,
                        schId,
                        affId,
                        componentId,
                        dialogComponentId,
                        componentRef,
                        cType: compConfig.cType
                    };
                },
                methods: {
                    setChildRefs(refs) {
                        // Process sub-components from layoutContainers
                        for (let refId in refs) {
                            if (refId === 'length') continue;
                            let refChildComp = refs[refId][0];
                            if (typeof refChildComp.manualSave === 'function') vueRefs[refId] = refChildComp;
                        }
                    }
                },
                mounted() {
                    setTimeout(() => {
                        let cRef = this.componentRef;
                        if (!vueRefs[cRef] && this.$refs && this.$refs[cRef] && typeof this.$refs[cRef].manualSave === 'function') {
                            vueRefs[cRef] = this.$refs[cRef];
                        }
                    }, 1000);
                },
                components: {}
            };
            let defaultDialogSettings = {
                title: 'Tasks',
                name: dialogComponentId,
                isComponentDialog: true,
                doNotCloseOnOK: true,
            };
            let funcPreSuccess = async () => {
                let responses = [];
                if (!library.objIsEmpty(vueRefs)) {
                    for (let ref in vueRefs) {
                        if (typeof vueRefs?.[ref]?.manualSave === 'function') responses.push(vueRefs[ref].manualSave());
                    }
                    // TODO handle responses
                }
                // eslint-disable-next-line no-return-await
                if (responses.length) return await library.promiseAllSettled(responses);
                return true;
            };
            dialogSettings = library.mergeObj(defaultDialogSettings, dialogSettings);
            return library.showDialog(componentDialogTemplate, false, false, dialogSettings, funcPreSuccess);
        },
        async getProfileFields({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'getProfileFields');
            if (Object.values(params).indexOf('isMissing') > -1) {
                return params;
            }
            /* if (typeof params === 'undefined' || typeof params.psp === 'undefined') {
                return "Perspective is not set";
            } */
            let findFieldName = (fieldData, psp, key) => {
                let outputName = 'Field';
                let fieldName = psp + ':::' + key;
                let matchingField = fieldData.find((field) => field.value === fieldName);
                if (matchingField) outputName = matchingField.optionData.CUSTOM_ATTRIBUTE_NAME || matchingField.optionData.displayTitle;
                outputName = outputName.split('::').length > 1 ? outputName.split('::')[1] : outputName;
                return outputName;
            };
            let fields = params.fields.map((field) => field.split(':::')[1]);
            let response = await sDs.post("er_" + params.psp + 'Field', fields, params.recordId);
            // Adjust the response
            response = response && response.data && response.data[params.recordId];
            let dialogTemplate;
            if (response) {
                let fieldData = await configStore.allFieldOptions();
                // TODO replace this with a component
                dialogTemplate = '<div class="dialog-content-actionstore-get-profile-fields"><contact-card cId="contactCard_getProfileFields" :prop-contact-id="contactId" :prop-contact-psp="contactPsp"></contact-card><ul>';
                // list of Content Fields
                fields.forEach((key) => {
                    // If it's hidden don't create an <li>
                    if (params.hiddenFields.indexOf(params.psp + ':::' + key) === -1) {
                        let fieldValue = response[key];
                        if (key === 'VOL_AVAILABILITY' && Array.isArray(fieldValue)) {
                            fieldValue = '<br>' + fieldValue.join(',<br>');
                        }
                        dialogTemplate += '<li><span class="field-name">'
                            + findFieldName(fieldData, params.psp, key)
                            + '</span><span class="field-value">' + fieldValue + '</span></li>';
                    }
                });
                dialogTemplate += "</ul></div>";
            }
            else dialogTemplate = "<div>No information to display.</div>";
            let dialogSettings = {
                title: 'Profile Info',
                isComponentDialog: true
            };
            if (params.psp === 'vol') {
                if (response.VOL_FIRST_NAME || response.VOL_LAST_NAME) {
                    dialogSettings.title = '';
                }
                if (response.VOL_FIRST_NAME) {
                    dialogSettings.title = response.VOL_FIRST_NAME + ' ';
                }
                if (response.VOL_LAST_NAME) {
                    dialogSettings.title += response.VOL_LAST_NAME;
                }
            }
            let dialogComponent = {
                name: 'getProfileFieldsDialog',
                template: dialogTemplate,
                data() {
                    return {
                        responseData: response,
                        contactId: params.recordId,
                        contactPsp: params.psp,
                    };
                },
                components: {
                    contactCard: defineAsyncComponent(() => import('@common/contactCard/contactCard.vue')),
                }
            };
            return library.showDialog(dialogComponent, false, false, dialogSettings);
        },
        async saveControlPanel({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let response = {
                action: 'saveControlPanel',
                params: passedParams,
                status: 'success'
            };
            let { component } = passedParams;
            if (component && typeof component.manualSave === 'function') {
                let tmpRes = await component.manualSave();
                response.status = tmpRes.status;
            } else {
                response.status = 'failure';
                response.error = 'Component have no manualSave function';
            }
            return response;
        },
        async closeDialog({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'closeDialog', false, false);
            let response = {
                action: 'closeDialog',
                params: passedParams,
                status: 'success'
            };
            let allDialogs = library.getDialogs();
            let dialogsToClose;
            let { component } = passedParams;
            switch (params.dialogId) {
                case 'all':
                    dialogsToClose = allDialogs;
                    break;
                case 'parent':
                    // eslint-disable-next-line no-case-declarations
                    let dialogName = component?.dialogId || false;
                    if (dialogName && allDialogs[dialogName]) {
                        dialogsToClose = [allDialogs[dialogName]];
                    } else {
                        response.status = 'failure';
                        response.error = 'Can not find parent dialog';
                    }
                    break;
            }
            for (let i in dialogsToClose) {
                if (typeof dialogsToClose?.[i]?.[params.closeAs + 'Button'] === 'function') {
                    dialogsToClose[i][params.closeAs + 'Button']();
                    response.status = params.closeAs === 'ok' ? 'success' : 'failure';
                }
            }
            return response;
        },
        async openRecruiterForm({ state, commit, dispatch }, payload) {
            if (typeof PROJECT_NAME === 'undefined' || PROJECT_NAME !== 'recruiter') {
                return library.showDialog('We are unable to complete your request. Please execute this action from within a recruiter.', false, false, { showAsAlert: true });
            }
            if (!ngAdapterStore().initialized) {
                return library.showDialog('The services platform is not ready.  Please check the recruiter for proper configuration.', false, false, { showAsAlert: true });
            }
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openRecruiterForm', false, false);
            let response = {
                action: 'openRecruiterForm',
                params: passedParams,
                status: 'failure'
            };
            if (Object.values(params).indexOf('isMissing') > -1) {
                return params;
            }
            if (!ngAdapterStore().ngStores.forms) ngAdapterStore().ngStores.forms = [];
            let uniqueId = library.getUniqueID();
            let formKey = 'vue_recruiter_form_dialog_' + uniqueId;
            ngAdapterStore().ngStores.forms[formKey] = { formName: params.formName, targetId: formKey, response: { status: 'pending' } };
            // let formWatchKey = 'ngStores.formResponses.' + formIndex;
            let formWatchKey = 'ngStores.forms.' + formKey + '.response.status';
            let dialogTemplate = `<div id="${formKey}" class="recruiter-form-dialog"></div>`;
            let dialogSettings = {
                title: params.dialogTitle || 'Update Information',
                name: 'recruiterFormDialog',
                preventCloseOnBackdropClick: true,
                size: params.dialogSize || 'large',
                okButtonCssClass: 'hide',
                showCloseIcon: true,
                closeOnEscape: false,
                zIndex: 1049
            };
            let dialogComponent = {
                name: 'recruiterFormDialog',
                template: dialogTemplate,
                data() {
                    return {};
                },
                computed: {
                    ngStores() {
                        return ngAdapterStore().ngStores;
                    }
                },
                mounted() {
                    this.$watch(formWatchKey, (formResponse) => {
                        response.status = typeof formResponse === 'string' ? formResponse : formResponse?.status;
                        if (formResponse === 'success') {
                            library.hideDialog(dialogSettings.name, true);
                            // TODO make this work with other perspectives and record IDs
                            if (passedParams.mappedRecord && passedParams.mappedRecord.VOLUNTEER_ID) {
                                recordStore().renewSubscriptions({ psp: 'vol', ids: [passedParams.mappedRecord.VOLUNTEER_ID] });
                            }
                        } else {
                            library.hideDialog(dialogSettings.name);
                        }
                    });
                }
            };
            response.dialogResponse = await library.showDialog(dialogComponent, false, false, dialogSettings);
            return response;
        },
        async sendEST({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'sendEST');
            let response = {};
            let estId = params.estId;
            if (Array.isArray(estId)) estId = estId[0];
            if (estId && params.recordId) {
                let affiliationID = params.affID || null;
                response = await sDs.post('sds_sendEST', estId, params.recordId, affiliationID);
            } else {
                response.status = 'failure';
                response.error = 'Not all params are passed to the action';
            }
            response.action = 'sendEST';
            response.params = passedParams;
            return response;
        },
        async uploadAttachments({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'uploadAttachments');
            let response = {
                action: 'uploadAttachments',
                params: passedParams
            };
            if (params.psp && params.recordId && Array.isArray(params.attachIds) && params.attachIds.length) {
                let tmpAttachArray = await configStore.getAttachTypeList(params.recordId, params.psp);
                let tmpAttachInfo = [];
                let controlsConfigs = {};
                for (let i in params.attachIds) {
                    if (typeof tmpAttachArray[params.attachIds[i]] !== 'undefined') {
                        tmpAttachInfo.push(tmpAttachArray[params.attachIds[i]]);
                        let tmpExtentions = tmpAttachArray[params.attachIds[i]].ATTACH_TYPE_ALLOWED_EXT?.split(',');
                        let allowedExt = [];
                        if (tmpExtentions) {
                            for (let ext in tmpExtentions) {
                                let tmpExtention = tmpExtentions[ext].replace(/\s/g, '');
                                allowedExt.push('.' + tmpExtention);
                            }
                        }
                        allowedExt = allowedExt.join(', ');
                        controlsConfigs['UPLOAD_ATTACH_' + params.attachIds[i]] = {
                            name: 'UPLOAD_ATTACH_' + params.attachIds[i],
                            type: 'upload',
                            showAsDefaultInput: false,
                            multiple: false,
                            showRemoveConfirmation: false,
                            showExtensionsText: true,
                            label: tmpAttachArray[params.attachIds[i]].ATTACH_TYPE_TEXT,
                            allowedExtensions: allowedExt,
                            allowedExtensionsText: allowedExt
                        };
                    }
                }
                if (tmpAttachInfo.length) {
                    let uniqueID = library.getUniqueID();
                    let filesData = {};
                    let profileDialogTemplate = {
                        name: "upload-attachments-popup_" + uniqueID,
                        template: `
                            <div v-for="(attachIdInfo, key) in attachIds" :key="key">
                                <control 
                                    :name="'UPLOAD_ATTACH_' + attachIdInfo.ATTACH_TYPE_ID"
                                    :prop-config="uploadAttachConfig['UPLOAD_ATTACH_' + attachIdInfo.ATTACH_TYPE_ID]" 
                                    @update:value-files="updateValue($event, attachIdInfo.ATTACH_TYPE_ID)"
                                ></control>
                            </div>
                        `,
                        data() {
                            return {
                                uniqueID: uniqueID,
                                attachIds: tmpAttachInfo,
                                uploadAttachConfig: controlsConfigs
                            };
                        },
                        methods: {
                            updateValue(data, attachTypeId) {
                                filesData[attachTypeId] = data[0];
                            }
                        },
                        components: {
                            store,
                            control: controlComponent
                        },
                    };
                    let successFn = async () => {
                        // TODO process this with promises allPromises
                        // Handle multiple file uploads
                        let promises = [];
                        let fileIds = [];
                        let notUploadedAttachments = [];
                        for (let i in tmpAttachInfo) {
                            if (library.objIsEmpty(filesData[tmpAttachInfo[i]['ATTACH_TYPE_ID']])) {
                                notUploadedAttachments.push(tmpAttachInfo[i]['ATTACH_TYPE_TEXT']);
                            }
                        }
                        if (notUploadedAttachments.length) {
                            let tmpMessage = notUploadedAttachments.length === 1 ? 'Please choose a file for ' : 'Please choose files for following attachments:<br>';
                            library.showDialog(tmpMessage + notUploadedAttachments.join('<br>'), false, false, { showAsAlert: true });
                            response.status = 'failure';
                            return response;
                        }
                        response.status = 'success';

                        for (let i in filesData) {
                            fileIds.push(i);
                            promises.push(sDs.post('er_uploadAttach', i, params.psp, params.recordId, filesData[i].name, filesData[i].base64));
                        }
                        let allPromises = await library.promiseAllSettled(promises);
                        allPromises.forEach((uploadResponse, resIndex) => {
                            // Return failure if any attachment doesn't upload?
                            if (uploadResponse.value.status === 'failure') response.status = 'failure';
                            else { // Process success
                                // TODO get this to return multiple attachment's data
                                if (!response.data) response.data = {};
                                response.data[fileIds[resIndex]] = uploadResponse.value.data;
                                if (response.status !== 'failure') response.status = 'success';
                            }
                        });
                        return response;
                    };
                    let dialogOptions = {
                        title: 'Upload attachments',
                        name: 'uploadAttachments',
                        preventCloseOnBackdropClick: true,
                        width: '680px',
                        showCloseIcon: true,
                        closeOnEscape: false,
                        isComponentDialog: true,
                        cssClass: 'hide-cancel',
                        doNotCloseOnFuncFailure: true
                    };
                    response.dialogResponse = await library.showDialog(profileDialogTemplate, successFn, false, dialogOptions);
                }
            } else {
                response.status = 'failure';
                response.error = 'Not all params are passed to the action';
            }
            if (!params.disableToastConfirmation) {
                if (response.status === 'success') {
                    library.showToast('Attachment uploaded successfully!');
                }
            }
            return response;
        },
        async playYouTubeVideo({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'playYouTubeVideo');
            let response = {
                action: 'playYouTubeVideo',
                params: passedParams
            };
            if (params.videoUrl) {
                let uniqueID = library.getUniqueID();
                let profileDialogTemplate = {
                    name: "play-youtube-video-popup_" + uniqueID,
                    template: `<div :id="'play-youtube-video-popup_' + uniqueID" ><control name="YOUTUBE_PLAYER" :prop-config="youTubePlayerConfig"></control></div>`,
                    data() {
                        return {
                            uniqueID: uniqueID,
                            youTubePlayerConfig: {
                                name: 'YOUTUBE_PLAYER',
                                type: 'youtube',
                                value: params.videoUrl,
                                description: params.customMessage || false,
                                allowResume: params.allowResume,
                                disableFastForward: params.disableFastForward
                            }
                        };
                    },
                    components: {
                        store,
                        control: controlComponent
                    },
                };
                response.dialogResponse = await library.showDialog(profileDialogTemplate, () => {
                    response.status = 'success';
                }, false, {
                    title: params.modalHeader || 'Please watch the video',
                    name: 'playYouTubeVideo',
                    preventCloseOnBackdropClick: true,
                    width: '680px',
                    showCloseIcon: false,
                    closeOnEscape: false,
                    isComponentDialog: true,
                    cssClass: 'hide-cancel'
                });
            } else {
                response.status = 'failure';
                response.error = 'Not all params are passed to the action';
            }
            return response;
        },
        async updateProfileFields({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            // Normalize data to accommodate for updateProfileField
            if (library.objIsEmpty(passedParams)) passedParams = {};
            if (passedParams.field) passedParams.fields = [{ field: passedParams.field, value: passedParams.value }];
            let params = await actionStore.actions.checkParams(passedParams, 'updateProfileFields');
            if (Object.values(params).indexOf('isMissing') > -1) {
                return params;
            }
            const fields = Array.isArray(params.fields)
                ? params.fields.reduce((accumulator, field) => {
                    let fVal = field.value;
                    let fKey = Array.isArray(field?.field) ? field.field[0] : field.field; // matches dropdown selections that are array of one
                    if (fKey && typeof fKey === 'string') { // Field key must be a string
                        if (fKey.indexOf(':::') !== -1) fKey = fKey.split(':::')[1];
                        accumulator[fKey] = field.value === '_empty_' ? null : fVal;
                    }
                    return accumulator;
                }, {}) : params.fields;
            const response = await sDs.post("sds_updateProfileField", params.psp, params.recordId, fields);
            response.action = 'updateProfileFields';
            response.params = passedParams;
            if (response.status === 'success') {
                library.mergeObj(recordStore().records[params.psp][params.recordId], fields);
                let mRecords = {};
                mRecords[params.psp] = [params.recordId];
                recordStore().setModified(mRecords);
                library.showToast('Field updated successfully!', { timeout: 10 });
            } else {
                library.showToast('There was a problem updating the field.', { type: 'danger', timeout: 10 });
            }
            return response;
        },
        async updateProfileField({ state, commit, dispatch }, payload) {
            return dispatch('updateProfileFields', payload);
        },
        async addColorPalette({ state, commit, dispatch }, payload) {
            let [palette] = Object.values(payload);
            return configStore.addPalette(palette);
        },
        async deleteColorPalette({ state, commit, dispatch }, payload) {
            let [palette] = Object.values(payload);
            return configStore.deletePalette(palette);
        },
        async runBackgroundCheck({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'runBackgroundCheck');
            if (Object.values(params).indexOf('isMissing') > -1) {
                return params;
            }
            if (params.recordId && typeof params.recordId === 'object' && params.recordId.length) params.recordId = params.recordId[0];
            return sDs.post("sds_bcSendRequest", params.packageID, params.recordId, params.affiliationId);
        },
        async editAutomation({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'editAutomation');
            if (typeof params.automationID === 'string' && params.automationID.indexOf(':::') !== -1) params.automationID = params.automationID.split(':::')[1];
            let response = {};
            if (params.automationID) {
                params.recordId = params.automationID;
                params.actVal = 'editAutomation';
                params.needResponse = true;
                response = await actionStore.actions.iframeProcessSubmit('editAutomation', params); // NOSONAR
            } else {
                response.status = 'failure';
                response.error = 'Not all params are passed to the action';
            }
            return response;
        },
        async deleteAutomation({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'deleteAutomation');
            if (typeof params.automationID === 'string' && params.automationID.indexOf(':::') !== -1) params.automationID = params.automationID.split(':::')[1];
            let response = {};
            if (params.automationID) {
                let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_DELETE_THE_TITLE');
                let message = '';
                let automationsToDelete = params.automationID;
                if (!Array.isArray(automationsToDelete)) automationsToDelete = [automationsToDelete];
                if (automationsToDelete.length === 1) {
                    message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_DELETE', 'automation');
                } else {
                    message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_MULTIDELETE', 'automations');
                }
                response.dialogResponse = await library.showDialog(message,
                    async () => {
                        response = await sDs.post('sds_deleteAutomation', automationsToDelete);
                    },
                    false,
                    { title: title, okButtonLabel: 'Delete' });
            } else {
                response.status = 'failure';
                response.error = 'Not all params are passed to the action';
            }
            response.action = 'deleteAutomation';
            response.params = passedParams;
            return response;
        },
        async runAutomation({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'runAutomation');
            if (typeof params.automationID === 'string' && params.automationID.indexOf(':::') !== -1) params.automationID = params.automationID.split(':::')[1];
            return sDs.post("ec_runAutomation", params.automationID, '', false, params.recordId);
        },
        async updateAffiliation({ state, commit, dispatch }, payload) {
            let [passedParams, chainingInProcess] = Object.values(payload);
            // TODO: Possibly Move this to recordSourceMapper
            if (passedParams.recordSource_affID === 'matchingRecord') {
                let affType = passedParams.matchingAffType;
                let mactId = passedParams.matchingActivityId;
                let morgId = passedParams.matchingOrgId;
                let volId = passedParams.mappedRecord.VOLUNTEER_ID || passedParams.mappedRecord.AFF_VOLUNTEER_ID;
                let orgId = passedParams.mappedRecord.ORGANIZATION_ID;
                let fields = ['AFF_STATUS', 'AFF_NOTE'];
                if (affType === 'vol_ae' && mactId && volId) {
                    fields.push('ACTIVITY_ENTITY_ID');
                    // TODO move this to recordStore call
                    let affListResponse = await sDs.post('sds_getAffiliationList', volId, false, fields, affType);
                    if (affListResponse.status === 'success') {
                        let affs = affListResponse.data;
                        if (!Array.isArray(affs)) affs = Object.values(affs);
                        let matchingAff = affs.find((affRecord) => affRecord.ACTIVITY_ENTITY_ID === mactId);
                        passedParams.affID = matchingAff && matchingAff.ID;
                    }
                } else if (affType === 'vol_org' && morgId && volId) {
                    fields.push('ORGANIZATION_ID');
                    let affListResponse = await sDs.post('sds_getAffiliationList', volId, orgId, fields, affType);
                    if (affListResponse.status === 'success') {
                        let affs = affListResponse.data;
                        if (!Array.isArray(affs)) affs = Object.values(affs);
                        let matchingAff = affs.find((affRecord) => affRecord.ORGANIZATION_ID === morgId);
                        passedParams.affID = matchingAff && matchingAff.ID;
                    }
                }
            }
            let params = await actionStore.actions.checkParams(passedParams, 'updateAffiliation', false, false);
            let response = {};
            let affId = params.affID;
            let affTypes = {
                'vol_org': 0,
                'assignment': 1,
                'vol_ae': 2,
                'org_org': 3,
            };
            // TODO make sure the above object is correct
            let affType = affTypes[params.affType] || 0;
            if (!affType) {
                let affInfoResponse = await sDs.post('sds_getProfileField', 32, affId, ['AFF_TYPE'], { strictTypeResults: true });
                if (affInfoResponse.status === 'success' && typeof affInfoResponse?.data?.[affId]?.['AFF_TYPE'] !== 'undefined') {
                    affType = affInfoResponse.data[affId]['AFF_TYPE'];
                }
            }
            if (affId) {
                let updateFields = {};
                if (typeof params.AFF_STATUS !== 'undefined') {
                    if (parseInt(params.AFF_STATUS, 10) > 0) updateFields.AFF_STATUS = params.AFF_STATUS;
                    if (params.AFF_STATUS === -1) updateFields.AFF_STATUS = null;
                }
                if (typeof params.AFF_REASON !== 'undefined') {
                    if (parseInt(params.AFF_REASON, 10) > 0) updateFields.AFF_REASON = Number(params.AFF_REASON);
                    if (params.AFF_REASON === -1) updateFields.AFF_REASON = null;
                }
                if (typeof params.AFF_NOTE !== 'undefined') updateFields.AFF_NOTE = params.AFF_NOTE;
                let setDate = (iDate, difference) => iDate.setDate(iDate.getDate() + difference);
                // Start Date
                if (params.AFF_START_DATE_TYPE === 'today') updateFields.AFF_START_DATE = new Date();
                else if (typeof params.AFF_START_DATE !== 'undefined') {
                    updateFields.AFF_START_DATE = library.parseRelativeDate(params.AFF_START_DATE);
                }
                // End Date
                if (params.AFF_END_DATE || params.AFF_END_DATE_TYPE) {
                    let endDate = new Date();
                    if (params.AFF_END_DATE_TYPE === 'today') setDate(endDate, 0);
                    else if (params.AFF_END_DATE_TYPE === '90_days') updateFields.AFF_END_DATE = setDate(endDate, 90);
                    else if (params.AFF_END_DATE_TYPE === '1_year') updateFields.AFF_END_DATE = setDate(endDate, 365);
                    else if (params.AFF_END_DATE) endDate = params.AFF_END_DATE;
                    updateFields.AFF_END_DATE = endDate;
                }
                // Expiration Date
                if (params.AFF_EXPIRATION_DATE || params.AFF_EXPIRATION_DATE_TYPE) {
                    let expirationDate = new Date();
                    if (params.AFF_EXPIRATION_DATE_TYPE === 'today') setDate(expirationDate, 0);
                    else if (params.AFF_EXPIRATION_DATE_TYPE === '90_days') setDate(expirationDate, 90);
                    else if (params.AFF_EXPIRATION_DATE_TYPE === '1_year') setDate(expirationDate, 365);
                    else expirationDate = params.AFF_EXPIRATION_DATE;
                    updateFields.AFF_EXPIRATION_DATE = expirationDate;
                }
                if (params.AFF_OPPORTUNITY_ID) updateFields.AFF_OPPORTUNITY_ID = params.AFF_OPPORTUNITY_ID;
                let runAffiliationRenewOnExpiration = params.runAffiliationRenewOnExpiration || false;
                if (!library.objIsEmpty(updateFields)) {
                    let runAutomations = true;
                    response = await sDs.post('sds_updateAffiliation', affId, updateFields, runAutomations, runAffiliationRenewOnExpiration);
                    if (response.status === 'success') {
                        // Set AFF Status ID fields
                        updateFields.AFF_STATUS_ID = updateFields.AFF_STATUS;
                        updateFields.AFF_REASON_ID = updateFields.AFF_REASON;
                        if (updateFields.AFF_STATUS) {
                            let statusOpts = await configStore.attrListOptions("aff_status_" + affType);
                            let statusOption = statusOpts.find((status) => status.value === updateFields.AFF_STATUS);
                            if (typeof statusOption?.text !== 'undefined') updateFields.AFF_STATUS = statusOption.text;
                        }
                        if (updateFields.AFF_REASON) {
                            let statusOpts = await configStore.attrListOptions("aff_reason_" + affType);
                            let statusOption = statusOpts.find((status) => status.value === updateFields.AFF_REASON);
                            if (typeof statusOption?.text !== 'undefined') updateFields.AFF_REASON = statusOption.text;
                        }
                        let rsPsp = affType === 1 ? 'assignment' : 'aff';
                        library.mergeObj(recordStore().records[rsPsp][affId], updateFields);
                        let modifObj = {};
                        modifObj[rsPsp] = [affId];
                        recordStore().setModified(modifObj);
                        if (!chainingInProcess && !params.disableResponseMessage) library.showDialog('Update successful!', false, false, { showAsAlert: true });
                    }
                } else {
                    response.status = 'failure';
                    response.error = 'Nothing to update';
                }
            } else {
                response.status = 'failure';
                response.error = 'Not all params are passed to the action';
            }
            response.action = 'updateAffiliation';
            response.params = passedParams;
            return response;
        },
        async renewActivity({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'renewActivity', false, false);
            let response = {
                action: 'renewActivity',
                params: passedParams
            };
            let affFields = {
                // Include the expiration date of the current affiliation by default
                AFF_EXPIRATION_DATE: recordStore().records.aff[params.currentAffId].AFF_EXPIRATION_DATE
            };
            if (Array.isArray(params.fields)) {
                params.fields.forEach((fieldObj) => {
                    let iField = fieldObj.field.indexOf(':::') !== -1 ? fieldObj.field.split(':::')[1] : fieldObj.field;
                    affFields[iField] = fieldObj.value;
                });
            }
            let serverResponse = await sDs.post(
                'sds_renewVolAeAffiliation',
                params.currentAffId,
                affFields,
                false, // runAutomation
            );
            if (serverResponse.status === 'success') {
                // update the local store
                // Refresh the current workflow step affiliation
                // Set field like complianceRenewalAffId
                let newAffId = serverResponse.data;
                if (Array.isArray(newAffId)) newAffId = newAffId[0];
                recordStore().records.aff[newAffId] = {
                    ID: newAffId,
                    AFFILIATION_ID: newAffId,
                    AFF_STATUS_ID: 3, // TODO extract this from string value in AFF_STATUS
                    AFF_REASON_ID: 503, // TODO extract this from string value in AFF_REASON
                    ACTIVITY_ENTITY_ID: params.activityId,
                    ...affFields // Some temporary record
                };
                if (params.currentAffId) {
                    // put the new id in the old aff complianceRenewalAffId
                    let inSubscription = recordStore().records.aff[params.currentAffId].inSubscription;
                    recordStore().records.aff[params.currentAffId].complianceRenewalAffId = newAffId;
                    Object.keys(inSubscription).forEach((subId) => {
                        let inSub = inSubscription[subId];
                        if (inSub) recordStore().subscriptions[subId].recordIds.push(newAffId);
                    });
                    recordStore().setModified({ aff: [params.currentAffId] });
                }
                library.showToast('Renewal started successfully!');
            } else {
                library.showToast('There was a problem starting the renewal process.');
            }
            response.status = serverResponse.status;
            return response;
        },
        async deleteAssignment({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'deleteAssignment');
            let response = {};
            if (params.assignmentID) {
                response = await sDs.post('sds_deleteAssignment', params.assignmentID);
            } else {
                response.status = 'failure';
                response.error = 'Not all params are passed to the action';
            }
            if (response.status === 'success') {
                library.showToast('Assignment deleted successfully!');
                recordStore().deleteRecord({ assignment: [params.assignmentID] });
            }
            else library.showToast('There was a problem deleting this assignment. Please try again.');
            return response;
        },
        async resetWorkflow({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'resetWorkflow');
            let response = {
                action: 'resetWorkflow',
                params: passedParams
            };
            // Exit if no affiliations
            // TODO add configurable list of matching activities to action params
            if (!passedParams?.mappedRecord?.affiliations) {
                response.status = 'failure';
                return response;
            }
            let wfStatuses = {};
            wfStatuses[params.workflowId] = params.newWorkflowStatus;
            let updateFields = {
                AFF_ASSIGNMENT_WORKFLOW_STATUS: wfStatuses,
                AFF_STATUS: params.newAssignmentStatus
            };
            if (params.assignmentId && params.workflowId) {
                let sdsResponse = await sDs.post('sds_resetAssignment', params.assignmentId, params.workflowId, updateFields);
                if (sdsResponse.status === 'success') {
                    library.showToast('Workflow has been reset successfully!');
                } else {
                    response.status = sdsResponse.status;
                    library.showToast('There was a problem resetting the workflow.');
                }
            } else {
                response.status = 'failure';
                response.error = 'Not all params are passed to the action';
            }
            return response;
        },
        async updateWorkflowStatus({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'updateWorkflowStatus');
            let wfStatuses = {};
            wfStatuses[params.workflowId] = params.workflowStatus;
            let updateFields = {
                AFF_ASSIGNMENT_WORKFLOW_STATUS: wfStatuses
            };
            let response = await sDs.post('sds_updateAffiliation', params.assignmentId, updateFields);
            if (response.status === 'success') {
                let rsPsp = 'assignment';
                let affId = params.assignmentId;
                library.mergeObj(recordStore().records[rsPsp][affId], updateFields);
                let modifObj = {};
                modifObj[rsPsp] = [affId];
                recordStore().setModified(modifObj);
                library.showToast('Status updated successfully!');
            } else {
                library.showToast('There was a problem updating the status.');
            }
            return response;
        },
        async refreshWorkflowStep({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            const record = passedParams.record;
            const affFields = {
                32: [
                    'AFFILIATION_ID',
                    'AFF_REASON_ID',
                    'AFF_REASON',
                    'AFF_STATUS_ID',
                    'AFF_STATUS',
                    'AFF_START_DATE',
                    'AFF_END_DATE',
                    'AFF_COMPLIANCE_STATUS',
                    'AFF_COMPLIANCE_STATUS_ID',
                    'AFF_COMPLIANCE_STATUS_VERIFIER',
                    'AFF_STATUS_VERIFIER_DATE',
                    'AFF_STATUS_VERIFIER',
                    'AFF_STATUS_DATETIME',
                    'AFF_COMPLETE_DATE',
                    'AFF_EXPIRATION_DATE',
                    'AFF_NOTE'
                ]
            };

            const affId = record.AFFILIATION_ID || record.assignmentId;
            const subscriptions = recordStore().subscriptions;
            const placedSlotSubs = Object.values(subscriptions).filter((subscription) => subscription);
            const subscription = placedSlotSubs.find((subscription) => subscription.source === 'er_getPlacedSlotList');
            const subKey = subscription.key;
            recordStore().subscribe(false, false, true, subKey);
            const affResponse = await sDs.post('sds_getAffiliationDetails', affId, affFields);
            library.mergeObj(recordStore().records['aff'][affId], affResponse.data);
            recordStore().setModified({ 'aff': [affId] });

            if (affResponse.status === 'success') {
                library.showToast('Status updated successfully!');
            } else {
                library.showToast('There was a problem updating the status.');
            }
            return affResponse;
        },
        async openEmail({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openEmail');
            if (params.psp === 'source') {
                params.psp = passedParams.mappedRecord.uiRecordPsp;
            }
            params.actVal = 'email';
            params.width = 900;
            params.height = 1500;
            actionStore.actions.iframeProcessSubmit('BulkEmail', params); // NOSONAR
        },
        async openBackgroundCheckReview({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openBackgroundCheckReview');
            let response = {};
            if (params.recordId) {
                params.isMainGrid = true;
                params.vueOnePageDesign = true;
                params.fromTopMenu = true;
                params.actVal = 'BackgroundCheck;review;1';
                params.needResponse = true;
                response = await actionStore.actions.iframeProcessSubmit('openBackgroundCheckReview', params); // NOSONAR
                let bcStatusResponse = await sDs.post('er_volField', ['VOL_BC_STATUS'], params.recordId);
                if (
                    bcStatusResponse
                    && bcStatusResponse.status === 'success'
                    && bcStatusResponse.data
                    && bcStatusResponse.data[params.recordId]
                    && bcStatusResponse.data[params.recordId]['VOL_BC_STATUS']
                ) {
                    if (bcStatusResponse.data[params.recordId]['VOL_BC_STATUS'] === 'Approved') {
                        response.status = 'success';
                    } else {
                        response.status = 'failure';
                        response.error = 'BC Status: ' + bcStatusResponse.data[params.recordId]['VOL_BC_STATUS'];
                    }
                } else {
                    response.status = 'failure';
                }
            } else {
                response.status = 'failure';
                response.error = 'Not all params are passed to the action';
            }
            // Leave this for example, delete in 1 month
            // if (Array.isArray(passedParams.actionChaining)) {
            //     response.params = passedParams;
            //     response.actionChaining = await actionStore.runActionChaining(passedParams.actionChaining, response);
            // }
            return response;
        },
        async createUpdateShift({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'createUpdateShift');
            let response = {};
            if (params.oppID || params.aeID || params.schID) {
                params.actVal = 'editSlot';
                params.needResponse = true;
                response = await actionStore.actions.iframeProcessSubmit('createUpdateShift', params); // NOSONAR
            } else {
                response.status = 'failure';
                response.error = 'Not all params are passed to the action';
            }
            return response;
        },
        // eslint-disable-next-line consistent-return
        async openLogBookEntry({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = library.cloneObj(passedParams);
            let response = {};
            // TODO Some params will actually be requested in recruiters
            // TODO refactor required params, Allow params to be project specific
            let isRecruiter = typeof VUE_PROJECT_NAME !== 'undefined' && VUE_PROJECT_NAME === 'recruiterBridge';
            if (typeof passedParams.stationID === 'undefined' && !isRecruiter) {
                params = await actionStore.actions.checkParams(passedParams, 'openLogBookEntry');
            }

            if (params.openInNewWindow || typeof VUE_PROJECT_NAME === 'undefined' || (typeof VUE_PROJECT_NAME !== 'undefined' && (VUE_PROJECT_NAME === 'devDash' || VUE_PROJECT_NAME === 'recruiterBridge'))) {
                if (typeof VUE_PROJECT_NAME === 'undefined' || VUE_PROJECT_NAME === 'coordinator' || VUE_PROJECT_NAME === 'vms' || VUE_PROJECT_NAME === 'devDash') {
                    // vueBridge, eCoordinator, devDash
                    params.recordId = params.lbeID;
                    params.actVal = 'editLBE';
                    params.needResponse = true;
                    response = await actionStore.actions.iframeProcessSubmit('editLBE', params); // NOSONAR
                } else { // recruiterBridge, others?
                    let packageID;
                    if (params.oppID && params.surveyID) {
                        packageID = params.oppID + '_' + params.surveyID;
                    } else if (params.surveyID) {
                        packageID = '_' + params.surveyID;
                    } else if (params.oppID && params.packageID) {
                        packageID = params.oppID + '_' + params.packageID;
                    } else if (params.packageID) {
                        packageID = '_' + params.packageID;
                    }
                    let recordID = params.recordID || params.recordId;
                    let tmpRecruiterID = typeof RECRUITER_ID !== 'undefined' ? RECRUITER_ID : '499';
                    let url = PROJECTS_URL
                        + '/recruiter/index.php?actionStore&className=ReportService&actRepSer=fillAction&recruiterID=' + tmpRecruiterID
                        + (packageID ? '&packageID=' + packageID : '')
                        + (recordID ? '&UID=' + recordID : '')
                        + (params.trainingID ? '&trainingID=' + params.trainingID : '')
                        + (params.lbeID ? '&lbeID=' + params.lbeID : '')
                        + (params.slotID ? '&stationSlotID=' + params.slotID : '')
                        + (params.stationID ? '&stationID=' + params.stationID : '')
                        + (params.aeID ? '&ACTIVITY_ENTITY_ID=' + params.aeID : '')
                        + (params.affID ? '&AFFILIATION_ID=' + params.affID : '')
                        + (params.assignmentID ? '&assignmentID=' + params.assignmentID : '');
                    let iframeSubmitParams = {
                        url: url,
                        needResponse: true,
                        openInSameWindow: true,
                        hideOpenInNewWindow: true,
                        actVal: 'recruiter_survey_iframe',
                        preventCloseOnBackdropClick: true,
                    };
                    if (params.dialogSettings) iframeSubmitParams.dialogSettings = params.dialogSettings;
                    response = await actionStore.actions.iframeProcessSubmit('customUrl', iframeSubmitParams);
                }
            } else {
                response.status = 'failure';
                let surveySubminFnc = params.surveySubminFnc;
                let self;
                let surveyListControl = {
                    name: 'SURVEY_LIST_OPP',
                    type: 'dropdown',
                    showClearButton: false,
                    fields: { text: 'text', value: 'value' },
                    items: params.surveyList,
                    placeholder: 'Please select a survey'
                };
                if (!params.stationID && (typeof params.surveyList === 'undefined' || !params.surveyList.length)) {
                    surveyListControl = {
                        text: 'Select Survey',
                        value: 'packageID',
                        type: 'dropdowntree',
                        itemsSource: 'configStore.allSurveyOptions()',
                        fields: {
                            text: 'text',
                            value: 'value',
                            hasChildren: 'hasChild',
                            parentValue: 'pId',
                        },
                        default: ''
                    };
                }
                let dialogID = 'openSurveyDialog_' + library.getUniqueID();
                let surveyTemplate = {
                    name: "survey-template",
                    template: `<div>
                                    <control v-if="!lbeID || stationID" name="SURVEY_LIST_OPP__` + library.getUniqueID() + `" :prop-config="surveyListControl" :value="value" @update:value="value = $event;" :onchange="changeSurvey"></control>
                                    <div v-if="src">
                                        <iframe ref="surveyIframe" id="survey-iframe" width="100%" v-if="!reload" :src="src" height="300px" @load="load"></iframe>
                                    </div>
                                </div>`,
                    data() {
                        return {
                            data: {},
                            recordID: params.recordId,
                            oppID: params.oppID,
                            lbeID: params.lbeID,
                            slotID: params.slotID,
                            stationID: params.stationID,
                            surveyListControl: surveyListControl,
                            additionalSurveySignin: false,
                            value: null,
                            src: false,
                            surveyID: false,
                            dialogID: dialogID
                        };
                    },
                    mounted() {
                        if (this.lbeID && !this.stationID) this.generateUrl();
                        if ((!this.lbeID || this.stationID) && Array.isArray(this.surveyListControl.items) && this.surveyListControl.items.length === 1) {
                            this.value = this.surveyListControl.items[0].value;
                            this.changeSurvey();
                        }
                    },
                    methods: {
                        generateUrl() {
                            self = this;
                            if (this.surveyID || this.lbeID) {
                                let pUrl = PROJECTS_URL;
                                this.src = false;
                                if (this.$el.closest('.e-dlg-container')) {
                                    this.$el.closest('.e-dlg-container').id = this.dialogID;
                                }
                                if (this.dialogID) {
                                    library.showLoadingIndicator(this.dialogID, false, "Please wait while our survey loads", 'survey-spinner');
                                }
                                this.$nextTick(() => {
                                    this.src = pUrl
                                        + '/recruiter/index.php?actionStore&className=ReportService&actRepSer=fillAction&recruiterID=499'
                                        + (self.oppID && self.surveyID ? '&packageID=' + self.oppID + '_' + self.surveyID : '')
                                        + (self.recordID ? '&UID=' + self.recordID : '')
                                        + (self.lbeID ? '&lbeID=' + self.lbeID : '')
                                        + (self.slotID ? '&stationSlotID=' + self.slotID : '')
                                        + (self.stationID ? '&stationID=' + self.stationID : '');
                                });
                            }
                        },
                        changeSurvey(event) {
                            self = this;
                            self.surveyID = false;
                            if (!self.value && event && event.value) {
                                self.value = event.value;
                            }
                            if (self.value) {
                                if (typeof this.value === 'string') {
                                    // for dropdown
                                    self.surveyID = self.value.replace('string:', '');
                                } else {
                                    // for dropdowntree
                                    self.surveyID = self.value[0];
                                }
                                self.generateUrl(self);
                            }
                        },
                        async load() {
                            library.hideLoadingIndicator(this.dialogID);
                            if (this.additionalSurveySignin) {
                                // when form submitted
                                this.additionalSurveySignin = false;
                                if (store && store.state && store.state.control && store.state.control.controls && store.state.control.controls['SURVEY_LIST_OPP']) {
                                    delete store.state.control.controls['SURVEY_LIST_OPP'];
                                }
                                library.hideAllDialogs();
                                response.status = 'success';
                                if (typeof surveySubminFnc === 'function') surveySubminFnc();
                            } else {
                                // hide all buttons
                                let iframe = this.$refs['surveyIframe'];
                                let iframeDoc = iframe.contentDocument;
                                if (!iframeDoc) iframeDoc = iframe.contentWindow && iframe.contentWindow.document ? iframe.contentWindow.document : false;
                                if (iframeDoc) {
                                    let okButton = iframeDoc.querySelector('[name="ok_button"]');
                                    if (okButton) okButton.style.display = 'none';
                                    let cancelButton = iframeDoc.querySelector('[name="cancel_button"]');
                                    if (cancelButton) cancelButton.style.display = 'none';
                                    okButton = iframeDoc.querySelector('[id="ok_button"]');
                                    if (okButton) okButton.style.display = 'none';
                                    cancelButton = iframeDoc.querySelector('[id="cancel_button"]');
                                    if (cancelButton) cancelButton.style.display = 'none';
                                }
                            }
                        }
                    },
                    components: {
                        control: controlComponent
                    }
                };
                let funcOnSuccess = async () => {
                    if (typeof self === 'undefined' || !self.surveyID) {
                        library.showDialog('Please select a survey.', false, false, { showAsAlert: true });
                        return;
                    }
                    if (store && store.state && store.state.control && store.state.control.controls && store.state.control.controls['SURVEY_LIST_OPP']) {
                        delete store.state.control.controls['SURVEY_LIST_OPP'];
                    }
                    let iframe = self.$refs['surveyIframe'];
                    if (iframe && !self.additionalSurveySignin) {
                        self.additionalSurveySignin = true;
                        if (typeof iframe.contentWindow.profile_doAction !== 'undefined') {
                            await iframe.contentWindow.profile_doAction('ok');
                            if (iframe.contentWindow.profile_formCheckFailed) { self.additionalSurveySignin = false; return; }
                            if (dialogID) {
                                library.showLoadingIndicator(dialogID, false, "Please wait while we save your survey", 'survey-spinner');
                            }
                        }
                    }
                    if (Array.isArray(params.surveyList) && params.surveyList.length) {
                        let dpTitle = params.surveyList.find((tmp) => tmp.value === self.surveyID);
                        if (dpTitle) {
                            // eslint-disable-next-line consistent-return
                            return dpTitle.text;
                        }
                    }
                };
                let funcOnFailure = () => {
                    if (store && store.state && store.state.control && store.state.control.controls && store.state.control.controls['SURVEY_LIST_OPP']) {
                        delete store.state.control.controls['SURVEY_LIST_OPP'];
                    }
                };
                let tmpDialogOpt = {
                    title: params.lbeID ? 'Edit logbook entry' : 'Please select from the following survey(s):',
                    'doNotCloseOnFuncFailure': true,
                    'okButtonLabel': 'OK',
                    'resizeDialogToIframeHeight': 'survey-iframe',
                    'resizeDialogToIframeWidth': 'survey-iframe',
                    'hideTitle': params.hideTitle,
                    'closeAfterSeconds': params.closeAfterSeconds
                };
                if (!params.stationID) {
                    tmpDialogOpt['size'] = 'fullscreen';
                }
                response.dialogResponse = await library.showDialog(surveyTemplate,
                    false,
                    false,
                    tmpDialogOpt,
                    funcOnSuccess,
                    funcOnFailure);
            }
            response.action = 'openLogBookEntry';
            response.params = passedParams;
            return response;
        },
        // eslint-disable-next-line consistent-return
        async openSurvey({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let response = {};
            // TODO Some params will actually be requested in recruiters
            // TODO refactor required params, Allow params to be project specific
            let isRecruiter = typeof VUE_PROJECT_NAME !== 'undefined' && VUE_PROJECT_NAME === 'recruiterBridge';
            if (!passedParams.lbeID && !passedParams.stationID && !isRecruiter) {
                let params = await actionStore.actions.checkParams(passedParams, 'openSurvey');
                params.psp = 1;
                params.actVal = 'new_logbook_lbe';
                params.needResponse = true;
                response = await actionStore.actions.iframeProcessSubmit('newLBE', params, 680, 400); // NOSONAR
            } else {
                response = await actionStore.openLogBookEntry(passedParams);
            }
            response.action = 'openSurvey';
            response.params = passedParams;
            let isSignin = typeof VUE_PROJECT_NAME !== 'undefined' && VUE_PROJECT_NAME === 'signin';
            if (!isSignin) {
                if (response.status === 'success') {
                    library.showDialog('Thank You!', false, false, { showAsAlert: true });
                } else {
                    library.showDialog('There was an error. Please check your configuration.', false, false, {
                        title: 'Failed',
                        showAsAlert: true
                    });
                }
            }
            return response;
        },
        // eslint-disable-next-line consistent-return
        async openWaiver({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let response;
            // TODO Some params will actually be requested in recruiters
            // TODO refactor required params, Allow params to be project specific
            let isRecruiter = typeof VUE_PROJECT_NAME !== 'undefined' && VUE_PROJECT_NAME === 'recruiterBridge';
            if (!passedParams.lbeID && !passedParams.stationID && !isRecruiter) {
                let params = await actionStore.actions.checkParams(passedParams, 'openWaiver');
                params.psp = 1;
                params.actVal = 'new_logbook_waiver';
                params.needResponse = true;
                response = await actionStore.actions.iframeProcessSubmit('newLBE', params, 680, 400); // NOSONAR
            } else {
                response = await actionStore.openLogBookEntry(passedParams);
            }
            response.action = 'openWaiver';
            response.params = passedParams;
            return response;
        },
        // eslint-disable-next-line consistent-return
        async openTraining({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let response = {};
            // TODO Some params will actually be requested in recruiters
            // TODO refactor required params, Allow params to be project specific
            let isRecruiter = typeof VUE_PROJECT_NAME !== 'undefined' && VUE_PROJECT_NAME === 'recruiterBridge';
            if (!passedParams.lbeID && !passedParams.stationID && !isRecruiter) {
                let params = await actionStore.actions.checkParams(passedParams, 'openTraining');
                params.psp = 1;
                params.actVal = 'new_logbook_training';
                if (!params.packageID && params.packageID.indexOf('_') === -1) {
                    library.showToast('No Training selected or training is not available.', { type: 'danger' });
                } else {
                    let pkgParts = params.packageID.split('_');
                    params.trainingID = pkgParts[0];
                    params.packageID = pkgParts[1];
                }
                params.needResponse = true;
                response = await actionStore.actions.iframeProcessSubmit('newLBE', params, 680, 400); // NOSONAR
            } else {
                if (!passedParams.packageID && passedParams.packageID.indexOf('_') === -1) {
                    library.showToast('No Training selected or training is not available.', { type: 'danger' });
                } else {
                    let pkgParts = passedParams.packageID.split('_');
                    passedParams.trainingID = pkgParts[0];
                    passedParams.packageID = pkgParts[1];
                }
                response = await actionStore.openLogBookEntry(passedParams);
            }
            response.action = 'openTraining';
            response.params = passedParams;
            return response;
        },
        async createLbe({ state }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'createLbe');
            params.surveyId = Array.isArray(params.surveyId) && params.surveyId.length ? parseInt(params.surveyId[0], 10) : params.surveyId;
            if (Object.values(params).indexOf('isMissing') > -1) {
                return params;
            }
            params.loggedDataFields.map((fieldObj) => {
                const { field, value } = fieldObj;
                const fieldName = field[0].split(':::')[1];
                params[fieldName] = value;
                return params;
            });

            let response = await sDs.post('er_createlbe', params);
            if (response.status === 'success') {
                if (!params.disableSuccessMessage) {
                    library.showToast(params.successMessageText || 'You successfully created a Logbook Entry.', { type: 'success' });
                }
            } else {
                library.showToast('There was an error and your Logbook Entry was not saved. Please check your configuration.', { type: 'danger' });
            }
            return response;
        },
        async openUrl({ state }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openUrl');
            let response = {};
            if (params.url) {
                let target = params.target || '_blank';
                if (params.url.match(/(http:\/\/|https:\/\/)/) === null) params.url = 'https://' + params.url;
                if (params.urlParams) {
                    if (params.urlParams[0] !== '?') params.urlParams = '?' + params.urlParams;
                    params.url += params.urlParams;
                }
                let urlToOpen = library.interpolateVueVariables(params.url, 'record', params.mappedRecord);
                window.open(urlToOpen, target);
                response.status = 'success';
            } else {
                response.status = 'failure';
                response.error = 'Not all params are passed to the action';
            }
            response.action = 'openUrl';
            response.params = passedParams;
            return response;
        },
        async affiliateRecord({ state }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'affiliateRecord');
            let { volId, orgId, isAssignment } = params;
            if (Object.values(params).indexOf('isMissing') > -1) {
                return params;
            }
            // TODO connect affFields
            let affFields = {};
            let response = await sDs.post("sds_createAffiliation", volId, orgId, affFields);
            let orgIds = Array.isArray(orgId) ? orgId : [orgId];
            // Reassign orgId to a single org ID
            orgId = orgIds[0];
            // let response = await sDs.post("sds_updateAffiliation", params.affId, params.affFields);
            if (response.status === 'success') {
                let orgRecord = recordStore().records.org[orgId];
                let volRecord = recordStore().records.vol[volId];
                let volName = volRecord.VOL_FIRST_NAME + ' ' + volRecord.VOL_LAST_NAME;
                let date = moment().format("MM/DD/YYYY H:mm a");
                let affId = isAssignment ? response.data?.AFF_VOL_ASSIGNMENT_ID[0] : response.data;
                let tmpAffiliationRecord = {
                    AFFILIATION_ID: affId,
                    ID: affId,
                    ORGANIZATION_ID: orgId,
                    AFF_ORGANIZATION: orgRecord?.ORG_TITLE,
                    AFF_VOLUNTEER: volName,
                    AFF_STATUS: 'Pending',
                    VOLUNTEER_ID: volId,
                    AFF_MODIFY_DATE: date,
                    AFF_CREATE_DATE: date,
                    linked_org: orgRecord,
                    linked_vol: volRecord,
                };

                let affSubscriptions = [];
                if (isAssignment) {
                    if (orgIds[1]) tmpAffiliationRecord.ORGANIZATION_ID_2 = orgIds[1];
                    tmpAffiliationRecord.ENTRY_POINT_ID = orgIds;
                    affSubscriptions = Object.values(recordStore().subscriptions)
                        .filter((subscription) => subscription.psp === 'assignment'
                            && subscription?.params?.volId === volId);
                }
                else {
                    affSubscriptions = Object.values(recordStore().subscriptions)
                        .filter((subscription) => subscription.psp === 'aff'
                            && subscription.parentRecords
                            && ((Array.isArray(subscription.parentRecords[1]) && subscription.parentRecords[1].indexOf(volId) !== -1)
                                || (Array.isArray(subscription.parentRecords[3]) && subscription.parentRecords[3].indexOf(orgId) !== -1)
                            ));
                }
                affSubscriptions.forEach((subscription) => {
                    if (!tmpAffiliationRecord.inSubscription) tmpAffiliationRecord.inSubscription = {};
                    tmpAffiliationRecord.inSubscription[subscription.key] = true;
                });
                if (isAssignment) {
                    // do something?
                    recordStore().records.assignment[affId] = tmpAffiliationRecord;
                    recordStore().records.vol[volId].assignmentIds[affId] = volId;
                } else {
                    recordStore().records.aff[affId] = tmpAffiliationRecord;
                    recordStore().records.vol[volId].affIds[affId] = orgId;
                    orgIds.forEach((iOrgId) => {
                        if (iOrgId) recordStore().records.org[iOrgId].affIds[affId] = volId;
                    });
                }
                recordStore().setModified({ org: orgIds, vol: [volId], assignment: [affId] });
                affSubscriptions.forEach((subscription) => {
                    subscription.recordIds.push(affId);
                });
                library.showDialog('Affiliated Successfully!', false, false, { title: 'Successful', showAsAlert: true });
            } else { // This is server response success, not action success
                let message;
                if (typeof response.error === 'string') message = response.error;
                else if (Array.isArray(response.error)) message = response.error.join(' ');
                else message = 'Error: Action was not successful.';
                library.showDialog(message, false, false, { title: 'Failed', showAsAlert: true });
            }
            response.action = 'affiliateRecord';
            response.params = passedParams;
            return response;
        },
        async createAssignment({ dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'createAssignment');
            let { volId, endpointID } = params;
            let orgId = recordStore().records.aff[endpointID].AFF_RECORDS[3];
            // Runs affiliateRecords with correct params
            let isAssignment = true;
            return dispatch('affiliateRecord', [{ volId, orgId, isAssignment }]);
        },
        async deleteShift({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'deleteShift');
            if (!params.disableConfirmationDialog) {
                // Show confirmation dialog
                const dialogResponse = await library.showDialog(
                    'Are you sure you want to delete this shift?',
                    true,
                    false,
                    { title: 'Are you sure?' }
                );
                if (dialogResponse.status === 'failure') {
                    return dialogResponse;
                }
            }
            let response = {};
            if (params.slotId) {
                library.showLoadingIndicator('body');
                let shiftData = await sDs.post('er_slotField', ['SS_REPEATED', 'IS_HISTORICAL'], params.slotId, { strictTypeResults: true });
                library.hideLoadingIndicator('body');
                let deleteOption = 3;
                if (shiftData
                    && shiftData.status === 'success'
                    && shiftData.data
                    && shiftData.data[params.slotId]
                ) {
                    let repeated = shiftData.data[params.slotId]['SS_REPEATED'] === 'Yes' || false;
                    let historical = shiftData.data[params.slotId]['IS_HISTORICAL'] === 'Yes' || false;
                    if (repeated && !historical) {
                        library.showLoadingIndicator('body');
                        await ddStore.preloadGroup('SCHEDULE_CALENDAR');
                        let title = await ddStore.getAlias('SCHEDULE_CALENDAR', 'SCHEDULECALENDAR_DELETE_RECURRING_TITLE');
                        library.hideLoadingIndicator('body');
                        deleteOption = 1;
                        let deleteShiftDialog = {
                            name: 'delete-shift-dialog-template',
                            template: `<div>
                                            <control name="deleteOption" :prop-config="controls.deleteOption" :value="deleteOption" @update:value="changeDeleteOption"></control>
                                       </div>`,
                            data() {
                                return {
                                    deleteOption: 1,
                                    controls: {
                                        deleteOption: {
                                            name: 'deleteOption',
                                            id: 'deleteOption',
                                            type: 'radio_button_list',
                                            hideLabel: true,
                                            items: [
                                                { label: 'DD.SCHEDULE_CALENDAR.SCHEDULECALENDAR_DELETE_RECURRING_THIS', value: 1 },
                                                { label: 'DD.SCHEDULE_CALENDAR.SCHEDULECALENDAR_DELETE_RECURRING_NEXT', value: 2 },
                                                { label: 'DD.SCHEDULE_CALENDAR.SCHEDULECALENDAR_DELETE_RECURRING_ALL', value: 3 },
                                            ]
                                        }
                                    }
                                };
                            },
                            methods: {
                                changeDeleteOption: (value) => {
                                    deleteOption = value;
                                }
                            },
                            components: {
                                control: controlComponent
                            }
                        };
                        const deleteDialogResponse = await library.showDialog(
                            deleteShiftDialog,
                            true,
                            false,
                            { title: title }
                        );
                        if (deleteDialogResponse.status === 'failure') {
                            return deleteDialogResponse;
                        }
                    }
                }
                let slotId = Number(params.slotId);
                response = await sDs.post('er_deleteSlot', slotId, false, deleteOption);
                if (response.status === 'success') {
                    // Delete from recordStore
                    let forceReload = deleteOption !== 1;
                    recordStore().deleteRecord({ sch: [slotId] }, forceReload);
                }
            } else {
                response.status = 'failure';
                response.error = 'Not all params are passed to the action';
            }
            response.action = 'deleteShift';
            response.params = passedParams;
            return response;
        },
        async refPlace({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'refPlace');
            let arrayParams = ['oppIds', 'volIds', 'slotIds'];
            let getParamIds = (iParam) => {
                let ids = [];
                for (let j in iParam) {
                    if (j === 'length') continue;
                    let id = parseInt(iParam[j], 10);
                    if (isNaN(id)) continue;
                    ids.push(id);
                }
                return ids;
            };
            let resMsgFormatter = (responseMessages, assignType) => {
                let output = [];
                if (typeof responseMessages === 'object' && !Array.isArray(responseMessages)) responseMessages = Object.values(responseMessages);
                if (!Array.isArray(responseMessages)) responseMessages = [responseMessages];
                responseMessages.forEach((message) => {
                    let formattedMsg = "No response code found.";
                    // TODO setup human readable messages for
                    // Full
                    // Prerequisite not met
                    // No BC Check
                    // Expired
                    if (typeof message === 'number' || message === 'success' || message === null) formattedMsg = `The volunteer has been successfully assigned to the ${assignType}.`;
                    else if (message.indexOf('already exists') !== -1) formattedMsg = `An assignment already exists for this volunteer and ${assignType}.`;
                    else if (message.indexOf('BC Check')) formattedMsg = 'The volunteer\'s Background Check status is not valid for this action.';
                    output.push(formattedMsg);
                });
                return output;
            };
            let processResponseMessages = (iResponse, iParams, iSlotIDs) => {
                let outputMessages = [];
                iParams.volIds.forEach((volKey) => {
                    if (typeof iSlotIDs === 'object') {
                        let slotKeys = Object.keys(iSlotIDs);
                        slotKeys.forEach((sKey) => {
                            let slotMessages = resMsgFormatter(iResponse.data[volKey][sKey], 'shift');
                            outputMessages = outputMessages.concat(slotMessages);
                        });
                    } else {
                        iParams.oppIds.forEach((oppKey) => {
                            let resMessages = resMsgFormatter(iResponse.data[oppKey], 'opportunity');
                            outputMessages = outputMessages.concat(resMessages);
                        });
                    }
                });
                return outputMessages;
            };
            // Convert params to array
            for (let i in arrayParams) {
                if (i === 'length') continue;
                let paramName = arrayParams[i];
                if (typeof params[paramName] === 'undefined') continue;
                let tmpParam;
                if (typeof params[paramName] === 'number') tmpParam = [params[paramName]];
                else tmpParam = Array.isArray(params[paramName]) ? params[paramName] : params[paramName].split(',');
                let ids = getParamIds(tmpParam);
                params[paramName] = ids.length ? ids : false;
            }
            // Set some default params
            if (typeof params.doAddCheck === 'undefined') params.doAddCheck = true;
            if (typeof params.returnOpenings === 'undefined') params.returnOpenings = false;
            if (typeof params.isReferral === 'undefined') params.isReferral = false;
            let returnPlacementId = true;
            if (params.slotIds && !Array.isArray(params.slotIds)) params.slotIds = [params.slotIds];
            let postSlotIds = false;
            if (params.slotIds.length) {
                postSlotIds = {};
                for (let i in params.slotIds) {
                    if (i === 'length') continue;
                    let slotId = params.slotIds[i].toString();
                    if (slotId.length < 8) continue;
                    let slotDate = slotId.substring(slotId.length - 6, slotId.length);
                    let year = slotDate.substring(0, 2);
                    let month = slotDate.substring(2, 4);
                    let day = slotDate.substring(4, 6);
                    year = '20' + year;
                    slotDate = `${year}-${month}-${day}`;
                    postSlotIds[slotId] = {
                        date: slotDate,
                        permanent: false
                    };
                    if (params.assignmentID) postSlotIds[slotId].assignmentID = params.assignmentID;
                    if (params.aeAffID) postSlotIds[slotId].aeAffID = params.aeAffID;
                    /*
                    * {
                    *   date: '2021-12-31',
                    *   permanent: true // default if date parameter is not added,
                    *   group_size: 1
                    *   ... please check https://samaritan.atlassian.net/wiki/spaces/DEVELOPMEN/pages/261554308/sDs+instruction+and+tips+How+to+create+Recruiter+custom+pages+using+Custom+Environment
                    * }
                    * */
                }
            }
            let response;
            let removeResponse;
            let volId = params.volIds[0];
            let oppositeRefPl = !params.isReferral;
            let oppIds = params.oppIds || false;
            // perform both server requests before handling responses for better UIX
            library.showLoadingIndicator();
            response = await sDs.post("er_placeRefVol", oppIds, params.isReferral, params.volIds, postSlotIds, params.doAddCheck, params.returnOpenings, returnPlacementId);
            if (params.removeExistingAssignment && response.status === 'success') removeResponse = await sDs.post('er_unplaceRefVol', params.oppIds, oppositeRefPl, params.volIds, postSlotIds, returnPlacementId);
            library.hideLoadingIndicator();
            // Handle responses
            if (response.status === 'success') { // This is server response success, not action success
                // Update the local records in the store
                if (typeof response.data === 'object') {
                    let refPlIdKey;
                    let assignType;
                    if (postSlotIds) {
                        refPlIdKey = 'schIds';
                        assignType = 'sch';
                    }
                    else {
                        refPlIdKey = params.isReferral ? 'referredIds' : 'placedIds';
                        assignType = params.isReferral ? 'referrals' : 'placements';
                    }
                    let status = params.isReferral ? 'referred' : 'placed';
                    let resRecords = Object.keys(response.data);
                    resRecords.forEach((resRcdId) => {
                        resRcdId = Number(resRcdId);
                        let modifiedRecords = { vol: [volId] };
                        let shifts = Object.keys(response.data[resRcdId]);
                        shifts.forEach((shiftId) => {
                            shiftId = Number(shiftId);
                            if (typeof shiftId !== 'number') return;
                            let tmpRefPlRecord;
                            let existingRecords = library.cloneObj(recordStore().records.sch);
                            let existingShift = existingRecords[shiftId];
                            tmpRefPlRecord = existingShift || params.newShift || {
                                VOLUNTEER_ID: volId,
                                SCHEDULE_SLOT_ID: shiftId,
                            };
                            tmpRefPlRecord.STATUS = status;
                            if (oppIds) {
                                tmpRefPlRecord.OPP_ID = resRcdId;
                                recordStore().records.opp[resRcdId][refPlIdKey][shiftId] = volId;
                            }
                            recordStore().records[assignType][shiftId] = tmpRefPlRecord;
                            recordStore().updateShiftRecords([tmpRefPlRecord]);
                            modifiedRecords.sch = [shiftId];
                            recordStore().records.vol[volId][refPlIdKey][shiftId] = resRcdId;
                        });
                        // resRcdId might be an opp ID?  Not really sure, this is changed from previous
                        if (oppIds) modifiedRecords.opp = resRcdId;
                        recordStore().setModified(modifiedRecords);
                    });
                }
                if (removeResponse && removeResponse.status === 'success') {
                    let refPlIdKey = oppositeRefPl ? 'referredIds' : 'placedIds';
                    let assignType = oppositeRefPl ? 'referrals' : 'placements';
                    if (postSlotIds) {
                        refPlIdKey = 'schIds';
                        assignType = 'shifts';
                    } // else leave as is
                    if (typeof response.data === 'object') {
                        let removed = Object.keys(removeResponse.data);
                        removed.forEach((resRcdId) => {
                            let assignId = removeResponse.data[resRcdId];
                            if (typeof assignId !== 'number') return;
                            delete recordStore().records[assignType][assignId];
                            delete recordStore().records.vol[volId][refPlIdKey][assignId];
                            delete recordStore().records.opp[resRcdId][refPlIdKey][assignId];
                            recordStore().setModified({ opp: [resRcdId], vol: [volId] });
                        });
                    }
                }
                let messages = processResponseMessages(response, params, postSlotIds);
                let dialogMsg = '<div>' + messages.join('</br>') + '</div>';
                library.showDialog(dialogMsg, false, false, { title: 'Response', showAsAlert: true });
            }
            else library.showDialog('Error: Action was not successful.', false, false, { title: 'Failure', showAsAlert: true });
            response.action = 'refPlace';
            response.params = passedParams;
            return response;
        },
        async unRefPlace({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'unRefPlace');
            let arrayParams = ['oppIds', 'volIds', 'slotIds'];
            let getParamIds = (iParam) => {
                let ids = [];
                for (let j in iParam) {
                    if (j === 'length') continue;
                    let id = parseInt(iParam[j], 10);
                    if (isNaN(id)) continue;
                    ids.push(id);
                }
                return ids;
            };
            let resMsgFormatter = (responseMessages, assignType) => {
                let output = [];
                if (typeof responseMessages === 'object' && !Array.isArray(responseMessages)) responseMessages = Object.values(responseMessages);
                if (!Array.isArray(responseMessages)) responseMessages = [responseMessages];
                responseMessages.forEach((message) => {
                    let formattedMsg = "No response code found.";
                    // TODO setup human readable messages for
                    // Full
                    // Prerequisite not met
                    // No BC Check
                    // Expired
                    if (message === 'success') formattedMsg = `The volunteer has been successfully removed from the ${assignType}.`;
                    else formattedMsg = `There was a problem removing from the ${assignType}.`;
                    output.push(formattedMsg);
                });
                return output;
            };
            let processResponseMessages = (iResponse, iParams, iSlotIDs) => {
                let outputMessages = [];
                iParams.volIds.forEach((volKey) => {
                    if (typeof iSlotIDs === 'object') {
                        let slotKeys = Object.keys(iSlotIDs);
                        slotKeys.forEach((sKey) => {
                            let slotMessages = resMsgFormatter(iResponse.data[volKey][sKey], 'shift');
                            outputMessages = outputMessages.concat(slotMessages);
                        });
                    } else {
                        iParams.oppIds.forEach((oppKey) => {
                            let resMessages = resMsgFormatter(iResponse.data[oppKey], 'opportunity');
                            outputMessages = outputMessages.concat(resMessages);
                        });
                    }
                });
                return outputMessages;
            };
            // Convert params to array
            for (let i in arrayParams) {
                if (i === 'length') continue;
                let paramName = arrayParams[i];
                if (typeof params[paramName] === 'undefined') continue;
                let tmpParam;
                if (typeof params[paramName] === 'number') tmpParam = [params[paramName]];
                else tmpParam = Array.isArray(params[paramName]) ? params[paramName] : params[paramName].split(',');
                let ids = getParamIds(tmpParam);
                params[paramName] = ids.length ? ids : false;
            }
            // Set some default params
            if (!params.returnOpenings) params.returnOpenings = false;
            if (typeof params.isReferral === 'undefined') params.isReferral = false;
            if (params.slotIds && !Array.isArray(params.slotIds)) params.slotIds = [params.slotIds];
            let postSlotIds = false;
            if (params.slotIds.length) {
                postSlotIds = {};
                for (let i in params.slotIds) {
                    if (i === 'length') continue;
                    let slotId = params.slotIds[i].toString();
                    if (slotId.length < 8) continue;
                    let slotDate = slotId.substring(slotId.length - 6, slotId.length);
                    let year = slotDate.substring(0, 2);
                    let month = slotDate.substring(2, 4);
                    let day = slotDate.substring(4, 6);
                    year = '20' + year;
                    slotDate = `${year}-${month}-${day}`;
                    postSlotIds[slotId] = {
                        // date: slotDate,
                        permanent: false
                    };
                    /*
                    * {
                    *   date: '2021-12-31',
                    *   permanent: true // default if date parameter is not added,
                    *   group_size: 1
                    *   ... please check https://samaritan.atlassian.net/wiki/spaces/DEVELOPMEN/pages/261554308/sDs+instruction+and+tips+How+to+create+Recruiter+custom+pages+using+Custom+Environment
                    * }
                    * */
                }
            }
            let volId = params.volIds[0];
            let oppId = params.oppIds && params.oppIds[0];
            let slotId = params.slotIds && params.slotIds[0];
            let refPlIdKey = params.isReferral ? 'referredIds' : 'placedIds';
            let assignType = params.isReferral ? 'referrals' : 'placements';
            if (postSlotIds) {
                refPlIdKey = 'schIds';
                assignType = 'shifts';
            } // else leave as is
            let response = await sDs.post('er_unplaceRefVol', params.oppIds || false, params.isReferral, params.volIds, postSlotIds);
            if (response.status === 'success') {
                let assignId = response.data?.[volId];
                if (typeof assignId === 'object') {
                    assignId = Object.keys(assignId)[0]; // First key in the object is the shift ID
                }
                let mRecords = { vol: [volId] };
                if (oppId) {
                    if (recordStore().records.vol[volId][refPlIdKey][assignId]) delete recordStore().records.vol[volId][refPlIdKey][assignId];
                    if (recordStore().records.opp[oppId][refPlIdKey][assignId]) delete recordStore().records.opp[oppId][refPlIdKey][assignId];
                    mRecords.opp = [oppId];
                }
                if (slotId) {
                    if (recordStore().records.vol[volId].schIds[assignId]) {
                        delete recordStore().records.vol[volId].schIds[assignId];
                    }
                    if (recordStore().records[assignType][slotId]) delete recordStore().records[assignType][slotId];
                    mRecords.sch = [slotId];
                    mRecords.vol = [volId];
                }
                recordStore().setModified(mRecords);
                let messages = processResponseMessages(response, params, postSlotIds);
                let dialogMsg = '<div>' + messages.join('</br>') + '</div>';
                library.showDialog(dialogMsg, false, false, { title: 'Response', showAsAlert: true });
            }
            else library.showDialog('Error: Action was not successful.', false, false, { title: 'Failure', showAsAlert: true });
            response.action = 'unplaceRef';
            response.params = passedParams;
            return response;
        },
        async openTab({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openTab');
            params.actVal = 'openTab';
            for (let i in params) {
                if (i === 'length') continue;
                if (params[i] === 'isMissing') {
                    delete params[i];
                }
            }
            let psps = {
                'vol': 1,
                'opp': 2,
                'org': 3,
                'mem': 5,
                'prof': 14,
                'aff': 32
            };
            if (params.gridId && Array.isArray(params.gridId)) params.gridId = params.gridId[0];
            if (params.filterId && Array.isArray(params.filterId)) params.filterId = params.filterId[0];
            let pspID = psps[params.psp];
            if (
                pspID && (parseInt(params.gridId, 10) > 0 || parseInt(params.filterId, 10) > 0)
            ) {
                let gridFiltersResponse = await sDs.post('ec_getMainGridInfo', pspID, ["grids", "filters"]);
                let availableGrids = [];
                let availableFilters = [];
                if (gridFiltersResponse.status === 'success') {
                    availableGrids = gridFiltersResponse.data.grids || [];
                    availableFilters = gridFiltersResponse.data.filters || [];
                }
                let promises = [];
                if (parseInt(params.gridId, 10) > 0 && availableGrids.find((tmp) => tmp.CLIENT_GRID_SAVED_ID === parseInt(params.gridId, 10))) {
                    promises.push(sDs.post('er_setEcUserProperty', params.psp.toUpperCase() + '_savedGridID', parseInt(params.gridId, 10)));
                }
                if (parseInt(params.filterId, 10) > 0 && availableFilters.find((tmp) => tmp.FILTER_ID === parseInt(params.filterId, 10))) {
                    promises.push(sDs.post('er_setEcUserProperty', 'MainGrid_' + pspID + '_savedFilterID', parseInt(params.filterId, 10)));
                }
                // wait until all properties are set
                await library.promiseAllSettled(promises);
            }
            if (parent && typeof parent.processTab === 'function') {
                parent.processTab(pspID, params.gridId, params.filterId);
            } else {
                actionStore.actions.iframeProcessSubmit('openTab', params); // NOSONAR
            }
        },
        async viewDataset({ state, commit, dispatch }, payload) {
            let [params] = Object.values(payload);
            // Open up a dialog with cTitle, cId, cType
            let viewDatasetDialog = {
                name: 'dataset-dialog-template',
                template: `<div>
                    <div v-if="params.commonParams.value.length > 1" style="display: inline-block; width: 300px; margin-bottom: 20px;">
                        <control name="selectDataset" :prop-config="controls.selectDataset" :value="selectedDataset" @update:value="selectedDataset = $event"></control>
                    </div>
                    <div v-if="selectedDataset">
                        <dataset-pane :prop-dataset-id="selectedDataset"></dataset-pane>
                    </div>
                </div>`,
                data() {
                    return {
                        selectedDataset: '',
                        controls: {
                            selectDataset: {
                                type: 'dropdown',
                                id: 'selectDataset',
                                label: 'Select a Dataset to View',
                                default: ''
                            }
                        },
                        params: params
                    };
                },
                beforeMount() {
                    if (params.commonParams.value.length === 1) {
                        this.selectedDataset = params.commonParams.value[0];
                    }
                    else {
                        this.controls.selectDataset.items = params.commonParams.value;
                    }
                },
                components: {
                    control: controlComponent
                }
            };
            return library.showDialog(viewDatasetDialog, false, false, {
                title: 'View Dataset',
                name: 'viewDatasetDialog',
                size: 'full',
                preventCloseOnBackdropClick: true
            });
        },
        async createDataset({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'createDataset');
            let promiseResult = new Promise((resolve) => {
                let tmpWindow;
                configStore.getDevDashLocalInstanceDetails().then((instance) => {
                    let tmpUrl = instance.url + '/coordinator/index.php?editLocalDataset&pspID=' + params.psp + (instance.sId ? '&copyPHPSESSID=' + instance.sId : '');
                    tmpWindow = window.open(tmpUrl, 'editedDatasetArea', 'scrollbars=yes,resizable=yes,width=1000,height=1000,status=yes,top=100,left=100');
                });
                let tmpInterval = setInterval(() => {
                    if (tmpWindow.closed) {
                        clearInterval(tmpInterval);
                        resolve('done');
                    }
                }, 500); // NOSONAR
            });
            await promiseResult;
            configStore.getDatasetList(true);
        },
        checkSelect({ state, commit, dispatch }, payload) {
            let [recordsIDs, message, title] = Object.values(payload);
            if (typeof recordsIDs === 'string') recordsIDs = recordsIDs.split(',');
            if (typeof recordsIDs === 'number') recordsIDs = [recordsIDs];
            if (!recordsIDs || !recordsIDs.length) {
                let opt = { showAsAlert: true };
                if (title) opt['title'] = title;
                library.showDialog(message, false, false, opt);
                return false;
            }
            return true;
        },
        async newEntity({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'newEntity');
            params.width = 1000;
            params.height = 800;
            let limitSize;
            let totalSize;
            if (limitSize && totalSize && totalSize >= limitSize && params.psp === 1) {
                let message = await ddStore.getAlias('VOLUNTEER', 'VOLUNTEERMANAGER_LIMIT_REACHED');
                let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                library.showDialog(message, false, false, { title: title, showAsAlert: true });
            } else {
                actionStore.actions.iframeProcessSubmit('new', params);
            }
        },
        async editEntity({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'editEntity');
            params.width = 1000;
            params.height = 800;
            let abbrev = configStore.pspParentNamesAbbrev[params.psp];
            let button = await ddStore.getAlias('COMMON', 'BUTTON_EDIT');
            let message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_' + abbrev.toUpperCase() + '_NOT_SELECTED', button);
            let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
            if (actionStore.checkSelect(params.recordId, message, title)) {
                actionStore.actions.iframeProcessSubmit('edit', params);
            }
        },
        async copyEntity({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'copyEntity');
            // eslint-disable-next-line no-case-declarations
            let copyMessage = await ddStore.getAlias('DATA_GRID', 'GRIDENGINE_COPY_ATTRS_MSG');
            // eslint-disable-next-line no-case-declarations
            let copyHistoryLabel = await ddStore.getAlias('DATA_GRID', 'GRIDENGINE_COPY_HIST_NOTES');
            // eslint-disable-next-line no-case-declarations
            let copyOppSSLabel = await ddStore.getAlias('DATA_GRID', 'GRIDENGINE_COPY_OPPORTUNITY_SS');
            // eslint-disable-next-line no-case-declarations
            let copyPlacementsLabel = await ddStore.getAlias('DATA_GRID', 'GRIDENGINE_COPY_VOL_PLACEMENTS');
            // eslint-disable-next-line no-case-declarations
            let copyReferralsLabel = await ddStore.getAlias('DATA_GRID', 'GRIDENGINE_COPY_VOL_REFERRALS');
            // eslint-disable-next-line no-case-declarations
            let copyEmailsLabel = await ddStore.getAlias('DATA_GRID', 'GRIDENGINE_COPY_CONTACT_EMAILS');
            // eslint-disable-next-line no-case-declarations
            let choices = [
                {
                    id: 'copyHistory',
                    name: 'copyHistory',
                    type: 'checkbox',
                    label: copyHistoryLabel
                }
            ];
            if (params.psp === 2) {
                choices.push({
                    id: 'copyOppSS',
                    name: 'copyOppSS',
                    type: 'checkbox',
                    label: copyOppSSLabel
                });
            }
            if (params.psp === 1 || params.psp === 2) {
                choices.push({
                    id: 'copyPlacements',
                    name: 'copyPlacements',
                    type: 'checkbox',
                    label: copyPlacementsLabel
                });
                choices.push({
                    id: 'copyReferrals',
                    name: 'copyReferrals',
                    type: 'checkbox',
                    label: copyReferralsLabel
                });
                choices.push({
                    id: 'copyEmails',
                    name: 'copyEmails',
                    type: 'checkbox',
                    label: copyEmailsLabel
                });
            }
            // eslint-disable-next-line no-case-declarations
            let choiceValue = {};
            // eslint-disable-next-line no-case-declarations
            let choiceTemplate = {
                name: "choice-template",
                template: `<div>
                                        ` + copyMessage + `
                                        <div v-for="(choice, index) in choices" :key="index">
                                            <control :name="choice.name" :prop-config="choice" :value="choiceValue[choice.name]" @update:value="choiceValue[choice.name] = $event"></control>
                                        </div>
                                   </div>`,
                data() {
                    return {
                        choices: choices,
                        choiceValue: choiceValue
                    };
                },
                components: {
                    control: controlComponent
                }
            };
            // eslint-disable-next-line no-case-declarations
            let selectedRecords = params.recordId;
            if (selectedRecords.length > 1) {
                let pspNameMany = configStore.pspParentNamesPlural[params.psp].toLowerCase();
                choiceTemplate = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_COPY', selectedRecords.length, pspNameMany);
                choiceValue = {};
            }
            library.showDialog(choiceTemplate, () => {
                sDs.post('ec_copyRecords', params.psp, selectedRecords, choiceValue).then((response) => {
                    if (response.status === 'success') {
                        if (typeof params._this !== 'undefined') {
                            params.functionOnSuccess.call(params._this, response);
                        } else {
                            params.functionOnSuccess(response);
                        }
                        /* if (selectedRecords.length > 1) {
                            this.getGridData(true);
                        } else {
                            this.doAction('edit', { recordId: response.data[0] });
                        } */
                    }
                });
            });
        },
        async deleteEntity({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'deleteEntity');
            let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
            let abbrev = configStore.pspParentNamesAbbrev[params.psp];
            let button = await ddStore.getAlias('COMMON', 'BUTTON_DELETE');
            let message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_' + abbrev.toUpperCase() + '_NOT_SELECTED', button);
            if (actionStore.checkSelect(params.recordId, message, title)) {
                let selectedRecords = params.recordId;
                if (selectedRecords.length) {
                    sDs.post('ec_deleteRecords', params.psp, selectedRecords, {}, true).then((response) => {
                        if (response.status !== 'success') return;
                        let message = response.data && response.data.messages ? response.data.messages.join('<br>') : '';
                        let choices = [];
                        let choiceValue = {};
                        let opt = {};
                        let additionalData = {};
                        if (response.data.options) {
                            message += '<br>' + response.data.optionsTitle;
                            if (params.psp !== 3) {
                                for (let i in response.data.options) {
                                    if (i === 'length') continue;
                                    let name = response.data.options[i].name || i;
                                    let type = 'checkbox';
                                    let note = response.data.options[i].note || '';
                                    choices.push(
                                        {
                                            id: i,
                                            name: name,
                                            type: type,
                                            label: response.data.options[i].label,
                                            note: note
                                        }
                                    );
                                }
                            } else {
                                let name = 'orgDeletionOppChoice';
                                let type = 'radio_button_list';
                                let items = [];
                                let defaultValue;
                                for (let i in response.data.options) {
                                    if (i === 'length') continue;
                                    if (!defaultValue) defaultValue = i;
                                    items.push({
                                        text: response.data.options[i].label,
                                        label: response.data.options[i].label,
                                        value: i,
                                        note: response.data.options[i].note || ''
                                    });
                                }
                                choices.push(
                                    {
                                        id: name,
                                        name: name,
                                        type: type,
                                        fields: { text: 'text', value: 'value' },
                                        items: items
                                    }
                                );
                                choiceValue[name] = defaultValue;
                                opt['doNotCloseOnFuncFailure'] = true;
                                additionalData['labels'] = response.data.labels;
                                let orgList = [];
                                for (let i in response.data.orgList) {
                                    if (i === 'length') continue;
                                    orgList.push({
                                        text: response.data.orgList[i],
                                        value: i
                                    });
                                }
                                additionalData['orgList'] = orgList;
                                additionalData['deletingOrgList'] = response.data.deletingOrgList;
                                additionalData['associatedOppList'] = response.data.associatedOppList;
                            }
                        }
                        let popupThis = {};
                        let choiceTemplate = {
                            name: "choice-template",
                            template: ` <div>
                                                    <div v-if="step === 1">
                                                        <div v-html="message"></div>
                                                        <div v-for="(choice, index) in choices" :key="index">
                                                            <control :name="choice.name" :prop-config="choice" :value="choiceValue[choice.name]" @update:value="choiceValue[choice.name] = $event"></control>
                                                        </div>
                                                    </div>
                                                    <div v-if="step === 2">
                                                        <div class="deletedialog-outer-div">
                                                            <div class="deletedialog-inner-center-div deletedialog-title-div">
                                                                {{labels['GRIDENGINE_REASSIGN_OPP_TITLE']}}
                                                            </div>
                                                            <div>
                                                                {{labels['GRIDENGINE_REASSIGN_STEP_1']}}
                                                            </div>
                                                            <br><br>
                                                            <div class="deletedialog-inner-left-div">
                                                                <div style="display: none;">
                                                                    Would you like to:
                                                                </div>
                                                                <div class="deletedialog-reassign-options-div">
                                                                    <div id="oppList_placeholder">
                                                                        <div class="deletedialog-inner-left-div deletedialog-reassign-opplist-div deletedialog-reassign-opplist-div-outer">
                                                                            <div class="deletedialog-title-div">
                                                                                <control :name="oppList.name" :prop-config="oppList" :items="additionalData.orgList" value="selectedOrg" @update:value="selectedOrg = $event"></control>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="deletedialog-button-pane-div">
                                                                <control :name="backButton.name" :prop-config="backButton" :label="labels['GRIDENGINE_REASSIGN_BUTTON_BACK']" :onclick="backToChoices"></control>
                                                                <control :name="nextButton.name" :prop-config="nextButton" :label="labels['GRIDENGINE_REASSIGN_BUTTON_NEXT']" :onclick="next"></control>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="step === 3">
                                                        <div>
                                                            <div class="deletedialog-inner-center-div deletedialog-title-div">
                                                                {{labels['GRIDENGINE_REASSIGN_OPP_TITLE']}}
                                                            </div>
                                                            <div>
                                                                {{labels['GRIDENGINE_REASSIGN_STEP_2']}}
                                                            </div>
                                                            <br><br>
                                                            <div class="deletedialog-inner-center-div-pad">
                                                                 <div class="deletedialog-inner-left-div deletedialog-reassign-opplist-div deletedialog-reassign-confirm-opplist-div">
                                                                     <div class="deletedialog-reassign-opplist-div-review">
                                                                        {{labels['GRIDENGINE_REASSIGN_OPP_REVIEW']}}
                                                                     </div>
                                                                 </div>
                                                                 <div id="oppListConfirm_placeholder">
                                                                    <div class="deletedialog-inner-left-div deletedialog-reassign-opplist-div deletedialog-reassign-confirm-opplist-div deletedialog-reassign-opplist-div-outer deletedialog-reassign-opplist-div-review">
                                                                        {{labels['GRIDENGINE_REASSIGN_COMFIRM_SAME_ORG_1']}} {{additionalData['deletingOrgList']}}<br>{{labels['GRIDENGINE_REASSIGN_COMFIRM_SAME_ORG_2']}} {{selectedOrgName}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="deletedialog-button-pane-div">
                                                                <control :name="backButton.name" :prop-config="backButton" :label="labels['GRIDENGINE_REASSIGN_CONFIRM_BUTTON_BACK']" :onclick="back"></control>
                                                                <control :name="confirmButton.name" :prop-config="confirmButton" :label="labels['GRIDENGINE_REASSIGN_CONFIRM_BUTTON_CONFIRM']" :onclick="confirm"></control>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>`,
                            data() {
                                return {
                                    message: message,
                                    choices: choices,
                                    choiceValue: choiceValue,
                                    selectedRecords: selectedRecords,
                                    additionalData: additionalData,
                                    selectedOrg: null,
                                    selectedOrgName: '',
                                    step: 1,
                                    backButton: {
                                        name: 'backButton',
                                        id: 'backButton',
                                        type: 'button'
                                    },
                                    nextButton: {
                                        name: 'nextButton',
                                        id: 'nextButton',
                                        type: 'button'
                                    },
                                    confirmButton: {
                                        name: 'confirmButton',
                                        id: 'confirmButton',
                                        type: 'button'
                                    },
                                    oppList: {
                                        name: 'oppList',
                                        id: 'oppList',
                                        label: 'New Organization',
                                        type: 'dropdown',
                                        fields: { text: 'text', value: 'value' }
                                    }
                                };
                            },
                            components: {
                                control: controlComponent
                            },
                            created() {
                                popupThis = this;
                            },
                            computed: {
                                labels() {
                                    return this.additionalData && this.additionalData.labels ? this.additionalData.labels : {};
                                }
                            },
                            methods: {
                                changeStep(step) {
                                    popupThis.step = step;
                                },
                                backToChoices() {
                                    popupThis.step = 1;
                                },
                                back() {
                                    popupThis.step = 2;
                                },
                                next() {
                                    if (popupThis.step === 3) return;
                                    if (!popupThis.selectedOrg) {
                                        library.showDialog('Please select organization to be assigned.', false, false, { showAsAlert: true });
                                        return;
                                    }
                                    let org = additionalData.orgList.find((tmpOrg) => tmpOrg.value === popupThis.selectedOrg);
                                    if (org) popupThis.selectedOrgName = org.text;
                                    popupThis.step = 3;
                                },
                                confirm() {
                                    let asd = popupThis.selectedRecords;
                                    let asd1 = popupThis.selectedOrg;
                                    let aaa = popupThis.additionalData.associatedOppList;
                                    // debugger;
                                }
                            }
                        };
                        let changeStep = choiceTemplate.methods.changeStep;
                        library.showDialog(choiceTemplate, () => {
                            if (params.psp === 3 && choiceValue['orgDeletionOppChoice'] && choiceValue['orgDeletionOppChoice'].indexOf(2) !== -1) {
                                changeStep(2);
                                return false;
                            }
                            sDs.post('ec_deleteRecords', params.psp, selectedRecords, choiceValue).then((response) => {
                                if (response && response.status === 'success') {
                                    if (typeof params.functionOnSuccess === 'function') {
                                        if (typeof params._this !== 'undefined') {
                                            params.functionOnSuccess.call(params._this, response);
                                        } else {
                                            params.functionOnSuccess(response);
                                        }
                                    }
                                }
                                // @todo reload data
                                // this.getGridData(true);
                            });
                            return true;
                        }, false, opt);
                    });
                }
            }
        },
        async restoreEntity({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'restoreEntity');
            let abbrev = configStore.pspParentNamesAbbrev[params.psp];
            let button = await ddStore.getAlias('COMMON', 'BUTTON_RESTORE');
            let message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_' + abbrev + '_NOT_SELECTED', button);
            let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
            if (actionStore.checkSelect(params.recordId, message, title)) {
                params.width = 1000;
                params.height = 800;
                // actionStore.actions.iframeProcessSubmit('restoreEntity', params);
            }
        },
        async placeRefVolOpp({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'place');
            sDs.post('ec_placeRefVolOpp', params.oppIDs, params.isReferral, params.recordsIDs, params.recordsPsp).then((response) => {
                if (response && response.status === 'success') {
                    let message = response.data && response.data.messages ? response.data.messages.join('<br>') : '';
                    let options = response.data && response.data.options ? response.data.options : [];
                    let placementInformerKey = response.data && response.data.placementInformerKey ? response.data.placementInformerKey : '';
                    let choiceValue = {};
                    let choices = [];
                    for (let i in options) {
                        if (i === 'length') continue;
                        if (typeof options[i] === 'string') {
                            message += options[i] + '<br><br><br>';
                        } else {
                            choices.push({
                                id: options[i].VOLUNTEER_ID + '_' + options[i].OPPORTUNITY_ID,
                                name: options[i].VOLUNTEER_ID + '_' + options[i].OPPORTUNITY_ID,
                                title: options[i].OPP_TITLE,
                                type: 'checkbox',
                                label: options[i].confirm
                            });
                        }
                    }
                    let choiceTemplate = {
                        name: "choice-template",
                        template: ` <div>
                                        <div v-html="message"></div>
                                        <div v-for="(choice, index) in choices" :key="index">
                                            <div v-if="choice.title" class="ref-place-choice-title">{{choice.title}}:</div><br/>
                                            <control :name="choice.name" :prop-config="choice" :value="choiceValue[choice.name]" @update:value="choiceValue[choice.name] = $event"></control>
                                        </div>
                                    </div>`,
                        data() {
                            return {
                                message: message,
                                choices: choices,
                                choiceValue: choiceValue
                            };
                        },
                        components: {
                            control: controlComponent
                        }
                    };
                    let confirmOpt = {
                        name: 'referPlace'
                    };
                    if (message || options.length) {
                        library.showDialog(choiceTemplate, () => {
                            let openPlacementInformer = !!placementInformerKey;
                            for (let i in choiceValue) {
                                if (i === 'length') continue;
                                if (choiceValue[i]) openPlacementInformer = false;
                            }
                            if (openPlacementInformer) {
                                actionStore.openPlacementInformer({ recordId: placementInformerKey });
                            }
                        },
                        () => {
                            let openPlacementInformer = !!placementInformerKey;
                            if (openPlacementInformer) {
                                actionStore.openPlacementInformer({ recordId: placementInformerKey });
                            }
                        }, confirmOpt);
                    }
                }
            });
        },
        async place({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            passedParams.isReferral = false;
            actionStore.placeRefVolOpp(passedParams);
        },
        async refer({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            passedParams.isReferral = true;
            actionStore.placeRefVolOpp(passedParams);
        },
        async openLogBook({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openCustomizeSort');
            params.cssClass = 'fullscreen-dialog';
            if (!params.actVal) params.actVal = 'logbook_acc';
            actionStore.actions.iframeProcessSubmit(params.actVal, params);
        },
        async openCustomizeSort({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openCustomizeSort');
            params.width = 800;
            params.height = 400;
            params.actVal = 'customizeSort';
            actionStore.actions.iframeProcessSubmit('customizeSort', params);
        },
        async openPlacementInformer({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openPlacementInformer');
            params.width = 1000;
            params.height = 820;
            params.actVal = 'placementInformer';
            actionStore.actions.iframeProcessSubmit('placementInformer', params);
        },
        async openPlace({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openPlace');
            params.width = 1000;
            params.height = 820;
            let abbrev = configStore.pspParentNamesAbbrev[this.psp];
            let button = await ddStore.getAlias('COMMON', 'BUTTON_PLACE');
            let message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_' + abbrev + '_NOT_SELECTED', button);
            let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
            if (actionStore.checkSelect(params.recordId, message, title)) {
                actionStore.actions.iframeProcessSubmit('place', params);
            }
        },
        async openQuicklogbook({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openQuicklogbook');
            // @todo
        },
        async openCalendar({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openCalendar');
            params.cssClass = 'fullscreen-dialog';
            actionStore.actions.iframeProcessSubmit('calendar', params);
        },
        async openMyInfo({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openMyInfo');
            params.width = 1000;
            params.height = 800;
            actionStore.actions.iframeProcessSubmit('myInfo', params);
        },
        async openCustomizeGrid({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openCustomizeGrid');
            params.width = 1200;
            params.height = 800;
            params.cssClass = 'show-only-content-popup';
            return actionStore.actions.iframeProcessSubmit('customizeGrid', params);
        },
        async openChangeMyUserInfo({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openChangeMyUserInfo');
            params.width = 500;
            params.height = 600;
            actionStore.actions.iframeProcessSubmit('changeMyUserInfo', params);
        },
        async openChangeMyInfo({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openChangeMyInfo');
            params.width = 500;
            params.height = 600;
            actionStore.actions.iframeProcessSubmit('changeMyInfo', params);
        },
        async openCustomAttr({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openCustomAttr');
            params.width = 770;
            params.height = 600;
            actionStore.actions.iframeProcessSubmit('customAttr', params);
        },
        async openAdminOption({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openAdminOption');
            params.width = 1300;
            params.height = 800;
            actionStore.actions.iframeProcessSubmit('adminOption', params);
        },
        async openHelpMenu({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openHelpMenu');
            delete params.openInSameWindow;
            actionStore.actions.iframeProcessSubmit(params.act, params);
        },
        async openAgreements({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openAgreements');
            delete params.fromTopMenu;
            params.addECCss = true;
            params.hideOpenInNewWindow = true;
            params.backendAct = 'agreements';
            params.width = 400;
            params.height = 250;
            actionStore.actions.iframeProcessSubmit('agreements', params);
        },
        openAbout({ state, commit, dispatch }, payload) {
            let currentYear = this.configStore.currentYear || "";
            let dialogComponent = {
                name: 'about',
                template: `
                        <div class="about-section">
                            <br>
                            <b>eCoordinator</b>
                            <br>
                            <br>
                            <build-info c-id="buildInfo_vms_about"></build-info>
                            <br>
                            <br>
                            Copyright 2000-` + currentYear + ` Samaritan Technologies
                            <br>
                            All rights reserved.
                        </div>
                    `,
                data() {
                    return {};
                },
                components: {
                    buildInfo: defineAsyncComponent(() => import('@common/buildInfo.vue')),
                }
            };
            let opt = {
                name: 'about',
                showAsAlert: true
            };
            library.showDialog(dialogComponent, false, false, opt);
        },
        logout({ state, commit, dispatch }, payload) {
            let [params] = Object.values(payload);
            uStore().logout(params.psp);
        },
        async testAction({ state, commit, dispatch }, payload) {
            let [params] = Object.values(payload);
            let msg = '<div>'
                + '<br/>Param 1: ' + params.param1
                + '<br/>Param 2: ' + params.param2
                + '<br/>Toggle Boolean is ' + (params.testToggleBoolean ? 'enabled' : 'disabled') + ' (using param 2): ' + (params.testToggleBoolean ? !params.param2 : params.param2)
                + '<br/>Param 3: ' + params.param3
                + '<br/>Param 4: ' + params.param4
                + '<br/>Offset Number by ' + params.offset + ' (using param 4): ' + (params.param4 + params.offset)
                + '</div>';
            await library.showDialog(msg, false, false, { title: 'Test Action', showAsAlert: true });
        },
        async createComponent({ state, commit, dispatch }, payload) {
            let [passedParams, paramMixins, dialogOptions] = Object.values(payload);
            if (paramMixins && paramMixins.controlLabelType) {
                let label = library.titleCase(paramMixins.controlLabelType);
                let label2 = paramMixins.controlLabelType;
                paramMixins = {
                    cTitle: {
                        text: `${label} Title`,
                        default: `New ${label}`
                    },
                    cId: {
                        text: `${label} ID`,
                        default: `${label2}Id1`
                    },
                    isPublic: {
                        text: `${label} is Public`,
                        default: false
                    },
                    createFromCopy: {
                        text: `Copy Existing ${label}?`,
                        helpText: `Select the ${label2} you want to copy.`,
                    },
                    componentToCopy: {
                        text: `${label} To Copy`
                    }
                };
            }
            let params = await actionStore.actions.checkParams(passedParams, 'createComponent', paramMixins, dialogOptions);
            // Send the data to componentStore new component action
            if (params.cId.indexOf(params.cType) !== 0) {
                params.cId = params.cType + '_' + params.cId;
            }
            let response;
            for (let i in params) {
                if (i === 'length') continue;
                if (params[i] === 'isMissing') {
                    delete params[i];
                }
            }
            if (params.createFromCopy && params.componentToCopy) {
                response = await componentStore.copyComponent(params.componentToCopy, params.cId, params.cTitle, params.isPublic);
            }
            else {
                response = await componentStore.newComponent(params.cType, params.cId, params.cTitle, true, params.isPublic);
            }
            if (response === params.cId) {
                library.showToast('New component "' + params.cTitle + '" created! You can now select the component in your dropdown lists and component menu.', { timeout: 30 });
            }
            return response;
        },
        async openAddhours({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openAddhours');
            let uniqueID = library.getUniqueID();
            let recordIDs = [];
            for (let i in params.recordId) {
                if (i === 'length') continue;
                if (typeof params.recordId[i] === 'string') {
                    recordIDs.push(...params.recordId[i].split(','));
                } else {
                    recordIDs.push(params.recordId[i]);
                }
            }
            let addHoursDialogCmp;
            let addHoursDialogTemplate = {
                name: "add-hours-popup_" + uniqueID,
                template: `<div id="dialog-template-add-hours">
                                <add-hours ref="addHoursCmp" :prop-recordIDs="recordIDs" :prop-psp="psp" @update:hours-added="closePopUp"></add-hours>
                           </div>`,
                data() {
                    return {
                        recordIDs: recordIDs,
                        psp: params.psp,
                    };
                },
                created() {
                    addHoursDialogCmp = this;
                },
                methods: {
                    closePopUp() {
                        library.hideDialog('openAddHours', false, false, true);
                    }
                },
                components: {
                    control: controlComponent,
                    addHours: defineAsyncComponent(() => import('@components/common/addHours'))
                },
            };
            return library.showDialog(addHoursDialogTemplate, false, false, {
                title: 'Add Hours',
                name: 'openAddHours',
                preventCloseOnBackdropClick: true,
                width: '390px',
                cssClass: 'hide-footer',
                doNotCloseOnFuncFailure: true,
                closeAfterSeconds: 1
            }, false, () => {
                if (addHoursDialogCmp
                    && addHoursDialogCmp.$refs
                    && addHoursDialogCmp.$refs['addHoursCmp']
                    && typeof addHoursDialogCmp.$refs['addHoursCmp'].clearAll === 'function') {
                    addHoursDialogCmp.$refs['addHoursCmp'].clearAll();
                }
            });
        },
        async openPdf({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = library.cloneObj(passedParams);
            let pdf;
            let showComponent;
            let uniqueID = library.getUniqueID();
            let doNotSaveOnSuccess = false;
            if (!params.mode) {
                // called from action, not from pdf
                params.mode = 'viewer';
                params.templateHash = params.fileHash;
                delete params.fileHash;
                doNotSaveOnSuccess = true;
            }
            let pdfDialogTemplate = {
                name: "pdf-open-popup_" + uniqueID,
                template: `<div id="dialog-template-pdf" v-if="show">
                                <pdf :c-id="'pdf__' + uniqueID" 
                                     :editor-enabled="false" 
                                     ref="PDF" 
                                     :prop-hash="fileHash" 
                                     :prop-template-hash="templateHash" 
                                     :prop-vol-id="volId" 
                                     :prop-opp-id="oppId"
                                     :prop-org-id="orgId"
                                     :prop-mem-id="memId"
                                     :prop-slot-id="slotId"
                                     :prop-acc-id="accId"
                                     :prop-lbe-id="lbeId"
                                     :prop-aff-id="affId"
                                     :prop-ae-id="aeId"
                                     :prop-assignment-id="assignmentId"
                                     :prop-endpoint-id="endpointId"
                                     :prop-mode="mode"
                                     :prop-is-inline="true"
                                     :prop-record-id="recordID"
                                     :prop-psp-id="pspID"
                                     :prop-file-name="fileName"
                                     :prop-control-name="controlName"
                                     :prop-attach-id="attachID"
                                     :prop-is-new="isNew"
                                     :prop-disable-fields="disableFields"
                                     :prop-signer-index="signerIndex"
                                     :prop-do-not-show-agreement="doNotShowAgreement"
                                     @update:prop-component-loaded="componentLoaded()"
                                ></pdf>
                            </div>`,
                data() {
                    return {
                        uniqueID: uniqueID,
                        fileHash: params.fileHash || '',
                        templateHash: params.templateHash || '',
                        volId: params.volId,
                        oppId: params.oppId,
                        orgId: params.orgId,
                        memId: params.memId,
                        lbeId: params.lbeId,
                        slotId: params.slotId,
                        accId: params.accId,
                        affId: params.affId,
                        assignmentId: params.assignmentId,
                        endpointId: params.endpointId,
                        aeId: params.aeId,
                        mode: params.mode === 'editor' ? 'editor-popup' : params.mode,
                        recordID: params.recordID,
                        pspID: params.pspID,
                        fileName: params.fileName,
                        controlName: params.controlName,
                        attachID: params.attachID,
                        isNew: params.isNew,
                        disableFields: params.disableFields,
                        signerIndex: params.signerIndex,
                        controls: {
                            PDF_VIEWER: {
                                type: 'pdfViewer',
                                id: 'PDF_VIEWER'
                            }
                        },
                        show: false,
                        doNotShowAgreement: params.doNotShowAgreement
                    };
                },
                mounted() {
                    if (this.$refs && this.$refs['PDF']) pdf = this.$refs['PDF'];
                    showComponent = this.showComponent;
                },
                methods: {
                    showComponent() {
                        this.show = true;
                    },
                    componentLoaded() {
                        if (this.$refs && this.$refs['PDF']) {
                            pdf = this.$refs['PDF'];
                        }
                    }
                },
                updated() {
                    if (this.$refs && this.$refs['PDF']) {
                        pdf = this.$refs['PDF'];
                    }
                    showComponent = this.showComponent;
                },
                components: {
                    store,
                    control: controlComponent,
                },
            };
            let preSuccessFunction = async () => {
                if (doNotSaveOnSuccess) return true;
                let isValid = await pdf.formIsValid();
                if (isValid) {
                    let base64 = await pdf.save();
                    if (base64 === false) return false;
                    return base64;
                }
                return false;
            };
            let funcPostClose = () => {
                if (pdf && typeof pdf.destroy === 'function') pdf.destroy();
            };
            let openFunc = () => {
                if (typeof showComponent === 'function') showComponent();
            };
            let funcOnFailure = () => {
                if (pdf) {
                    return pdf.pdfLoaded || pdf.isNew;
                }
                return false;
            };
            return library.showDialog(pdfDialogTemplate, false, funcOnFailure, {
                title: 'View PDF',
                name: 'openPdf',
                preventCloseOnBackdropClick: true,
                size: 'fullscreen',
                doNotCloseOnFuncFailure: true,
                doNotCloseOnFuncCloseFailure: true,
                closeAfterSeconds: 1,
                doNotCloseOnOK: true,
                showCloseIcon: false,
                closeOnEscape: false,
                cssClass: 'hide-header-content-popup',
                hideTitle: true,
            }, preSuccessFunction, funcPostClose, openFunc);
        },
        async runChainedActions({ state }, payload) {
            let [actions, record, component] = Object.values(payload);
            let responses = [];
            actions = actions.filter((tmpAction) => typeof tmpAction.action === 'string' && typeof tmpAction.params === 'object');
            for (const aConfig of actions) {
                if (!aConfig.action) continue;
                const index = actions.indexOf(aConfig);
                const nextAction = actions[index + 1];
                let response;
                let chainingInProcess = index < actions.length - 1;
                if (index === 0) {
                    let payload = library.recordSourceMapper(aConfig.action, aConfig.params, record, component, true);
                    response = actionStore[aConfig.action](payload, chainingInProcess);
                    responses.push(response);
                } else response = responses[index]; // called by previous action.  See below:
                // Call the next action
                if (nextAction) {
                    let payload = library.recordSourceMapper(nextAction.action, nextAction.params, record, component, true);
                    if (aConfig.params && aConfig.params.runNext === 'parallel') {
                        if (typeof actionStore[nextAction.action] === 'function') {
                            responses.push(actionStore[nextAction.action](payload, chainingInProcess));
                        }
                    }
                    else {
                        // Synchronously (by default)
                        // eslint-disable-next-line no-await-in-loop
                        let result = await response;
                        let resultStatus = typeof result?.status !== 'undefined' ? result.status : result?.dialogResponse?.status;
                        if (aConfig.params.executeIfResponse !== 'any' && typeof resultStatus !== 'undefined' && aConfig.params.executeIfResponse !== resultStatus) {
                            // TODO possibly use continue here if we make a setting like "skipOnInvalidResponse"
                            return;
                        }
                        if (typeof actionStore[nextAction.action] === 'function') {
                            responses.push(actionStore[nextAction.action](payload, chainingInProcess));
                        }
                    }
                }
            }
        },
        async openLMSModule({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openLMSModule');
            let uniqueID = library.getUniqueID();
            let frameLoaded = false;
            let response = {};
            if (params.lmsModuleURL) {
                window.global_lmsStatus = null;
                let openLMSModuleDialogTemplate = {
                    name: "open-lms-modal-popup_" + uniqueID,
                    template: `
                    <iframe :ref="'openLmsModalFrame' + uniqueID" :id="'openLmsModalFrame' + uniqueID" :src="lmsModuleURL" width="100%" height="100%" @load="load"></iframe>
                `,
                    data() {
                        return {
                            uniqueID: uniqueID,
                            lmsModuleURL: params.lmsModuleURL,
                            frameLoaded: false
                        };
                    },
                    computed: {
                        recruiterID() {
                            let recruiterID = false;
                            if (typeof RECRUITER_ID !== 'undefined') recruiterID = RECRUITER_ID;
                            return recruiterID;
                        }
                    },
                    methods: {
                        load() {
                            if (!this.frameLoaded) {
                                this.frameLoaded = true;
                                frameLoaded = true;
                                window.openedFrom_devDash = true;
                            } else {
                                // Runs on iframe redirect
                                response.status = 'failure';
                                if (window.global_lmsStatus === 'Complete') {
                                    response.status = 'success';
                                    library.hideAllDialogs();
                                }
                                setTimeout(() => {
                                    window.openedFrom_devDash = false;
                                }, 2000);
                            }
                        }
                    },
                    updated() {},
                    components: {
                        store,
                        control: controlComponent
                    },
                };
                let funcOnSuccess = () => {
                    if (!frameLoaded || window.global_lmsStatus !== 'Complete') {
                        library.showDialog('If you cancel the module, your progress will not be recorded. Are you sure you want to cancel?', () => {
                            response.status = 'failure';
                            library.hideAllDialogs();
                        }, false, { okButtonLabel: 'Yes, Cancel', cancelButtonLabel: 'Stay and finish' });
                        return false;
                    }
                    return true;
                };
                response.dialogResponse = await library.showDialog(openLMSModuleDialogTemplate, funcOnSuccess, false, {
                    title: ' ',
                    name: 'openLMSModule',
                    preventCloseOnBackdropClick: true,
                    size: 'fullscreen',
                    showCloseIcon: false,
                    closeOnEscape: false,
                    isComponentDialog: true,
                    resizeDialogToIframeHeight: 'openLmsModalFrame' + uniqueID,
                    hideTitle: true,
                    cssClass: 'hide-cancel',
                    okButtonLabel: 'Cancel',
                    doNotCloseOnFuncFailure: true
                });
            } else {
                response.status = 'failure';
                response.error = 'Not all params are passed to the action';
            }
            response.action = 'openLMSModule';
            response.params = passedParams;
            return response;
        },
        async openSchedulingModal({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openSchedulingModal');
            let uniqueID = library.getUniqueID();
            let response = {};
            let dialogOptions = {
                title: 'Schedule',
                name: 'openSchedulingModal',
                preventCloseOnBackdropClick: true,
                // size: 'fullscreen',
                showCloseIcon: true,
                closeOnEscape: false,
                isComponentDialog: true,
                // cssClass: 'show-only-content-popup',
                width: '800px',
                height: 'auto'
            };
            if (typeof params.scheduleDialogSettings === 'object') library.mergeObj(dialogOptions, params.scheduleDialogSettings);
            let shiftPlacements = [];
            let schedulingModalDialogTemplate = {
                name: "open-scheduling-modal-popup_" + uniqueID,
                template: `
                    <div class="open-scheduling-modal">
                        <div style="font-size: 1.125rem;">
                            <p v-if="shiftsLoaded && visibleSlots.length && startDate && endDate">You are viewing shifts from {{startDate}} to {{endDate}}</p>
                            <p v-if="shiftsLoaded && !visibleSlots.length">There are no shifts available at this time.</p>
                            <p v-if="!shiftsLoaded" class="loading-message">Loading Shifts...</p>
                        </div>
                        <div v-if="rescheduleEnabled && currentPlacements.length && !showRescheduleOptions">
                            <p>
                                Your current shift is listed above.  To reschedule, click the reschedule button and choose a new shift.
                                This will remove you from your current shift, and place you with a new one.<br/><br/>
                                <control name="SHOW_RESCHEDULE_BUTTON" :prop-config="showRescheduleButton"></control>
                            </p>
                        </div>
                        <div class="slot-record-wrapper">
                            <div class="mt20 slot-record" v-for="(slot,index) in visibleSlots" :key="index"
                                 :slot-id="slot.ID" :class="{ 'schedule-dialog-placed-slot': slot.placed }">
                                <div class="media-left">
                                    <div class="media-object slot-date-thumb"
                                         :class="slot.isMultiDay && slot.dayNum !== slot.endDayNum ? 'multi-day' : ''">
                                        <div class="s-month">{{ slot.month }}</div>
                                        <div class="s-date">{{ slot.dayNum }}<span class="multi-date"
                                                                                   v-if="slot.dayNum !== slot.endDayNum">-
                                            {{ slot.endDayNum }}</span></div>
                                        <div class="s-day">{{ slot.day }}<span class="multi-date"
                                                                               v-if="slot.dayNum !== slot.endDayNum">-
                                            {{ slot.endDay }}</span></div>
                                    </div>
                                </div>

                                <div class="media-body" style="padding-left: 10px;">
                                    <div class="slot-description-wrapper">
                                        <div v-if="slot.placed" style="font-weight: bold; color: #0f8d0f;">This is your
                                            current shift
                                        </div>
                                        <div class="media-heading">
                                            {{ slot.SS_TITLE ? slot.SS_TITLE : slot.OPP_TITLE }}
                                        </div>
                                        <div class="slot-start-time">
                                            {{ slot.SS_START_TIME }}
                                            <span class="multi-day-time-date"
                                                  v-if="slot.isMultiDay && slot.dayNum !== slot.endDayNum">{{ slot.dayString }}</span>
                                            - {{ slot.SS_FINISH_TIME }}
                                            <span class="multi-day-time-date"
                                                  v-if="slot.isMultiDay && slot.dayNum !== slot.endDayNum">{{ slot.endDayString }}</span>
                                        </div>
                                        <div v-if="slot.SS_PICKUP_INSTR" class="location-description">
                                            <span v-html="slot.SS_PICKUP_INSTR"></span>
                                        </div>

                                        <div class="slot-repetition"
                                             v-if="slot.SS_REPEATED==='Yes' && slot.SS_REPEAT_TERM && slot.SS_REPEAT_TERM!=='' && slot.SS_REPEAT_SHOW_ONCE==='Yes'">
                                                <span class="slot-repetition-schedule">
                                                    {{ slot.SS_REPEAT_TERM }}}
                                                </span>
                                        </div>

                                        <div
                                            v-if="slot.SS_DESC!=='N/A' && slot.SS_DESC!=='none' && slot.SS_DESC!=='.' && slot.SS_DESC!=='-'"
                                            class="single-slot-record-desc">{{ slot.SS_DESC }}
                                        </div>
                                        <div v-if="slot.SS_NOTE">{{ slot.SS_NOTE }}</div>
                                    </div>
                                    <div class="slot-actions-wrapper">
                                        <div class="slot-availability">
                                            <span class="placement-limit" v-if="!slot.placed && maxShiftSignup && currentPlacements.length >= maxShiftSignup">
                                                Maximum reached
                                            </span>
                                            <span v-if="slot.placed">You are placed with this shift.</span>
                                            <span class="avail-label-open" v-else-if="slot.SS_AVAIL_POSITION">
                                                <span>{{ slot.SS_AVAIL_POSITION }}</span>
                                                <span v-show="slot.SS_AVAIL_POSITION > 1">&nbsp;openings</span>
                                                <span v-show="slot.SS_AVAIL_POSITION === 1">&nbsp;opening</span>
                                            </span>
                                            <span v-else-if="slot.SS_AVAIL_POSITION === 0" class="avail-label-full">
                                                schedule slot is full
                                            </span>
                                        </div>
                                        <div v-if="slot.placed || (slot.SS_AVAIL_POSITION && (!maxShiftSignup || currentPlacements.length < maxShiftSignup))">
                                            <control name="REMOVE_BUTTON" v-if="slot.placed" :prop-config="removeButton"
                                                     :actionParams="slot"></control>
                                            <control name="SIGNUP_BUTTON" v-else :prop-config="signupButton"
                                                     :actionParams="slot"></control>
                                        </div>
                                        <div v-if="recruiterID && enableMoreLinks">
                                            <control :name="'DETAILS__' + index" :prop-config="detailsControl"
                                                     :actionParams="slot"></control>
                                            <control :name="'MORE__' + index" :prop-config="moreControl"
                                                     :actionParams="slot"></control>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="slot-load-more-wrapper" v-if="visibleSlots.length !== slots.length && (!rescheduleEnabled || showRescheduleOptions)">
                            <control name="SEE_MORE" :prop-config="seeMoreControl"
                                     :label="'see more (' + (slots.length - visibleSlots.length) + ' not shown )'"></control>
                        </div>
                    </div>
                `,
                data() {
                    return {
                        uniqueID: uniqueID,
                        recordId: params.recordId,
                        aeSsOrgId: params.aeSsOrgId,
                        volId: params.volId,
                        maxShiftSignup: params.maxShiftSignup,
                        rescheduleEnabled: params.rescheduleEnabled,
                        showRescheduleOptions: false,
                        shiftsLoaded: false,
                        slots: [],
                        visibleSlotsCount: 20,
                        parsedStartDate: library.parseRelativeDate(params.startDate),
                        parsedEndDate: library.parseRelativeDate(params.endDate),
                        enableMoreLinks: params.enableMoreLinks,
                        seeMoreControl: {
                            name: 'SEE_MORE',
                            label: 'see more',
                            type: 'button',
                            onclick: 'seeMoreAction',
                        },
                        detailsControl: {
                            name: 'DETAILS',
                            label: 'Details',
                            type: 'button',
                            onclick: 'detailsAction',
                        },
                        moreControl: {
                            name: 'MORE',
                            label: 'more',
                            type: 'dropdownbutton',
                            fields: { text: 'label', value: 'key' },
                            items: [
                                { label: 'See your Schedule', key: 'schedule' },
                                { label: 'See your Dashboard', key: 'dashboard' },
                                /* { label: 'See more for this organization', key: 'org' }, */
                            ],
                            onselect: 'moreAction',
                            cssClass: 'e-flat'
                        },
                        showRescheduleButton: {
                            name: 'SHOW_RESCHEDULE_BUTTON',
                            label: 'Reschedule',
                            width: "200px",
                            type: 'button',
                            onclick: 'showReschedule'
                        },
                        signupButton: {
                            name: 'SIGNUP_BUTTON',
                            label: 'Schedule',
                            type: 'button',
                            onclick: 'shiftSignup'
                        },
                        removeButton: {
                            name: 'REMOVE_BUTTON',
                            label: 'Remove',
                            type: 'button',
                            onclick: 'shiftRemoval'
                        }
                    };
                },
                computed: {
                    recruiterID() {
                        let recruiterID = false;
                        if (typeof RECRUITER_ID !== 'undefined') recruiterID = RECRUITER_ID;
                        if (params.recruiterID) recruiterID = params.recruiterID;
                        return recruiterID;
                    },
                    currentPlacements() {
                        return this.slots.filter((slot) => slot.placed);
                    },
                    visibleSlots() {
                        if (this.rescheduleEnabled && this.currentPlacements.length && !this.showRescheduleOptions) return this.currentPlacements;
                        // Move placed shifts to the top of the list
                        let unplacedShifts = this.slots.filter((shift) => !shift.placed);
                        let slots = this.currentPlacements.concat(unplacedShifts);
                        return slots.slice(0, this.visibleSlotsCount);
                    },
                    startDate() {
                        return this.parsedStartDate || moment().format('MM/DD/YYYY');
                    },
                    endDate() {
                        return this.parsedEndDate || moment().add(60, 'day').format('MM/DD/YYYY');
                    }
                },
                methods: {
                    showReschedule() {
                        this.showRescheduleOptions = true;
                    },
                    async shiftSignup(event, slot) {
                        let refPlaceResponse = await actionStore.refPlace({
                            volIds: [params.volId],
                            slotIds: [slot.ID],
                            assignmentID: params.assignmentID,
                            aeAffID: params.aeAffID,
                            doAddCheck: false,
                            newShift: slot
                        });
                        if (refPlaceResponse.status === 'success') {
                            // Add shift for response.status
                            shiftPlacements.push(refPlaceResponse.data);
                            response.status = 'success';
                            slot.placed = true;
                            if (params.autoSetScheduledAffReason && params.aeAffID) {
                                // TODO allow the reason to be configurable
                                dispatch('updateAffiliation', [{
                                    affID: params.aeAffID,
                                    AFF_REASON: params.autoSetScheduledAffReason,
                                    disableResponseMessage: true
                                }]);
                            }
                        }
                    },
                    async shiftRemoval(event, slot) {
                        let removeResponse = await actionStore.unRefPlace({ isReferral: false, volIds: [params.volId], slotIds: [slot.ID] });
                        if (removeResponse.status === 'success') {
                            slot.placed = false;
                            if (params.autoSetUnscheduledAffReason && params.aeAffID) {
                                // TODO allow the reason to be configurable
                                dispatch('updateAffiliation', [{
                                    affID: params.aeAffID,
                                    AFF_REASON: params.autoSetUnscheduledAffReason,
                                    disableResponseMessage: true
                                }]);
                            }
                        }
                    },
                    seeMoreAction() {
                        this.visibleSlotsCount += 20;
                    },
                    detailsAction(_tmp, params) {
                        library.openInNewTab(PROJECTS_URL + 'custom/' + this.recruiterID + '/opp_details/' + params.OPPORTUNITY_ID + '?slotid=' + params.ID);
                    },
                    moreAction(event, params) {
                        if (event && event.item && event.item.key) {
                            switch (event.item.key) {
                                case 'schedule':
                                    library.openInNewTab(PROJECTS_URL + 'custom/' + this.recruiterID + '/volunteer_schedule?view=calendar');
                                    break;
                                case 'dashboard':
                                    library.openInNewTab(PROJECTS_URL + 'custom/' + this.recruiterID + '/volunteer_menu');
                                    break;
                                /* case 'org':
                                    library.openInNewTab(PROJECTS_URL + 'custom/' + this.recruiterID + '/organization_details/' + params.OPPORTUNITY_ID);
                                    break; */
                            }
                        }
                    }
                },
                async mounted() {
                    let formatSlotDates = (slotRecord) => {
                        slotRecord.day = moment(slotRecord['SS_START']).format("ddd");
                        slotRecord.dayNum = moment(slotRecord['SS_START']).format("DD");
                        slotRecord.dayString = moment(slotRecord['SS_START']).format("MM/DD/YYYY");
                        slotRecord.month = moment(slotRecord['SS_START']).format("MMM");
                        slotRecord.endDay = moment(slotRecord['SS_END']).format("ddd");
                        slotRecord.endDayNum = moment(slotRecord['SS_END']).format("DD");
                        slotRecord.endDayString = moment(slotRecord['SS_END']).format("MM/DD/YYYY");
                        slotRecord.endDayMonth = moment(slotRecord['SS_END']).format("MMM");
                    };
                    let ssFields = [
                        'SS_DESC',
                        'SS_TITLE',
                        'OPP_TITLE',
                        'SS_START',
                        'SS_END',
                        'SS_DATE',
                        'SS_END_DATE',
                        'SS_START_TIME',
                        'SS_FINISH_TIME',
                        'SS_AVAIL_POSITION',
                        'SS_VOLS_NEEDED',
                        'SS_VOLS_NEEDED_MAX',
                        'SS_REPEATED',
                        'SS_REPEAT_SHOW_ONCE',
                        'SS_REPEAT_TERM',
                        'SS_PICKUP_INSTR',
                        'ORGANIZATION_ID',
                        'AE_SS_ORGANIZATION_ID',
                    ];
                    let start = this.startDate || moment().format('YYYY-MM-DD');
                    let end = this.endDate || moment().add(60, 'day').format('YYYY-MM-DD');
                    let tmpSlots = [];
                    let sdsFunction = params.shiftRecordType === 'opp'
                        ? 'er_getSlotsList'
                        : 'sds_getAeSlotsList';
                    let response;
                    if (sdsFunction === 'sds_getAeSlotsList' && this.aeSsOrgId) {
                        response = await sDs.post(sdsFunction, this.recordId, ssFields, start, end, 9999, true, false, false, false, this.aeSsOrgId);
                    } else {
                        response = await sDs.post(sdsFunction, this.recordId, ssFields, start, end, 9999, true);
                    }
                    if (response.status === 'success' && response.data) {
                        for (let i in response.data) {
                            if (i === 'length') continue;
                            tmpSlots.push(response.data[i]);
                        }
                    }
                    let existingStart = moment().subtract(1, 'days').format('YYYY-MM-DD'); // Trac
                    let placedResponse = await sDs.post('er_getPlacedSlotList', false, ssFields, end, existingStart, false, this.volId, true);
                    if (placedResponse.status === 'success' && typeof placedResponse.data === 'object') {
                        for (let schId in placedResponse.data) {
                            let shift = placedResponse.data[schId];
                            shift.placed = true;
                            shift.ID = schId;
                            formatSlotDates(shift);
                            shiftPlacements.push(shift.ID);
                            // find existing
                            let existingIdx = tmpSlots.findIndex((iShift) => iShift.ID === shift.ID);
                            if (existingIdx) tmpSlots[existingIdx] = library.mergeObj(shift, tmpSlots[existingIdx]);
                            else tmpSlots.push(shift); // if no existing append in correct position
                        }
                    }
                    for (let i in tmpSlots) {
                        formatSlotDates(tmpSlots[i]);
                    }
                    this.slots = library.cloneObj(tmpSlots);
                    this.shiftsLoaded = true;
                },
                updated() {},
                components: {
                    store,
                    control: controlComponent
                },
            };
            response.dialogResponse = await library.showDialog(schedulingModalDialogTemplate,
                () => {
                    if (shiftPlacements.length) response.status = 'success';
                    else response.status = 'failure';
                }, () => {
                    // TODO Maybe we should remove shifts?
                    response.status = 'failure';
                }, dialogOptions);
            response.action = 'openSchedulingModal';
            response.params = passedParams;
            return response;
        },
        async openProfile({ state, commit, dispatch }, payload) {
            let [passedParams] = Object.values(payload);
            let params = await actionStore.actions.checkParams(passedParams, 'openProfile');
            let recordPsp = params.recordPsp;

            let tmpTabs = await configStore.getProfileTabs(recordPsp);
            if (!tmpTabs.length) {
                return {
                    status: 'failure',
                    action: 'openProfile',
                    params: passedParams
                };
            }

            if (recordPsp !== 'ae') {
                if (typeof RECTUITER_ID === 'undefined') {
                    params.isMainGrid = true;
                    params.vueOnePageDesign = false;
                    if (recordPsp === 'source') {
                        recordPsp = passedParams.mappedRecord.uiRecordPsp;
                    }
                    let pspList = await configStore.getPSPList();
                    params.psp = 1;
                    for (let i in pspList) {
                        if (pspList[i].abbrev === recordPsp) {
                            params.psp = i;
                            break;
                        }
                    }
                    if (params.recordId > 0) {
                        params.actVal = 'edit';
                        actionStore.editEntity(params);
                    } else {
                        params.actVal = 'new';
                        params.recordId = -1;
                        actionStore.newEntity(params);
                    }
                } else {
                    // eslint-disable-next-line no-console
                    console.log('This action not working for Recruiter project'); /* @phpstan-ignore-line */
                }
            } else {
                let uniqueID = library.getUniqueID();
                let formResponse;
                let promiseResolve;
                let result = new Promise((resolve) => {
                    promiseResolve = resolve;
                });
                let profileDialogTemplate = {
                    name: "profile-open-popup_" + uniqueID,
                    template: `<profile :c-id="'profile__' + uniqueID" :prop-record-psp="recordPsp" :prop-record-id="recordId" :prop-is-from-popup="true" @update:profileSaved="profileSaved" :prop-related-records="relatedRecords"></profile>`,
                    data() {
                        return {
                            uniqueID: uniqueID,
                            recordPsp: recordPsp,
                            recordId: params.recordId,
                            relatedRecords: params.relatedRecords
                        };
                    },
                    mounted() {},
                    methods: {
                        profileSaved(response) {
                            formResponse = response;
                        }
                    },
                    updated() {},
                    components: {
                        store,
                        control: controlComponent,
                        // 'window-portal': windowPortal
                    },
                };
                let funcOnComplete = (response) => {
                    promiseResolve(formResponse);
                };
                library.showDialog(profileDialogTemplate, funcOnComplete, funcOnComplete, {
                    title: 'Profile',
                    name: 'openProfile',
                    preventCloseOnBackdropClick: true,
                    // size: 'fullscreen',
                    showCloseIcon: true,
                    closeOnEscape: false,
                    isComponentDialog: true,
                    cssClass: 'show-only-content-popup',
                    width: '1000px',
                    height: 'auto',
                    openInNewWindowFnc: params.openInNewWindowFnc
                });
                return result;
            }
            return true;
        },
        async generateQuicklink({ state }, payload) {
            // Get quicklink obj
            let quicklinkObj = await library.getQuickLink(false, true);
            // Setup Dialog
            let options = {
                title: 'Configure Quicklink',
                okButtonCssClass: 'hide'
            };
            let showQuicklinkComposer = true;
            let uniqueID = library.getUniqueID();
            let quicklinkDialogTemplate = library.createTemplateComponent("generate_quicklink_dialog_" + uniqueID, {
                template: `<div v-if="showQuicklinkComposer"><quicklink-composer :prop-quicklink-obj="quicklinkObj"></quicklink-composer></div>`,
                data() {
                    return {
                        quicklinkObj,
                        showQuicklinkComposer: true
                    };
                },
                mounted() {
                    let closeInterval = setInterval(() => {
                        if (!showQuicklinkComposer) {
                            this.showQuicklinkComposer = false;
                            clearInterval(closeInterval);
                        }
                    }, 500);
                },
                components: {
                    quicklinkComposer: defineAsyncComponent(() => import('@common/quicklinkComposer.vue'))
                },
            });
            // open dialog with configuration options
            library.showDialog(
                quicklinkDialogTemplate,
                false,
                false,
                options,
                false,
                () => {
                    showQuicklinkComposer = false;
                }
            );
        },
        async switchBetweenInstanceAndLocal({ state }, payload) {
            let instancesUrl = {
                prod: 'https://devdash.samaritan.com/DevDash/',
                qa: 'https://devdashqa.samaritan.com/DevDash/',
                local: 'http://localhost/'
            };
            let devDashInstanceDetails = await configStore.getCurrentInstanceDetails(true);
            let devDashLocalInstanceDetails = await configStore.getDevDashLocalInstanceDetails();
            let loggedUsers = await uStore().getLoggedUsers();
            let switchTo;
            let switchToGetParamsArray = {};
            if (devDashInstanceDetails.isLocalhost) {
                // switch to instance
                if (devDashInstanceDetails.isProd) {
                    switchTo = 'prod';
                } else {
                    switchTo = 'qa';
                }
            } else {
                // switch to localhost
                switchTo = 'local';
                if (devDashInstanceDetails.isProd) {
                    switchToGetParamsArray['isprod'] = 1;
                }
            }
            if (loggedUsers['user'] && devDashLocalInstanceDetails.devDashSID) {
                switchToGetParamsArray['sid'] = devDashLocalInstanceDetails.devDashSID;
            }
            if (devDashInstanceDetails.quicklink) {
                switchToGetParamsArray['quicklink'] = devDashInstanceDetails.quicklink;
            }
            let switchToGetParams = new URLSearchParams(switchToGetParamsArray).toString();
            let switchToUrl = instancesUrl[switchTo] + (switchToGetParams ? '?' + switchToGetParams : '');
            location.href = switchToUrl;
        },
        async editAffiliation({ state }, payload) {
            let [passedParams] = Object.values(payload);
            let affID = passedParams.affID;
            let response = {};
            library.showLoadingIndicator(false, 3, false, 'damien-loader');
            if (!affID) {
                response.status = 'failure';
                response.error = 'Not all params are passed to the action';
                response.action = 'editAffiliation';
                response.params = passedParams;
                return response;
            }
            let affInfo = false;
            response = await sDs.post('sds_getProfileField', 32, affID, ['AFF_STATUS', 'AFF_REASON', 'AFF_START_DATE', 'AFF_END_DATE', 'AFF_EXPIRATION_DATE', 'AFF_NOTE', 'AFF_TYPE', 'AFF_COMPLIANCE_STATUS'], { strictTypeResults: true });
            if (response.status !== 'success') {
                response.action = 'editAffiliation';
                response.params = passedParams;
                return response;
            }
            affInfo = response && response.data && response.data[affID] ? response.data[affID] : false;
            if (!affInfo) {
                response.status = 'failure';
                response.action = 'editAffiliation';
                response.params = passedParams;
            }
            let affType = affInfo['AFF_TYPE'];
            let uniqueID = library.getUniqueID();
            let vmsAffiliationManagerEditTemplate = {
                name: "vmsAffiliationManager-edit-popup_" + uniqueID,
                template: `
                    <div class="vms-affiliation-manager-edit">
                        <div class="vms-affiliation-manager-edit-status">
                            <control name="AFF_STATUS__${uniqueID}" :prop-config="controls.AFF_STATUS" :value="affInfo.AFF_STATUS" :onselect="checkExpiration" @update:value="affInfo.AFF_STATUS = $event; optionChanged()"></control>
                        </div>
                        <div class="vms-affiliation-manager-edit-reason">
                            <control name="AFF_REASON__${uniqueID}" :prop-config="controls.AFF_REASON" :value="affInfo.AFF_REASON" @update:value="affInfo.AFF_REASON = $event; optionChanged()"></control>
                        </div>
                        <div class="vms-affiliation-manager-edit-note">
                            <control name="AFF_NOTE__${uniqueID}" :prop-config="controls.AFF_NOTE" :value="affInfo.AFF_NOTE" @update:value="affInfo.AFF_NOTE = $event; optionChanged()"></control>
                        </div>
                        <div class="vms-affiliation-manager-edit-start-date">
                            <control name="AFF_START_DATE__${uniqueID}" :prop-config="controls.AFF_START_DATE" :value="affInfo.AFF_START_DATE" @update:value="affInfo.AFF_START_DATE = $event; optionChanged()"></control>
                        </div>
                        <div class="vms-affiliation-manager-edit-end-date">
                            <control name="AFF_END_DATE__${uniqueID}" :prop-config="controls.AFF_END_DATE" :value="affInfo.AFF_END_DATE" @update:value="affInfo.AFF_END_DATE = $event; optionChanged()"></control>
                        </div>
                        <div class="vms-affiliation-manager-edit-expiration-date">
                            <control name="AFF_EXPIRATION_DATE__${uniqueID}" :prop-config="controls.AFF_EXPIRATION_DATE" :value="affInfo.AFF_EXPIRATION_DATE" @update:value="affInfo.AFF_EXPIRATION_DATE = $event; checkExpiration(); optionChanged()"></control>
                        </div>
                        <div class="vms-affiliation-manager-edit-expiration-date">
                            <control name="RUN_RENEW__${uniqueID}" :prop-config="controls.RUN_RENEW" :value="affInfo.RUN_RENEW" @update:value="affInfo.RUN_RENEW = $event; optionChanged()"></control>
                        </div>
                        <div class="vms-affiliation-manager-edit-compliance-status">
                            <control name="AFF_COMPLIANCE_STATUS__${uniqueID}" :prop-config="controls.AFF_COMPLIANCE_STATUS" :value="affInfo.AFF_COMPLIANCE_STATUS" :onselect="checkExpiration" @update:value="affInfo.AFF_COMPLIANCE_STATUS = $event; optionChanged()"></control>
                        </div>
                    </div>
                `,
                data() {
                    return {
                        affInfo: affInfo,
                        affID: affID,
                        controls: {
                            'AFF_START_DATE': {
                                label: 'Start Date',
                                type: 'date',
                                display: 'asField',
                                min: new Date(2000, 0, 1)
                            },
                            'AFF_END_DATE': {
                                label: 'End Date',
                                type: 'date',
                                display: 'asField',
                                min: new Date(2000, 0, 1)
                            },
                            'AFF_EXPIRATION_DATE': {
                                label: 'Expiration Date',
                                type: 'date',
                                display: 'asField',
                                min: new Date(2000, 0, 1)
                            },
                            'AFF_STATUS': {
                                label: 'Status',
                                type: 'dropdown',
                                itemsSource: 'configStore.attrListOptions("aff_status_' + affType + '")',
                                fields: { text: 'text', value: 'value' },
                                display: 'asField',
                            },
                            'AFF_REASON': {
                                label: 'Reason',
                                type: 'dropdown',
                                itemsSource: 'configStore.attrListOptions("aff_reason_' + affType + '")',
                                fields: { text: 'text', value: 'value' },
                            },
                            'AFF_COMPLIANCE_STATUS': {
                                label: 'Compliance Status',
                                type: 'dropdown',
                                itemsSource: 'configStore.attrListOptions("aff_compliance_status")',
                                fields: { text: 'text', value: 'value' },
                                display: 'asField',
                            },
                            'AFF_NOTE': {
                                label: 'Note',
                                type: 'string',
                                display: 'asField',
                            },
                            'RUN_RENEW': {
                                label: 'Run Affiliation Renew On Expiration',
                                type: 'boolean',
                                default: false
                            },
                        },
                    };
                },
                mounted() {},
                methods: {
                    checkExpiration(event) {
                        if (this.affInfo.AFF_EXPIRATION_DATE && this.affInfo.AFF_STATUS) {
                            let tmpExpirationDate = library.getMoment(this.affInfo.AFF_EXPIRATION_DATE);
                            let tmpTodayDate = library.getMoment().startOf('day');
                            if (tmpTodayDate.isAfter(tmpExpirationDate)) {
                                if (event) {
                                    event.cancel = true;
                                } else {
                                    this.affInfo.AFF_STATUS = null;
                                    this.$nextTick(() => {
                                        this.affInfo.AFF_STATUS = 9;
                                    });
                                }
                            }
                        }
                    },
                    optionChanged() {
                        affInfo = this.affInfo;
                    },
                },
                updated() {},
                components: {
                    control: defineAsyncComponent(() => import('@common/control/control.vue')),
                },
            };
            let funcOnSuccess = async () => {
                if (affInfo.AFF_START_DATE && affInfo.AFF_END_DATE) {
                    let tmpStartDate = library.getMoment(affInfo.AFF_START_DATE);
                    let tmpEndDate = library.getMoment(affInfo.AFF_END_DATE);
                    if (tmpStartDate.isAfter(tmpEndDate)) {
                        library.showDialog('End date must be greater than start date', false, false, { title: 'Error', showAsAlert: true });
                        return false;
                    }
                }
                // Set AFF Status ID fields
                affInfo.AFF_STATUS_ID = affInfo.AFF_STATUS;
                affInfo.AFF_REASON_ID = affInfo.AFF_REASON;
                let affStatusList = await configStore.attrListOptions("aff_status_" + affType);
                let affReasonList = await configStore.attrListOptions("aff_reason_" + affType);
                let selectedStatus = affStatusList.find((tmpEl) => parseInt(tmpEl.value, 10) === parseInt(affInfo.AFF_STATUS, 10));
                if (selectedStatus) {
                    affInfo.AFF_STATUS = selectedStatus.text;
                }
                let selectedReason = affReasonList.find((tmpEl) => parseInt(tmpEl.value, 10) === parseInt(affInfo.AFF_REASON, 10));
                if (selectedReason) {
                    affInfo.AFF_REASON = selectedReason.text;
                }
                let runAffiliationRenewOnExpiration = typeof affInfo.RUN_RENEW !== 'undefined' ? affInfo.RUN_RENEW : (passedParams.runAffiliationRenewOnExpiration || false);
                delete affInfo.AFF_TYPE;
                delete affInfo.RUN_RENEW;
                let runAutomations = true;
                let updateResponse = await sDs.post('sds_updateAffiliation', affID, affInfo, runAutomations, runAffiliationRenewOnExpiration);
                if (updateResponse.status === 'success') {
                    library.mergeObj(recordStore().records.aff[affID], affInfo);
                    recordStore().setModified({ aff: [affID] });
                }
                return true;
            };
            let funcOnFailure = () => {};
            let opt = {
                title: 'Edit Affiliation',
                name: 'editAffiliationTemplateDialog',
                preventCloseOnBackdropClick: false,
                doNotCloseOnOK: false,
                showCloseIcon: true,
                closeOnEscape: true,
                doNotCloseOnFuncFailure: true
            };
            library.hideLoadingIndicator();
            return library.showDialog(vmsAffiliationManagerEditTemplate, funcOnSuccess, funcOnFailure, opt);
        }
    },
};

store.registerModule("actionStore", actionStore);
export { actionStore, recordSourceControl, createRecordSourceControl };
